import { getCurrentScope as fl, onScopeDispose as pl, unref as h, getCurrentInstance as me, onMounted as ie, nextTick as we, watch as V, ref as E, defineComponent as M, openBlock as F, createElementBlock as P, createElementVNode as B, warn as vl, inject as W, computed as w, isRef as hl, shallowRef as ns, onBeforeUnmount as ke, onBeforeMount as gl, provide as ye, mergeProps as Pt, renderSlot as N, toRef as Re, onUnmounted as ml, createBlock as j, Transition as oo, withCtx as R, withDirectives as et, normalizeClass as $, normalizeStyle as ze, vShow as rn, Fragment as ot, createVNode as U, reactive as $t, onActivated as yl, onUpdated as bl, resolveDynamicComponent as tt, createCommentVNode as G, cloneVNode as wl, Text as os, Comment as xl, Teleport as Fl, readonly as Cl, onDeactivated as Sl, toDisplayString as ge, useSlots as Ol, withModifiers as ve, toHandlers as Tl, withKeys as Kt, createTextVNode as It, toRaw as sr, toRefs as ir, watchEffect as El, resolveComponent as qe, resolveDirective as kl, toHandlerKey as _l, renderList as Zt, vModelText as $l, markRaw as Ye } from "vue";
import Et from "plotly.js/lib/core";
import Il from "plotly.js/lib/scatter";
import Al from "plotly.js/lib/bar";
import Pl from "plotly.js/lib/heatmap";
import Ll from "papaparse";
function Ml(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rs = { exports: {} }, ne = rs.exports = {}, Pe, Le;
function zo() {
  throw new Error("setTimeout has not been defined");
}
function Do() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Pe = setTimeout : Pe = zo;
  } catch {
    Pe = zo;
  }
  try {
    typeof clearTimeout == "function" ? Le = clearTimeout : Le = Do;
  } catch {
    Le = Do;
  }
})();
function as(e) {
  if (Pe === setTimeout)
    return setTimeout(e, 0);
  if ((Pe === zo || !Pe) && setTimeout)
    return Pe = setTimeout, setTimeout(e, 0);
  try {
    return Pe(e, 0);
  } catch {
    try {
      return Pe.call(null, e, 0);
    } catch {
      return Pe.call(this, e, 0);
    }
  }
}
function Rl(e) {
  if (Le === clearTimeout)
    return clearTimeout(e);
  if ((Le === Do || !Le) && clearTimeout)
    return Le = clearTimeout, clearTimeout(e);
  try {
    return Le(e);
  } catch {
    try {
      return Le.call(null, e);
    } catch {
      return Le.call(this, e);
    }
  }
}
var Xe = [], qt = !1, Ot, Zn = -1;
function Nl() {
  !qt || !Ot || (qt = !1, Ot.length ? Xe = Ot.concat(Xe) : Zn = -1, Xe.length && ss());
}
function ss() {
  if (!qt) {
    var e = as(Nl);
    qt = !0;
    for (var t = Xe.length; t; ) {
      for (Ot = Xe, Xe = []; ++Zn < t; )
        Ot && Ot[Zn].run();
      Zn = -1, t = Xe.length;
    }
    Ot = null, qt = !1, Rl(e);
  }
}
ne.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  Xe.push(new is(e, t)), Xe.length === 1 && !qt && as(ss);
};
function is(e, t) {
  this.fun = e, this.array = t;
}
is.prototype.run = function() {
  this.fun.apply(null, this.array);
};
ne.title = "browser";
ne.browser = !0;
ne.env = {};
ne.argv = [];
ne.version = "";
ne.versions = {};
function at() {
}
ne.on = at;
ne.addListener = at;
ne.once = at;
ne.off = at;
ne.removeListener = at;
ne.removeAllListeners = at;
ne.emit = at;
ne.prependListener = at;
ne.prependOnceListener = at;
ne.listeners = function(e) {
  return [];
};
ne.binding = function(e) {
  throw new Error("process.binding is not supported");
};
ne.cwd = function() {
  return "/";
};
ne.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
ne.umask = function() {
  return 0;
};
var Bl = rs.exports;
const Lt = /* @__PURE__ */ Ml(Bl), Ze = (e, t, { checkForDefaultPrevented: n = !0 } = {}) => (r) => {
  const a = e == null ? void 0 : e(r);
  if (n === !1 || !a)
    return t == null ? void 0 : t(r);
}, Wt = globalThis || void 0 || self;
var jr;
const se = typeof window < "u", zl = (e) => typeof e == "string", ls = () => {
}, Ho = se && ((jr = window == null ? void 0 : window.navigator) == null ? void 0 : jr.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function us(e) {
  return typeof e == "function" ? e() : h(e);
}
function Dl(e) {
  return e;
}
function ro(e) {
  return fl() ? (pl(e), !0) : !1;
}
function Hl(e, t = !0) {
  me() ? ie(e) : t ? e() : we(e);
}
function Qe(e) {
  var t;
  const n = us(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const ao = se ? window : void 0;
function Te(...e) {
  let t, n, o, r;
  if (zl(e[0]) || Array.isArray(e[0]) ? ([n, o, r] = e, t = ao) : [t, n, o, r] = e, !t)
    return ls;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const a = [], s = () => {
    a.forEach((d) => d()), a.length = 0;
  }, i = (d, c, v, g) => (d.addEventListener(c, v, g), () => d.removeEventListener(c, v, g)), u = V(() => [Qe(t), us(r)], ([d, c]) => {
    s(), d && a.push(...n.flatMap((v) => o.map((g) => i(d, v, g, c))));
  }, { immediate: !0, flush: "post" }), l = () => {
    u(), s();
  };
  return ro(l), l;
}
let Ur = !1;
function Vl(e, t, n = {}) {
  const { window: o = ao, ignore: r = [], capture: a = !0, detectIframe: s = !1 } = n;
  if (!o)
    return;
  Ho && !Ur && (Ur = !0, Array.from(o.document.body.children).forEach((v) => v.addEventListener("click", ls)));
  let i = !0;
  const u = (v) => r.some((g) => {
    if (typeof g == "string")
      return Array.from(o.document.querySelectorAll(g)).some((f) => f === v.target || v.composedPath().includes(f));
    {
      const f = Qe(g);
      return f && (v.target === f || v.composedPath().includes(f));
    }
  }), d = [
    Te(o, "click", (v) => {
      const g = Qe(e);
      if (!(!g || g === v.target || v.composedPath().includes(g))) {
        if (v.detail === 0 && (i = !u(v)), !i) {
          i = !0;
          return;
        }
        t(v);
      }
    }, { passive: !0, capture: a }),
    Te(o, "pointerdown", (v) => {
      const g = Qe(e);
      g && (i = !v.composedPath().includes(g) && !u(v));
    }, { passive: !0 }),
    s && Te(o, "blur", (v) => {
      var g;
      const f = Qe(e);
      ((g = o.document.activeElement) == null ? void 0 : g.tagName) === "IFRAME" && !(f != null && f.contains(o.document.activeElement)) && t(v);
    })
  ].filter(Boolean);
  return () => d.forEach((v) => v());
}
function cs(e, t = !1) {
  const n = E(), o = () => n.value = !!e();
  return o(), Hl(o, t), n;
}
const Vo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof Wt < "u" ? Wt : typeof self < "u" ? self : {}, jo = "__vueuse_ssr_handlers__";
Vo[jo] = Vo[jo] || {};
Vo[jo];
var Kr = Object.getOwnPropertySymbols, jl = Object.prototype.hasOwnProperty, Ul = Object.prototype.propertyIsEnumerable, Kl = (e, t) => {
  var n = {};
  for (var o in e)
    jl.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Kr)
    for (var o of Kr(e))
      t.indexOf(o) < 0 && Ul.call(e, o) && (n[o] = e[o]);
  return n;
};
function pt(e, t, n = {}) {
  const o = n, { window: r = ao } = o, a = Kl(o, ["window"]);
  let s;
  const i = cs(() => r && "ResizeObserver" in r), u = () => {
    s && (s.disconnect(), s = void 0);
  }, l = V(() => Qe(e), (c) => {
    u(), i.value && r && c && (s = new ResizeObserver(t), s.observe(c, a));
  }, { immediate: !0, flush: "post" }), d = () => {
    u(), l();
  };
  return ro(d), {
    isSupported: i,
    stop: d
  };
}
var Gr = Object.getOwnPropertySymbols, Gl = Object.prototype.hasOwnProperty, Wl = Object.prototype.propertyIsEnumerable, ql = (e, t) => {
  var n = {};
  for (var o in e)
    Gl.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Gr)
    for (var o of Gr(e))
      t.indexOf(o) < 0 && Wl.call(e, o) && (n[o] = e[o]);
  return n;
};
function Zl(e, t, n = {}) {
  const o = n, { window: r = ao } = o, a = ql(o, ["window"]);
  let s;
  const i = cs(() => r && "MutationObserver" in r), u = () => {
    s && (s.disconnect(), s = void 0);
  }, l = V(() => Qe(e), (c) => {
    u(), i.value && r && c && (s = new MutationObserver(t), s.observe(c, a));
  }, { immediate: !0 }), d = () => {
    u(), l();
  };
  return ro(d), {
    isSupported: i,
    stop: d
  };
}
var Wr;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(Wr || (Wr = {}));
var Yl = Object.defineProperty, qr = Object.getOwnPropertySymbols, Jl = Object.prototype.hasOwnProperty, Xl = Object.prototype.propertyIsEnumerable, Zr = (e, t, n) => t in e ? Yl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ql = (e, t) => {
  for (var n in t || (t = {}))
    Jl.call(t, n) && Zr(e, n, t[n]);
  if (qr)
    for (var n of qr(t))
      Xl.call(t, n) && Zr(e, n, t[n]);
  return e;
};
const eu = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Ql({
  linear: Dl
}, eu);
Lt.env.NODE_ENV !== "production" && Object.freeze({});
Lt.env.NODE_ENV !== "production" && Object.freeze([]);
const Jn = () => {
}, tu = Object.prototype.hasOwnProperty, Yr = (e, t) => tu.call(e, t), Ne = Array.isArray, ue = (e) => typeof e == "function", an = (e) => typeof e == "string", Be = (e) => e !== null && typeof e == "object", nu = Object.prototype.toString, ou = (e) => nu.call(e), To = (e) => ou(e).slice(8, -1);
var ds = typeof Wt == "object" && Wt && Wt.Object === Object && Wt, ru = typeof self == "object" && self && self.Object === Object && self, Ue = ds || ru || Function("return this")(), He = Ue.Symbol, fs = Object.prototype, au = fs.hasOwnProperty, su = fs.toString, yn = He ? He.toStringTag : void 0;
function iu(e) {
  var t = au.call(e, yn), n = e[yn];
  try {
    e[yn] = void 0;
    var o = !0;
  } catch {
  }
  var r = su.call(e);
  return o && (t ? e[yn] = n : delete e[yn]), r;
}
var lu = Object.prototype, uu = lu.toString;
function cu(e) {
  return uu.call(e);
}
var du = "[object Null]", fu = "[object Undefined]", Jr = He ? He.toStringTag : void 0;
function sn(e) {
  return e == null ? e === void 0 ? fu : du : Jr && Jr in Object(e) ? iu(e) : cu(e);
}
function Yt(e) {
  return e != null && typeof e == "object";
}
var pu = "[object Symbol]";
function so(e) {
  return typeof e == "symbol" || Yt(e) && sn(e) == pu;
}
function vu(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, r = Array(o); ++n < o; )
    r[n] = t(e[n], n, e);
  return r;
}
var Ee = Array.isArray, hu = 1 / 0, Xr = He ? He.prototype : void 0, Qr = Xr ? Xr.toString : void 0;
function ps(e) {
  if (typeof e == "string")
    return e;
  if (Ee(e))
    return vu(e, ps) + "";
  if (so(e))
    return Qr ? Qr.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -hu ? "-0" : t;
}
var gu = /\s/;
function mu(e) {
  for (var t = e.length; t-- && gu.test(e.charAt(t)); )
    ;
  return t;
}
var yu = /^\s+/;
function bu(e) {
  return e && e.slice(0, mu(e) + 1).replace(yu, "");
}
function mt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ea = NaN, wu = /^[-+]0x[0-9a-f]+$/i, xu = /^0b[01]+$/i, Fu = /^0o[0-7]+$/i, Cu = parseInt;
function ta(e) {
  if (typeof e == "number")
    return e;
  if (so(e))
    return ea;
  if (mt(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = mt(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = bu(e);
  var n = xu.test(e);
  return n || Fu.test(e) ? Cu(e.slice(2), n ? 2 : 8) : wu.test(e) ? ea : +e;
}
function vs(e) {
  return e;
}
var Su = "[object AsyncFunction]", Ou = "[object Function]", Tu = "[object GeneratorFunction]", Eu = "[object Proxy]";
function hs(e) {
  if (!mt(e))
    return !1;
  var t = sn(e);
  return t == Ou || t == Tu || t == Su || t == Eu;
}
var Eo = Ue["__core-js_shared__"], na = function() {
  var e = /[^.]+$/.exec(Eo && Eo.keys && Eo.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ku(e) {
  return !!na && na in e;
}
var _u = Function.prototype, $u = _u.toString;
function Mt(e) {
  if (e != null) {
    try {
      return $u.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Iu = /[\\^$.*+?()[\]{}|]/g, Au = /^\[object .+?Constructor\]$/, Pu = Function.prototype, Lu = Object.prototype, Mu = Pu.toString, Ru = Lu.hasOwnProperty, Nu = RegExp(
  "^" + Mu.call(Ru).replace(Iu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Bu(e) {
  if (!mt(e) || ku(e))
    return !1;
  var t = hs(e) ? Nu : Au;
  return t.test(Mt(e));
}
function zu(e, t) {
  return e == null ? void 0 : e[t];
}
function Rt(e, t) {
  var n = zu(e, t);
  return Bu(n) ? n : void 0;
}
var Uo = Rt(Ue, "WeakMap");
function Du(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Hu = 800, Vu = 16, ju = Date.now;
function Uu(e) {
  var t = 0, n = 0;
  return function() {
    var o = ju(), r = Vu - (o - n);
    if (n = o, r > 0) {
      if (++t >= Hu)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Ku(e) {
  return function() {
    return e;
  };
}
var Xn = function() {
  try {
    var e = Rt(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Gu = Xn ? function(e, t) {
  return Xn(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ku(t),
    writable: !0
  });
} : vs, Wu = Uu(Gu);
function qu(e, t, n, o) {
  e.length;
  for (var r = n + 1; r--; )
    if (t(e[r], r, e))
      return r;
  return -1;
}
var Zu = 9007199254740991, Yu = /^(?:0|[1-9]\d*)$/;
function lr(e, t) {
  var n = typeof e;
  return t = t ?? Zu, !!t && (n == "number" || n != "symbol" && Yu.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Ju(e, t, n) {
  t == "__proto__" && Xn ? Xn(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function ur(e, t) {
  return e === t || e !== e && t !== t;
}
var Xu = Object.prototype, Qu = Xu.hasOwnProperty;
function ec(e, t, n) {
  var o = e[t];
  (!(Qu.call(e, t) && ur(o, n)) || n === void 0 && !(t in e)) && Ju(e, t, n);
}
var oa = Math.max;
function tc(e, t, n) {
  return t = oa(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, r = -1, a = oa(o.length - t, 0), s = Array(a); ++r < a; )
      s[r] = o[t + r];
    r = -1;
    for (var i = Array(t + 1); ++r < t; )
      i[r] = o[r];
    return i[t] = n(s), Du(e, this, i);
  };
}
var nc = 9007199254740991;
function cr(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= nc;
}
function oc(e) {
  return e != null && cr(e.length) && !hs(e);
}
var rc = Object.prototype;
function ac(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || rc;
  return e === n;
}
function sc(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var ic = "[object Arguments]";
function ra(e) {
  return Yt(e) && sn(e) == ic;
}
var gs = Object.prototype, lc = gs.hasOwnProperty, uc = gs.propertyIsEnumerable, dr = ra(/* @__PURE__ */ function() {
  return arguments;
}()) ? ra : function(e) {
  return Yt(e) && lc.call(e, "callee") && !uc.call(e, "callee");
};
function cc() {
  return !1;
}
var ms = typeof exports == "object" && exports && !exports.nodeType && exports, aa = ms && typeof module == "object" && module && !module.nodeType && module, dc = aa && aa.exports === ms, sa = dc ? Ue.Buffer : void 0, fc = sa ? sa.isBuffer : void 0, Ko = fc || cc, pc = "[object Arguments]", vc = "[object Array]", hc = "[object Boolean]", gc = "[object Date]", mc = "[object Error]", yc = "[object Function]", bc = "[object Map]", wc = "[object Number]", xc = "[object Object]", Fc = "[object RegExp]", Cc = "[object Set]", Sc = "[object String]", Oc = "[object WeakMap]", Tc = "[object ArrayBuffer]", Ec = "[object DataView]", kc = "[object Float32Array]", _c = "[object Float64Array]", $c = "[object Int8Array]", Ic = "[object Int16Array]", Ac = "[object Int32Array]", Pc = "[object Uint8Array]", Lc = "[object Uint8ClampedArray]", Mc = "[object Uint16Array]", Rc = "[object Uint32Array]", Q = {};
Q[kc] = Q[_c] = Q[$c] = Q[Ic] = Q[Ac] = Q[Pc] = Q[Lc] = Q[Mc] = Q[Rc] = !0;
Q[pc] = Q[vc] = Q[Tc] = Q[hc] = Q[Ec] = Q[gc] = Q[mc] = Q[yc] = Q[bc] = Q[wc] = Q[xc] = Q[Fc] = Q[Cc] = Q[Sc] = Q[Oc] = !1;
function Nc(e) {
  return Yt(e) && cr(e.length) && !!Q[sn(e)];
}
function Bc(e) {
  return function(t) {
    return e(t);
  };
}
var ys = typeof exports == "object" && exports && !exports.nodeType && exports, xn = ys && typeof module == "object" && module && !module.nodeType && module, zc = xn && xn.exports === ys, ko = zc && ds.process, ia = function() {
  try {
    var e = xn && xn.require && xn.require("util").types;
    return e || ko && ko.binding && ko.binding("util");
  } catch {
  }
}(), la = ia && ia.isTypedArray, bs = la ? Bc(la) : Nc, Dc = Object.prototype, Hc = Dc.hasOwnProperty;
function Vc(e, t) {
  var n = Ee(e), o = !n && dr(e), r = !n && !o && Ko(e), a = !n && !o && !r && bs(e), s = n || o || r || a, i = s ? sc(e.length, String) : [], u = i.length;
  for (var l in e)
    Hc.call(e, l) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    lr(l, u))) && i.push(l);
  return i;
}
function jc(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Uc = jc(Object.keys, Object), Kc = Object.prototype, Gc = Kc.hasOwnProperty;
function Wc(e) {
  if (!ac(e))
    return Uc(e);
  var t = [];
  for (var n in Object(e))
    Gc.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function ws(e) {
  return oc(e) ? Vc(e) : Wc(e);
}
var qc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Zc = /^\w*$/;
function fr(e, t) {
  if (Ee(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || so(e) ? !0 : Zc.test(e) || !qc.test(e) || t != null && e in Object(t);
}
var Sn = Rt(Object, "create");
function Yc() {
  this.__data__ = Sn ? Sn(null) : {}, this.size = 0;
}
function Jc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Xc = "__lodash_hash_undefined__", Qc = Object.prototype, ed = Qc.hasOwnProperty;
function td(e) {
  var t = this.__data__;
  if (Sn) {
    var n = t[e];
    return n === Xc ? void 0 : n;
  }
  return ed.call(t, e) ? t[e] : void 0;
}
var nd = Object.prototype, od = nd.hasOwnProperty;
function rd(e) {
  var t = this.__data__;
  return Sn ? t[e] !== void 0 : od.call(t, e);
}
var ad = "__lodash_hash_undefined__";
function sd(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Sn && t === void 0 ? ad : t, this;
}
function At(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
At.prototype.clear = Yc;
At.prototype.delete = Jc;
At.prototype.get = td;
At.prototype.has = rd;
At.prototype.set = sd;
function id() {
  this.__data__ = [], this.size = 0;
}
function io(e, t) {
  for (var n = e.length; n--; )
    if (ur(e[n][0], t))
      return n;
  return -1;
}
var ld = Array.prototype, ud = ld.splice;
function cd(e) {
  var t = this.__data__, n = io(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : ud.call(t, n, 1), --this.size, !0;
}
function dd(e) {
  var t = this.__data__, n = io(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function fd(e) {
  return io(this.__data__, e) > -1;
}
function pd(e, t) {
  var n = this.__data__, o = io(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
function st(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
st.prototype.clear = id;
st.prototype.delete = cd;
st.prototype.get = dd;
st.prototype.has = fd;
st.prototype.set = pd;
var On = Rt(Ue, "Map");
function vd() {
  this.size = 0, this.__data__ = {
    hash: new At(),
    map: new (On || st)(),
    string: new At()
  };
}
function hd(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function lo(e, t) {
  var n = e.__data__;
  return hd(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function gd(e) {
  var t = lo(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function md(e) {
  return lo(this, e).get(e);
}
function yd(e) {
  return lo(this, e).has(e);
}
function bd(e, t) {
  var n = lo(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
function it(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
it.prototype.clear = vd;
it.prototype.delete = gd;
it.prototype.get = md;
it.prototype.has = yd;
it.prototype.set = bd;
var wd = "Expected a function";
function pr(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(wd);
  var n = function() {
    var o = arguments, r = t ? t.apply(this, o) : o[0], a = n.cache;
    if (a.has(r))
      return a.get(r);
    var s = e.apply(this, o);
    return n.cache = a.set(r, s) || a, s;
  };
  return n.cache = new (pr.Cache || it)(), n;
}
pr.Cache = it;
var xd = 500;
function Fd(e) {
  var t = pr(e, function(o) {
    return n.size === xd && n.clear(), o;
  }), n = t.cache;
  return t;
}
var Cd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Sd = /\\(\\)?/g, Od = Fd(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Cd, function(n, o, r, a) {
    t.push(r ? a.replace(Sd, "$1") : o || n);
  }), t;
});
function Td(e) {
  return e == null ? "" : ps(e);
}
function uo(e, t) {
  return Ee(e) ? e : fr(e, t) ? [e] : Od(Td(e));
}
var Ed = 1 / 0;
function $n(e) {
  if (typeof e == "string" || so(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Ed ? "-0" : t;
}
function vr(e, t) {
  t = uo(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[$n(t[n++])];
  return n && n == o ? e : void 0;
}
function Je(e, t, n) {
  var o = e == null ? void 0 : vr(e, t);
  return o === void 0 ? n : o;
}
function xs(e, t) {
  for (var n = -1, o = t.length, r = e.length; ++n < o; )
    e[r + n] = t[n];
  return e;
}
var ua = He ? He.isConcatSpreadable : void 0;
function kd(e) {
  return Ee(e) || dr(e) || !!(ua && e && e[ua]);
}
function _d(e, t, n, o, r) {
  var a = -1, s = e.length;
  for (n || (n = kd), r || (r = []); ++a < s; ) {
    var i = e[a];
    n(i) ? xs(r, i) : r[r.length] = i;
  }
  return r;
}
function $d(e) {
  var t = e == null ? 0 : e.length;
  return t ? _d(e) : [];
}
function Id(e) {
  return Wu(tc(e, void 0, $d), e + "");
}
function Me() {
  if (!arguments.length)
    return [];
  var e = arguments[0];
  return Ee(e) ? e : [e];
}
function Ad() {
  this.__data__ = new st(), this.size = 0;
}
function Pd(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function Ld(e) {
  return this.__data__.get(e);
}
function Md(e) {
  return this.__data__.has(e);
}
var Rd = 200;
function Nd(e, t) {
  var n = this.__data__;
  if (n instanceof st) {
    var o = n.__data__;
    if (!On || o.length < Rd - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new it(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
function nt(e) {
  var t = this.__data__ = new st(e);
  this.size = t.size;
}
nt.prototype.clear = Ad;
nt.prototype.delete = Pd;
nt.prototype.get = Ld;
nt.prototype.has = Md;
nt.prototype.set = Nd;
function Bd(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, r = 0, a = []; ++n < o; ) {
    var s = e[n];
    t(s, n, e) && (a[r++] = s);
  }
  return a;
}
function zd() {
  return [];
}
var Dd = Object.prototype, Hd = Dd.propertyIsEnumerable, ca = Object.getOwnPropertySymbols, Vd = ca ? function(e) {
  return e == null ? [] : (e = Object(e), Bd(ca(e), function(t) {
    return Hd.call(e, t);
  }));
} : zd;
function jd(e, t, n) {
  var o = t(e);
  return Ee(e) ? o : xs(o, n(e));
}
function da(e) {
  return jd(e, ws, Vd);
}
var Go = Rt(Ue, "DataView"), Wo = Rt(Ue, "Promise"), qo = Rt(Ue, "Set"), fa = "[object Map]", Ud = "[object Object]", pa = "[object Promise]", va = "[object Set]", ha = "[object WeakMap]", ga = "[object DataView]", Kd = Mt(Go), Gd = Mt(On), Wd = Mt(Wo), qd = Mt(qo), Zd = Mt(Uo), vt = sn;
(Go && vt(new Go(new ArrayBuffer(1))) != ga || On && vt(new On()) != fa || Wo && vt(Wo.resolve()) != pa || qo && vt(new qo()) != va || Uo && vt(new Uo()) != ha) && (vt = function(e) {
  var t = sn(e), n = t == Ud ? e.constructor : void 0, o = n ? Mt(n) : "";
  if (o)
    switch (o) {
      case Kd:
        return ga;
      case Gd:
        return fa;
      case Wd:
        return pa;
      case qd:
        return va;
      case Zd:
        return ha;
    }
  return t;
});
var ma = Ue.Uint8Array, Yd = "__lodash_hash_undefined__";
function Jd(e) {
  return this.__data__.set(e, Yd), this;
}
function Xd(e) {
  return this.__data__.has(e);
}
function Qn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new it(); ++t < n; )
    this.add(e[t]);
}
Qn.prototype.add = Qn.prototype.push = Jd;
Qn.prototype.has = Xd;
function Qd(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function ef(e, t) {
  return e.has(t);
}
var tf = 1, nf = 2;
function Fs(e, t, n, o, r, a) {
  var s = n & tf, i = e.length, u = t.length;
  if (i != u && !(s && u > i))
    return !1;
  var l = a.get(e), d = a.get(t);
  if (l && d)
    return l == t && d == e;
  var c = -1, v = !0, g = n & nf ? new Qn() : void 0;
  for (a.set(e, t), a.set(t, e); ++c < i; ) {
    var f = e[c], p = t[c];
    if (o)
      var m = s ? o(p, f, c, t, e, a) : o(f, p, c, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      v = !1;
      break;
    }
    if (g) {
      if (!Qd(t, function(y, C) {
        if (!ef(g, C) && (f === y || r(f, y, n, o, a)))
          return g.push(C);
      })) {
        v = !1;
        break;
      }
    } else if (!(f === p || r(f, p, n, o, a))) {
      v = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), v;
}
function of(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o, r) {
    n[++t] = [r, o];
  }), n;
}
function rf(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var af = 1, sf = 2, lf = "[object Boolean]", uf = "[object Date]", cf = "[object Error]", df = "[object Map]", ff = "[object Number]", pf = "[object RegExp]", vf = "[object Set]", hf = "[object String]", gf = "[object Symbol]", mf = "[object ArrayBuffer]", yf = "[object DataView]", ya = He ? He.prototype : void 0, _o = ya ? ya.valueOf : void 0;
function bf(e, t, n, o, r, a, s) {
  switch (n) {
    case yf:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case mf:
      return !(e.byteLength != t.byteLength || !a(new ma(e), new ma(t)));
    case lf:
    case uf:
    case ff:
      return ur(+e, +t);
    case cf:
      return e.name == t.name && e.message == t.message;
    case pf:
    case hf:
      return e == t + "";
    case df:
      var i = of;
    case vf:
      var u = o & af;
      if (i || (i = rf), e.size != t.size && !u)
        return !1;
      var l = s.get(e);
      if (l)
        return l == t;
      o |= sf, s.set(e, t);
      var d = Fs(i(e), i(t), o, r, a, s);
      return s.delete(e), d;
    case gf:
      if (_o)
        return _o.call(e) == _o.call(t);
  }
  return !1;
}
var wf = 1, xf = Object.prototype, Ff = xf.hasOwnProperty;
function Cf(e, t, n, o, r, a) {
  var s = n & wf, i = da(e), u = i.length, l = da(t), d = l.length;
  if (u != d && !s)
    return !1;
  for (var c = u; c--; ) {
    var v = i[c];
    if (!(s ? v in t : Ff.call(t, v)))
      return !1;
  }
  var g = a.get(e), f = a.get(t);
  if (g && f)
    return g == t && f == e;
  var p = !0;
  a.set(e, t), a.set(t, e);
  for (var m = s; ++c < u; ) {
    v = i[c];
    var y = e[v], C = t[v];
    if (o)
      var I = s ? o(C, y, v, t, e, a) : o(y, C, v, e, t, a);
    if (!(I === void 0 ? y === C || r(y, C, n, o, a) : I)) {
      p = !1;
      break;
    }
    m || (m = v == "constructor");
  }
  if (p && !m) {
    var S = e.constructor, x = t.constructor;
    S != x && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof x == "function" && x instanceof x) && (p = !1);
  }
  return a.delete(e), a.delete(t), p;
}
var Sf = 1, ba = "[object Arguments]", wa = "[object Array]", Vn = "[object Object]", Of = Object.prototype, xa = Of.hasOwnProperty;
function Tf(e, t, n, o, r, a) {
  var s = Ee(e), i = Ee(t), u = s ? wa : vt(e), l = i ? wa : vt(t);
  u = u == ba ? Vn : u, l = l == ba ? Vn : l;
  var d = u == Vn, c = l == Vn, v = u == l;
  if (v && Ko(e)) {
    if (!Ko(t))
      return !1;
    s = !0, d = !1;
  }
  if (v && !d)
    return a || (a = new nt()), s || bs(e) ? Fs(e, t, n, o, r, a) : bf(e, t, u, n, o, r, a);
  if (!(n & Sf)) {
    var g = d && xa.call(e, "__wrapped__"), f = c && xa.call(t, "__wrapped__");
    if (g || f) {
      var p = g ? e.value() : e, m = f ? t.value() : t;
      return a || (a = new nt()), r(p, m, n, o, a);
    }
  }
  return v ? (a || (a = new nt()), Cf(e, t, n, o, r, a)) : !1;
}
function co(e, t, n, o, r) {
  return e === t ? !0 : e == null || t == null || !Yt(e) && !Yt(t) ? e !== e && t !== t : Tf(e, t, n, o, co, r);
}
var Ef = 1, kf = 2;
function _f(e, t, n, o) {
  var r = n.length, a = r;
  if (e == null)
    return !a;
  for (e = Object(e); r--; ) {
    var s = n[r];
    if (s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++r < a; ) {
    s = n[r];
    var i = s[0], u = e[i], l = s[1];
    if (s[2]) {
      if (u === void 0 && !(i in e))
        return !1;
    } else {
      var d = new nt(), c;
      if (!(c === void 0 ? co(l, u, Ef | kf, o, d) : c))
        return !1;
    }
  }
  return !0;
}
function Cs(e) {
  return e === e && !mt(e);
}
function $f(e) {
  for (var t = ws(e), n = t.length; n--; ) {
    var o = t[n], r = e[o];
    t[n] = [o, r, Cs(r)];
  }
  return t;
}
function Ss(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function If(e) {
  var t = $f(e);
  return t.length == 1 && t[0][2] ? Ss(t[0][0], t[0][1]) : function(n) {
    return n === e || _f(n, e, t);
  };
}
function Af(e, t) {
  return e != null && t in Object(e);
}
function Pf(e, t, n) {
  t = uo(t, e);
  for (var o = -1, r = t.length, a = !1; ++o < r; ) {
    var s = $n(t[o]);
    if (!(a = e != null && n(e, s)))
      break;
    e = e[s];
  }
  return a || ++o != r ? a : (r = e == null ? 0 : e.length, !!r && cr(r) && lr(s, r) && (Ee(e) || dr(e)));
}
function Os(e, t) {
  return e != null && Pf(e, t, Af);
}
var Lf = 1, Mf = 2;
function Rf(e, t) {
  return fr(e) && Cs(t) ? Ss($n(e), t) : function(n) {
    var o = Je(n, e);
    return o === void 0 && o === t ? Os(n, e) : co(t, o, Lf | Mf);
  };
}
function Nf(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Bf(e) {
  return function(t) {
    return vr(t, e);
  };
}
function zf(e) {
  return fr(e) ? Nf($n(e)) : Bf(e);
}
function Df(e) {
  return typeof e == "function" ? e : e == null ? vs : typeof e == "object" ? Ee(e) ? Rf(e[0], e[1]) : If(e) : zf(e);
}
var $o = function() {
  return Ue.Date.now();
}, Hf = "Expected a function", Vf = Math.max, jf = Math.min;
function Uf(e, t, n) {
  var o, r, a, s, i, u, l = 0, d = !1, c = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(Hf);
  t = ta(t) || 0, mt(n) && (d = !!n.leading, c = "maxWait" in n, a = c ? Vf(ta(n.maxWait) || 0, t) : a, v = "trailing" in n ? !!n.trailing : v);
  function g(O) {
    var k = o, A = r;
    return o = r = void 0, l = O, s = e.apply(A, k), s;
  }
  function f(O) {
    return l = O, i = setTimeout(y, t), d ? g(O) : s;
  }
  function p(O) {
    var k = O - u, A = O - l, L = t - k;
    return c ? jf(L, a - A) : L;
  }
  function m(O) {
    var k = O - u, A = O - l;
    return u === void 0 || k >= t || k < 0 || c && A >= a;
  }
  function y() {
    var O = $o();
    if (m(O))
      return C(O);
    i = setTimeout(y, p(O));
  }
  function C(O) {
    return i = void 0, v && o ? g(O) : (o = r = void 0, s);
  }
  function I() {
    i !== void 0 && clearTimeout(i), l = 0, o = u = r = i = void 0;
  }
  function S() {
    return i === void 0 ? s : C($o());
  }
  function x() {
    var O = $o(), k = m(O);
    if (o = arguments, r = this, u = O, k) {
      if (i === void 0)
        return f(u);
      if (c)
        return clearTimeout(i), i = setTimeout(y, t), g(u);
    }
    return i === void 0 && (i = setTimeout(y, t)), s;
  }
  return x.cancel = I, x.flush = S, x;
}
function Kf(e, t, n) {
  var o = e == null ? 0 : e.length;
  if (!o)
    return -1;
  var r = o - 1;
  return qu(e, Df(t), r);
}
function Zo(e) {
  for (var t = -1, n = e == null ? 0 : e.length, o = {}; ++t < n; ) {
    var r = e[t];
    o[r[0]] = r[1];
  }
  return o;
}
function Yo(e, t) {
  return co(e, t);
}
function hr(e) {
  return e == null;
}
function Gf(e) {
  return e === void 0;
}
function Wf(e, t, n, o) {
  if (!mt(e))
    return e;
  t = uo(t, e);
  for (var r = -1, a = t.length, s = a - 1, i = e; i != null && ++r < a; ) {
    var u = $n(t[r]), l = n;
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return e;
    if (r != s) {
      var d = i[u];
      l = void 0, l === void 0 && (l = mt(d) ? d : lr(t[r + 1]) ? [] : {});
    }
    ec(i, u, l), i = i[u];
  }
  return e;
}
function qf(e, t, n) {
  for (var o = -1, r = t.length, a = {}; ++o < r; ) {
    var s = t[o], i = vr(e, s);
    n(i, s) && Wf(a, uo(s, e), i);
  }
  return a;
}
function Zf(e, t) {
  return qf(e, t, function(n, o) {
    return Os(e, o);
  });
}
var Yf = Id(function(e, t) {
  return e == null ? {} : Zf(e, t);
});
const wn = (e) => e === void 0, gr = (e) => typeof e == "boolean", xe = (e) => typeof e == "number", kt = (e) => typeof Element > "u" ? !1 : e instanceof Element, Jf = (e) => an(e) ? !Number.isNaN(Number(e)) : !1, Xf = (e = "") => e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
class Ts extends Error {
  constructor(t) {
    super(t), this.name = "ElementPlusError";
  }
}
function Qf(e, t) {
  throw new Ts(`[${e}] ${t}`);
}
function Ve(e, t) {
  if (Lt.env.NODE_ENV !== "production") {
    const n = an(e) ? new Ts(`[${e}] ${t}`) : e;
    console.warn(n);
  }
}
const ep = "utils/dom/style";
function eo(e, t = "px") {
  if (!e)
    return "";
  if (xe(e) || Jf(e))
    return `${e}${t}`;
  if (an(e))
    return e;
  Ve(ep, "binding value must be a string or number");
}
function tp(e, t) {
  if (!se)
    return;
  if (!t) {
    e.scrollTop = 0;
    return;
  }
  const n = [];
  let o = t.offsetParent;
  for (; o !== null && e !== o && e.contains(o); )
    n.push(o), o = o.offsetParent;
  const r = t.offsetTop + n.reduce((u, l) => u + l.offsetTop, 0), a = r + t.offsetHeight, s = e.scrollTop, i = s + e.clientHeight;
  r < s ? e.scrollTop = r : a > i && (e.scrollTop = a - e.clientHeight);
}
/*! Element Plus Icons Vue v2.3.1 */
var np = /* @__PURE__ */ M({
  name: "ArrowDown",
  __name: "arrow-down",
  setup(e) {
    return (t, n) => (F(), P("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      B("path", {
        fill: "currentColor",
        d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
      })
    ]));
  }
}), op = np, rp = /* @__PURE__ */ M({
  name: "ArrowRight",
  __name: "arrow-right",
  setup(e) {
    return (t, n) => (F(), P("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      B("path", {
        fill: "currentColor",
        d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
      })
    ]));
  }
}), ap = rp, sp = /* @__PURE__ */ M({
  name: "CircleCheck",
  __name: "circle-check",
  setup(e) {
    return (t, n) => (F(), P("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      B("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      B("path", {
        fill: "currentColor",
        d: "M745.344 361.344a32 32 0 0 1 45.312 45.312l-288 288a32 32 0 0 1-45.312 0l-160-160a32 32 0 1 1 45.312-45.312L480 626.752l265.344-265.408z"
      })
    ]));
  }
}), ip = sp, lp = /* @__PURE__ */ M({
  name: "CircleClose",
  __name: "circle-close",
  setup(e) {
    return (t, n) => (F(), P("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      B("path", {
        fill: "currentColor",
        d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"
      }),
      B("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
}), Es = lp, up = /* @__PURE__ */ M({
  name: "Close",
  __name: "close",
  setup(e) {
    return (t, n) => (F(), P("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      B("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ]));
  }
}), Fa = up, cp = /* @__PURE__ */ M({
  name: "Loading",
  __name: "loading",
  setup(e) {
    return (t, n) => (F(), P("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      B("path", {
        fill: "currentColor",
        d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
      })
    ]));
  }
}), ks = cp;
const _s = "__epPropKey", z = (e) => e, dp = (e) => Be(e) && !!e[_s], fo = (e, t) => {
  if (!Be(e) || dp(e))
    return e;
  const { values: n, required: o, default: r, type: a, validator: s } = e, u = {
    type: a,
    required: !!o,
    validator: n || s ? (l) => {
      let d = !1, c = [];
      if (n && (c = Array.from(n), Yr(e, "default") && c.push(r), d || (d = c.includes(l))), s && (d || (d = s(l))), !d && c.length > 0) {
        const v = [...new Set(c)].map((g) => JSON.stringify(g)).join(", ");
        vl(`Invalid prop: validation failed${t ? ` for prop "${t}"` : ""}. Expected one of [${v}], got value ${JSON.stringify(l)}.`);
      }
      return d;
    } : void 0,
    [_s]: !0
  };
  return Yr(e, "default") && (u.default = r), u;
}, ee = (e) => Zo(Object.entries(e).map(([t, n]) => [
  t,
  fo(n, t)
])), Jt = z([
  String,
  Object,
  Function
]), fp = {
  validating: ks,
  success: ip,
  error: Es
}, _e = (e, t) => {
  if (e.install = (n) => {
    for (const o of [e, ...Object.values(t ?? {})])
      n.component(o.name, o);
  }, t)
    for (const [n, o] of Object.entries(t))
      e[n] = o;
  return e;
}, pp = (e, t) => (e.install = (n) => {
  n.directive(t, e);
}, e), po = (e) => (e.install = Jn, e), Tn = {
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  left: "ArrowLeft",
  up: "ArrowUp",
  right: "ArrowRight",
  down: "ArrowDown",
  esc: "Escape",
  delete: "Delete",
  backspace: "Backspace",
  numpadEnter: "NumpadEnter",
  pageUp: "PageUp",
  pageDown: "PageDown",
  home: "Home",
  end: "End"
}, ht = "update:modelValue", vo = "change", $s = ["", "default", "small", "large"], vp = (e) => /([\uAC00-\uD7AF\u3130-\u318F])+/gi.test(e), hp = (e) => e, gp = ({ from: e, replacement: t, scope: n, version: o, ref: r, type: a = "API" }, s) => {
  V(() => h(s), (i) => {
    i && Ve(n, `[${a}] ${e} is about to be deprecated in version ${o}, please use ${t} instead.
For more detail, please visit: ${r}
`);
  }, {
    immediate: !0
  });
};
var mp = {
  name: "en",
  el: {
    breadcrumb: {
      label: "Breadcrumb"
    },
    colorpicker: {
      confirm: "OK",
      clear: "Clear",
      defaultLabel: "color picker",
      description: "current color is {color}. press enter to select a new color.",
      alphaLabel: "pick alpha value"
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
      monthTablePrompt: "Use the arrow keys and enter to select the month",
      yearTablePrompt: "Use the arrow keys and enter to select the year",
      selectedDate: "Selected date",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      weeksFull: {
        sun: "Sunday",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    inputNumber: {
      decrease: "decrease number",
      increase: "increase number"
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    mention: {
      loading: "Loading"
    },
    dropdown: {
      toggleDropdown: "Toggle Dropdown"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: "",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages",
      deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
    },
    dialog: {
      close: "Close this dialog"
    },
    drawer: {
      close: "Close this dialog"
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input",
      close: "Close this dialog"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    slider: {
      defaultLabel: "slider between {min} and {max}",
      defaultRangeStartLabel: "pick start value",
      defaultRangeEndLabel: "pick end value"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tour: {
      next: "Next",
      previous: "Previous",
      finish: "Finish"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    },
    carousel: {
      leftArrow: "Carousel arrow left",
      rightArrow: "Carousel arrow right",
      indicator: "Carousel switch to index {index}"
    }
  }
};
const yp = (e) => (t, n) => bp(t, n, h(e)), bp = (e, t, n) => Je(n, e, e).replace(/\{(\w+)\}/g, (o, r) => {
  var a;
  return `${(a = t == null ? void 0 : t[r]) != null ? a : `{${r}}`}`;
}), wp = (e) => {
  const t = w(() => h(e).name), n = hl(e) ? e : E(e);
  return {
    lang: t,
    locale: n,
    t: yp(e)
  };
}, xp = Symbol("localeContextKey"), Fp = (e) => {
  const t = W(xp, E());
  return wp(w(() => t.value || mp));
}, Io = "el", Cp = "is-", St = (e, t, n, o, r) => {
  let a = `${e}-${t}`;
  return n && (a += `-${n}`), o && (a += `__${o}`), r && (a += `--${r}`), a;
}, Sp = Symbol("namespaceContextKey"), mr = (e) => {
  const t = me() ? W(Sp, E(Io)) : E(Io);
  return w(() => h(t) || Io);
}, te = (e, t) => {
  const n = mr();
  return {
    namespace: n,
    b: (p = "") => St(n.value, e, p, "", ""),
    e: (p) => p ? St(n.value, e, "", p, "") : "",
    m: (p) => p ? St(n.value, e, "", "", p) : "",
    be: (p, m) => p && m ? St(n.value, e, p, m, "") : "",
    em: (p, m) => p && m ? St(n.value, e, "", p, m) : "",
    bm: (p, m) => p && m ? St(n.value, e, p, "", m) : "",
    bem: (p, m, y) => p && m && y ? St(n.value, e, p, m, y) : "",
    is: (p, ...m) => {
      const y = m.length >= 1 ? m[0] : !0;
      return p && y ? `${Cp}${p}` : "";
    },
    cssVar: (p) => {
      const m = {};
      for (const y in p)
        p[y] && (m[`--${n.value}-${y}`] = p[y]);
      return m;
    },
    cssVarName: (p) => `--${n.value}-${p}`,
    cssVarBlock: (p) => {
      const m = {};
      for (const y in p)
        p[y] && (m[`--${n.value}-${e}-${y}`] = p[y]);
      return m;
    },
    cssVarBlockName: (p) => `--${n.value}-${e}-${p}`
  };
}, Op = fo({
  type: z(Boolean),
  default: null
}), Tp = fo({
  type: z(Function)
}), Ep = (e) => {
  const t = `update:${e}`, n = `onUpdate:${e}`, o = [t], r = {
    [e]: Op,
    [n]: Tp
  };
  return {
    useModelToggle: ({
      indicator: s,
      toggleReason: i,
      shouldHideWhenRouteChanges: u,
      shouldProceed: l,
      onShow: d,
      onHide: c
    }) => {
      const v = me(), { emit: g } = v, f = v.props, p = w(() => ue(f[n])), m = w(() => f[e] === null), y = (k) => {
        s.value !== !0 && (s.value = !0, i && (i.value = k), ue(d) && d(k));
      }, C = (k) => {
        s.value !== !1 && (s.value = !1, i && (i.value = k), ue(c) && c(k));
      }, I = (k) => {
        if (f.disabled === !0 || ue(l) && !l())
          return;
        const A = p.value && se;
        A && g(t, !0), (m.value || !A) && y(k);
      }, S = (k) => {
        if (f.disabled === !0 || !se)
          return;
        const A = p.value && se;
        A && g(t, !1), (m.value || !A) && C(k);
      }, x = (k) => {
        gr(k) && (f.disabled && k ? p.value && g(t, !1) : s.value !== k && (k ? y() : C()));
      }, O = () => {
        s.value ? S() : I();
      };
      return V(() => f[e], x), u && v.appContext.config.globalProperties.$route !== void 0 && V(() => ({
        ...v.proxy.$route
      }), () => {
        u.value && s.value && S();
      }), ie(() => {
        x(f[e]);
      }), {
        hide: S,
        show: I,
        toggle: O,
        hasUpdateHandler: p
      };
    },
    useModelToggleProps: r,
    useModelToggleEmits: o
  };
}, Is = (e) => {
  const t = me();
  return w(() => {
    var n, o;
    return (o = (n = t == null ? void 0 : t.proxy) == null ? void 0 : n.$props) == null ? void 0 : o[e];
  });
};
var ce = "top", Ce = "bottom", Se = "right", de = "left", yr = "auto", In = [ce, Ce, Se, de], Xt = "start", En = "end", kp = "clippingParents", As = "viewport", bn = "popper", _p = "reference", Ca = In.reduce(function(e, t) {
  return e.concat([t + "-" + Xt, t + "-" + En]);
}, []), ho = [].concat(In, [yr]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Xt, t + "-" + En]);
}, []), $p = "beforeRead", Ip = "read", Ap = "afterRead", Pp = "beforeMain", Lp = "main", Mp = "afterMain", Rp = "beforeWrite", Np = "write", Bp = "afterWrite", zp = [$p, Ip, Ap, Pp, Lp, Mp, Rp, Np, Bp];
function je(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function $e(e) {
  if (e == null) return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Qt(e) {
  var t = $e(e).Element;
  return e instanceof t || e instanceof Element;
}
function Fe(e) {
  var t = $e(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function br(e) {
  if (typeof ShadowRoot > "u") return !1;
  var t = $e(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Dp(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, r = t.attributes[n] || {}, a = t.elements[n];
    !Fe(a) || !je(a) || (Object.assign(a.style, o), Object.keys(r).forEach(function(s) {
      var i = r[s];
      i === !1 ? a.removeAttribute(s) : a.setAttribute(s, i === !0 ? "" : i);
    }));
  });
}
function Hp(e) {
  var t = e.state, n = { popper: { position: t.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var r = t.elements[o], a = t.attributes[o] || {}, s = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), i = s.reduce(function(u, l) {
        return u[l] = "", u;
      }, {});
      !Fe(r) || !je(r) || (Object.assign(r.style, i), Object.keys(a).forEach(function(u) {
        r.removeAttribute(u);
      }));
    });
  };
}
var Ps = { name: "applyStyles", enabled: !0, phase: "write", fn: Dp, effect: Hp, requires: ["computeStyles"] };
function De(e) {
  return e.split("-")[0];
}
var _t = Math.max, to = Math.min, en = Math.round;
function tn(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), o = 1, r = 1;
  if (Fe(e) && t) {
    var a = e.offsetHeight, s = e.offsetWidth;
    s > 0 && (o = en(n.width) / s || 1), a > 0 && (r = en(n.height) / a || 1);
  }
  return { width: n.width / o, height: n.height / r, top: n.top / r, right: n.right / o, bottom: n.bottom / r, left: n.left / o, x: n.left / o, y: n.top / r };
}
function wr(e) {
  var t = tn(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), { x: e.offsetLeft, y: e.offsetTop, width: n, height: o };
}
function Ls(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t)) return !0;
  if (n && br(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o)) return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function rt(e) {
  return $e(e).getComputedStyle(e);
}
function Vp(e) {
  return ["table", "td", "th"].indexOf(je(e)) >= 0;
}
function yt(e) {
  return ((Qt(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function go(e) {
  return je(e) === "html" ? e : e.assignedSlot || e.parentNode || (br(e) ? e.host : null) || yt(e);
}
function Sa(e) {
  return !Fe(e) || rt(e).position === "fixed" ? null : e.offsetParent;
}
function jp(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && Fe(e)) {
    var o = rt(e);
    if (o.position === "fixed") return null;
  }
  var r = go(e);
  for (br(r) && (r = r.host); Fe(r) && ["html", "body"].indexOf(je(r)) < 0; ) {
    var a = rt(r);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none") return r;
    r = r.parentNode;
  }
  return null;
}
function An(e) {
  for (var t = $e(e), n = Sa(e); n && Vp(n) && rt(n).position === "static"; ) n = Sa(n);
  return n && (je(n) === "html" || je(n) === "body" && rt(n).position === "static") ? t : n || jp(e) || t;
}
function xr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Fn(e, t, n) {
  return _t(e, to(t, n));
}
function Up(e, t, n) {
  var o = Fn(e, t, n);
  return o > n ? n : o;
}
function Ms() {
  return { top: 0, right: 0, bottom: 0, left: 0 };
}
function Rs(e) {
  return Object.assign({}, Ms(), e);
}
function Ns(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var Kp = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, { placement: t.placement })) : e, Rs(typeof e != "number" ? e : Ns(e, In));
};
function Gp(e) {
  var t, n = e.state, o = e.name, r = e.options, a = n.elements.arrow, s = n.modifiersData.popperOffsets, i = De(n.placement), u = xr(i), l = [de, Se].indexOf(i) >= 0, d = l ? "height" : "width";
  if (!(!a || !s)) {
    var c = Kp(r.padding, n), v = wr(a), g = u === "y" ? ce : de, f = u === "y" ? Ce : Se, p = n.rects.reference[d] + n.rects.reference[u] - s[u] - n.rects.popper[d], m = s[u] - n.rects.reference[u], y = An(a), C = y ? u === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, I = p / 2 - m / 2, S = c[g], x = C - v[d] - c[f], O = C / 2 - v[d] / 2 + I, k = Fn(S, O, x), A = u;
    n.modifiersData[o] = (t = {}, t[A] = k, t.centerOffset = k - O, t);
  }
}
function Wp(e) {
  var t = e.state, n = e.options, o = n.element, r = o === void 0 ? "[data-popper-arrow]" : o;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || !Ls(t.elements.popper, r) || (t.elements.arrow = r));
}
var qp = { name: "arrow", enabled: !0, phase: "main", fn: Gp, effect: Wp, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
function nn(e) {
  return e.split("-")[1];
}
var Zp = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
function Yp(e) {
  var t = e.x, n = e.y, o = window, r = o.devicePixelRatio || 1;
  return { x: en(t * r) / r || 0, y: en(n * r) / r || 0 };
}
function Oa(e) {
  var t, n = e.popper, o = e.popperRect, r = e.placement, a = e.variation, s = e.offsets, i = e.position, u = e.gpuAcceleration, l = e.adaptive, d = e.roundOffsets, c = e.isFixed, v = s.x, g = v === void 0 ? 0 : v, f = s.y, p = f === void 0 ? 0 : f, m = typeof d == "function" ? d({ x: g, y: p }) : { x: g, y: p };
  g = m.x, p = m.y;
  var y = s.hasOwnProperty("x"), C = s.hasOwnProperty("y"), I = de, S = ce, x = window;
  if (l) {
    var O = An(n), k = "clientHeight", A = "clientWidth";
    if (O === $e(n) && (O = yt(n), rt(O).position !== "static" && i === "absolute" && (k = "scrollHeight", A = "scrollWidth")), O = O, r === ce || (r === de || r === Se) && a === En) {
      S = Ce;
      var L = c && O === x && x.visualViewport ? x.visualViewport.height : O[k];
      p -= L - o.height, p *= u ? 1 : -1;
    }
    if (r === de || (r === ce || r === Ce) && a === En) {
      I = Se;
      var H = c && O === x && x.visualViewport ? x.visualViewport.width : O[A];
      g -= H - o.width, g *= u ? 1 : -1;
    }
  }
  var Z = Object.assign({ position: i }, l && Zp), K = d === !0 ? Yp({ x: g, y: p }) : { x: g, y: p };
  if (g = K.x, p = K.y, u) {
    var X;
    return Object.assign({}, Z, (X = {}, X[S] = C ? "0" : "", X[I] = y ? "0" : "", X.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + p + "px)" : "translate3d(" + g + "px, " + p + "px, 0)", X));
  }
  return Object.assign({}, Z, (t = {}, t[S] = C ? p + "px" : "", t[I] = y ? g + "px" : "", t.transform = "", t));
}
function Jp(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, r = o === void 0 ? !0 : o, a = n.adaptive, s = a === void 0 ? !0 : a, i = n.roundOffsets, u = i === void 0 ? !0 : i, l = { placement: De(t.placement), variation: nn(t.placement), popper: t.elements.popper, popperRect: t.rects.popper, gpuAcceleration: r, isFixed: t.options.strategy === "fixed" };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Oa(Object.assign({}, l, { offsets: t.modifiersData.popperOffsets, position: t.options.strategy, adaptive: s, roundOffsets: u })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Oa(Object.assign({}, l, { offsets: t.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: u })))), t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement });
}
var Bs = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: Jp, data: {} }, jn = { passive: !0 };
function Xp(e) {
  var t = e.state, n = e.instance, o = e.options, r = o.scroll, a = r === void 0 ? !0 : r, s = o.resize, i = s === void 0 ? !0 : s, u = $e(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && l.forEach(function(d) {
    d.addEventListener("scroll", n.update, jn);
  }), i && u.addEventListener("resize", n.update, jn), function() {
    a && l.forEach(function(d) {
      d.removeEventListener("scroll", n.update, jn);
    }), i && u.removeEventListener("resize", n.update, jn);
  };
}
var zs = { name: "eventListeners", enabled: !0, phase: "write", fn: function() {
}, effect: Xp, data: {} }, Qp = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Yn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Qp[t];
  });
}
var e0 = { start: "end", end: "start" };
function Ta(e) {
  return e.replace(/start|end/g, function(t) {
    return e0[t];
  });
}
function Fr(e) {
  var t = $e(e), n = t.pageXOffset, o = t.pageYOffset;
  return { scrollLeft: n, scrollTop: o };
}
function Cr(e) {
  return tn(yt(e)).left + Fr(e).scrollLeft;
}
function t0(e) {
  var t = $e(e), n = yt(e), o = t.visualViewport, r = n.clientWidth, a = n.clientHeight, s = 0, i = 0;
  return o && (r = o.width, a = o.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (s = o.offsetLeft, i = o.offsetTop)), { width: r, height: a, x: s + Cr(e), y: i };
}
function n0(e) {
  var t, n = yt(e), o = Fr(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, a = _t(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = _t(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), i = -o.scrollLeft + Cr(e), u = -o.scrollTop;
  return rt(r || n).direction === "rtl" && (i += _t(n.clientWidth, r ? r.clientWidth : 0) - a), { width: a, height: s, x: i, y: u };
}
function Sr(e) {
  var t = rt(e), n = t.overflow, o = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + o);
}
function Ds(e) {
  return ["html", "body", "#document"].indexOf(je(e)) >= 0 ? e.ownerDocument.body : Fe(e) && Sr(e) ? e : Ds(go(e));
}
function Cn(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = Ds(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = $e(o), s = r ? [a].concat(a.visualViewport || [], Sr(o) ? o : []) : o, i = t.concat(s);
  return r ? i : i.concat(Cn(go(s)));
}
function Jo(e) {
  return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height });
}
function o0(e) {
  var t = tn(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Ea(e, t) {
  return t === As ? Jo(t0(e)) : Qt(t) ? o0(t) : Jo(n0(yt(e)));
}
function r0(e) {
  var t = Cn(go(e)), n = ["absolute", "fixed"].indexOf(rt(e).position) >= 0, o = n && Fe(e) ? An(e) : e;
  return Qt(o) ? t.filter(function(r) {
    return Qt(r) && Ls(r, o) && je(r) !== "body";
  }) : [];
}
function a0(e, t, n) {
  var o = t === "clippingParents" ? r0(e) : [].concat(t), r = [].concat(o, [n]), a = r[0], s = r.reduce(function(i, u) {
    var l = Ea(e, u);
    return i.top = _t(l.top, i.top), i.right = to(l.right, i.right), i.bottom = to(l.bottom, i.bottom), i.left = _t(l.left, i.left), i;
  }, Ea(e, a));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Hs(e) {
  var t = e.reference, n = e.element, o = e.placement, r = o ? De(o) : null, a = o ? nn(o) : null, s = t.x + t.width / 2 - n.width / 2, i = t.y + t.height / 2 - n.height / 2, u;
  switch (r) {
    case ce:
      u = { x: s, y: t.y - n.height };
      break;
    case Ce:
      u = { x: s, y: t.y + t.height };
      break;
    case Se:
      u = { x: t.x + t.width, y: i };
      break;
    case de:
      u = { x: t.x - n.width, y: i };
      break;
    default:
      u = { x: t.x, y: t.y };
  }
  var l = r ? xr(r) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (a) {
      case Xt:
        u[l] = u[l] - (t[d] / 2 - n[d] / 2);
        break;
      case En:
        u[l] = u[l] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return u;
}
function kn(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = o === void 0 ? e.placement : o, a = n.boundary, s = a === void 0 ? kp : a, i = n.rootBoundary, u = i === void 0 ? As : i, l = n.elementContext, d = l === void 0 ? bn : l, c = n.altBoundary, v = c === void 0 ? !1 : c, g = n.padding, f = g === void 0 ? 0 : g, p = Rs(typeof f != "number" ? f : Ns(f, In)), m = d === bn ? _p : bn, y = e.rects.popper, C = e.elements[v ? m : d], I = a0(Qt(C) ? C : C.contextElement || yt(e.elements.popper), s, u), S = tn(e.elements.reference), x = Hs({ reference: S, element: y, strategy: "absolute", placement: r }), O = Jo(Object.assign({}, y, x)), k = d === bn ? O : S, A = { top: I.top - k.top + p.top, bottom: k.bottom - I.bottom + p.bottom, left: I.left - k.left + p.left, right: k.right - I.right + p.right }, L = e.modifiersData.offset;
  if (d === bn && L) {
    var H = L[r];
    Object.keys(A).forEach(function(Z) {
      var K = [Se, Ce].indexOf(Z) >= 0 ? 1 : -1, X = [ce, Ce].indexOf(Z) >= 0 ? "y" : "x";
      A[Z] += H[X] * K;
    });
  }
  return A;
}
function s0(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = n.boundary, a = n.rootBoundary, s = n.padding, i = n.flipVariations, u = n.allowedAutoPlacements, l = u === void 0 ? ho : u, d = nn(o), c = d ? i ? Ca : Ca.filter(function(f) {
    return nn(f) === d;
  }) : In, v = c.filter(function(f) {
    return l.indexOf(f) >= 0;
  });
  v.length === 0 && (v = c);
  var g = v.reduce(function(f, p) {
    return f[p] = kn(e, { placement: p, boundary: r, rootBoundary: a, padding: s })[De(p)], f;
  }, {});
  return Object.keys(g).sort(function(f, p) {
    return g[f] - g[p];
  });
}
function i0(e) {
  if (De(e) === yr) return [];
  var t = Yn(e);
  return [Ta(e), t, Ta(t)];
}
function l0(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var r = n.mainAxis, a = r === void 0 ? !0 : r, s = n.altAxis, i = s === void 0 ? !0 : s, u = n.fallbackPlacements, l = n.padding, d = n.boundary, c = n.rootBoundary, v = n.altBoundary, g = n.flipVariations, f = g === void 0 ? !0 : g, p = n.allowedAutoPlacements, m = t.options.placement, y = De(m), C = y === m, I = u || (C || !f ? [Yn(m)] : i0(m)), S = [m].concat(I).reduce(function(Ie, le) {
      return Ie.concat(De(le) === yr ? s0(t, { placement: le, boundary: d, rootBoundary: c, padding: l, flipVariations: f, allowedAutoPlacements: p }) : le);
    }, []), x = t.rects.reference, O = t.rects.popper, k = /* @__PURE__ */ new Map(), A = !0, L = S[0], H = 0; H < S.length; H++) {
      var Z = S[H], K = De(Z), X = nn(Z) === Xt, be = [ce, Ce].indexOf(K) >= 0, re = be ? "width" : "height", _ = kn(t, { placement: Z, boundary: d, rootBoundary: c, altBoundary: v, padding: l }), q = be ? X ? Se : de : X ? Ce : ce;
      x[re] > O[re] && (q = Yn(q));
      var Ke = Yn(q), fe = [];
      if (a && fe.push(_[K] <= 0), i && fe.push(_[q] <= 0, _[Ke] <= 0), fe.every(function(Ie) {
        return Ie;
      })) {
        L = Z, A = !1;
        break;
      }
      k.set(Z, fe);
    }
    if (A) for (var Nt = f ? 3 : 1, Bt = function(Ie) {
      var le = S.find(function(oe) {
        var wt = k.get(oe);
        if (wt) return wt.slice(0, Ie).every(function(lt) {
          return lt;
        });
      });
      if (le) return L = le, "break";
    }, bt = Nt; bt > 0; bt--) {
      var zt = Bt(bt);
      if (zt === "break") break;
    }
    t.placement !== L && (t.modifiersData[o]._skip = !0, t.placement = L, t.reset = !0);
  }
}
var u0 = { name: "flip", enabled: !0, phase: "main", fn: l0, requiresIfExists: ["offset"], data: { _skip: !1 } };
function ka(e, t, n) {
  return n === void 0 && (n = { x: 0, y: 0 }), { top: e.top - t.height - n.y, right: e.right - t.width + n.x, bottom: e.bottom - t.height + n.y, left: e.left - t.width - n.x };
}
function _a(e) {
  return [ce, Se, Ce, de].some(function(t) {
    return e[t] >= 0;
  });
}
function c0(e) {
  var t = e.state, n = e.name, o = t.rects.reference, r = t.rects.popper, a = t.modifiersData.preventOverflow, s = kn(t, { elementContext: "reference" }), i = kn(t, { altBoundary: !0 }), u = ka(s, o), l = ka(i, r, a), d = _a(u), c = _a(l);
  t.modifiersData[n] = { referenceClippingOffsets: u, popperEscapeOffsets: l, isReferenceHidden: d, hasPopperEscaped: c }, t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-reference-hidden": d, "data-popper-escaped": c });
}
var d0 = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: c0 };
function f0(e, t, n) {
  var o = De(e), r = [de, ce].indexOf(o) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, { placement: e })) : n, s = a[0], i = a[1];
  return s = s || 0, i = (i || 0) * r, [de, Se].indexOf(o) >= 0 ? { x: i, y: s } : { x: s, y: i };
}
function p0(e) {
  var t = e.state, n = e.options, o = e.name, r = n.offset, a = r === void 0 ? [0, 0] : r, s = ho.reduce(function(d, c) {
    return d[c] = f0(c, t.rects, a), d;
  }, {}), i = s[t.placement], u = i.x, l = i.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += l), t.modifiersData[o] = s;
}
var v0 = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: p0 };
function h0(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Hs({ reference: t.rects.reference, element: t.rects.popper, strategy: "absolute", placement: t.placement });
}
var Vs = { name: "popperOffsets", enabled: !0, phase: "read", fn: h0, data: {} };
function g0(e) {
  return e === "x" ? "y" : "x";
}
function m0(e) {
  var t = e.state, n = e.options, o = e.name, r = n.mainAxis, a = r === void 0 ? !0 : r, s = n.altAxis, i = s === void 0 ? !1 : s, u = n.boundary, l = n.rootBoundary, d = n.altBoundary, c = n.padding, v = n.tether, g = v === void 0 ? !0 : v, f = n.tetherOffset, p = f === void 0 ? 0 : f, m = kn(t, { boundary: u, rootBoundary: l, padding: c, altBoundary: d }), y = De(t.placement), C = nn(t.placement), I = !C, S = xr(y), x = g0(S), O = t.modifiersData.popperOffsets, k = t.rects.reference, A = t.rects.popper, L = typeof p == "function" ? p(Object.assign({}, t.rects, { placement: t.placement })) : p, H = typeof L == "number" ? { mainAxis: L, altAxis: L } : Object.assign({ mainAxis: 0, altAxis: 0 }, L), Z = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, K = { x: 0, y: 0 };
  if (O) {
    if (a) {
      var X, be = S === "y" ? ce : de, re = S === "y" ? Ce : Se, _ = S === "y" ? "height" : "width", q = O[S], Ke = q + m[be], fe = q - m[re], Nt = g ? -A[_] / 2 : 0, Bt = C === Xt ? k[_] : A[_], bt = C === Xt ? -A[_] : -k[_], zt = t.elements.arrow, Ie = g && zt ? wr(zt) : { width: 0, height: 0 }, le = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ms(), oe = le[be], wt = le[re], lt = Fn(0, k[_], Ie[_]), Ln = I ? k[_] / 2 - Nt - lt - oe - H.mainAxis : Bt - lt - oe - H.mainAxis, Mn = I ? -k[_] / 2 + Nt + lt + wt + H.mainAxis : bt + lt + wt + H.mainAxis, cn = t.elements.arrow && An(t.elements.arrow), Fo = cn ? S === "y" ? cn.clientTop || 0 : cn.clientLeft || 0 : 0, Rn = (X = Z == null ? void 0 : Z[S]) != null ? X : 0, Co = q + Ln - Rn - Fo, So = q + Mn - Rn, xt = Fn(g ? to(Ke, Co) : Ke, q, g ? _t(fe, So) : fe);
      O[S] = xt, K[S] = xt - q;
    }
    if (i) {
      var dn, Dt = S === "x" ? ce : de, Nn = S === "x" ? Ce : Se, Ge = O[x], Ht = x === "y" ? "height" : "width", fn = Ge + m[Dt], Bn = Ge - m[Nn], Ft = [ce, de].indexOf(y) !== -1, pn = (dn = Z == null ? void 0 : Z[x]) != null ? dn : 0, vn = Ft ? fn : Ge - k[Ht] - A[Ht] - pn + H.altAxis, hn = Ft ? Ge + k[Ht] + A[Ht] - pn - H.altAxis : Bn, gn = g && Ft ? Up(vn, Ge, hn) : Fn(g ? vn : fn, Ge, g ? hn : Bn);
      O[x] = gn, K[x] = gn - Ge;
    }
    t.modifiersData[o] = K;
  }
}
var y0 = { name: "preventOverflow", enabled: !0, phase: "main", fn: m0, requiresIfExists: ["offset"] };
function b0(e) {
  return { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
}
function w0(e) {
  return e === $e(e) || !Fe(e) ? Fr(e) : b0(e);
}
function x0(e) {
  var t = e.getBoundingClientRect(), n = en(t.width) / e.offsetWidth || 1, o = en(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function F0(e, t, n) {
  n === void 0 && (n = !1);
  var o = Fe(t), r = Fe(t) && x0(t), a = yt(t), s = tn(e, r), i = { scrollLeft: 0, scrollTop: 0 }, u = { x: 0, y: 0 };
  return (o || !o && !n) && ((je(t) !== "body" || Sr(a)) && (i = w0(t)), Fe(t) ? (u = tn(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : a && (u.x = Cr(a))), { x: s.left + i.scrollLeft - u.x, y: s.top + i.scrollTop - u.y, width: s.width, height: s.height };
}
function C0(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function r(a) {
    n.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(i) {
      if (!n.has(i)) {
        var u = t.get(i);
        u && r(u);
      }
    }), o.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || r(a);
  }), o;
}
function S0(e) {
  var t = C0(e);
  return zp.reduce(function(n, o) {
    return n.concat(t.filter(function(r) {
      return r.phase === o;
    }));
  }, []);
}
function O0(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function T0(e) {
  var t = e.reduce(function(n, o) {
    var r = n[o.name];
    return n[o.name] = r ? Object.assign({}, r, o, { options: Object.assign({}, r.options, o.options), data: Object.assign({}, r.data, o.data) }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var $a = { placement: "bottom", modifiers: [], strategy: "absolute" };
function Ia() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function Or(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, r = t.defaultOptions, a = r === void 0 ? $a : r;
  return function(s, i, u) {
    u === void 0 && (u = a);
    var l = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, $a, a), modifiersData: {}, elements: { reference: s, popper: i }, attributes: {}, styles: {} }, d = [], c = !1, v = { state: l, setOptions: function(p) {
      var m = typeof p == "function" ? p(l.options) : p;
      f(), l.options = Object.assign({}, a, l.options, m), l.scrollParents = { reference: Qt(s) ? Cn(s) : s.contextElement ? Cn(s.contextElement) : [], popper: Cn(i) };
      var y = S0(T0([].concat(o, l.options.modifiers)));
      return l.orderedModifiers = y.filter(function(C) {
        return C.enabled;
      }), g(), v.update();
    }, forceUpdate: function() {
      if (!c) {
        var p = l.elements, m = p.reference, y = p.popper;
        if (Ia(m, y)) {
          l.rects = { reference: F0(m, An(y), l.options.strategy === "fixed"), popper: wr(y) }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function(A) {
            return l.modifiersData[A.name] = Object.assign({}, A.data);
          });
          for (var C = 0; C < l.orderedModifiers.length; C++) {
            if (l.reset === !0) {
              l.reset = !1, C = -1;
              continue;
            }
            var I = l.orderedModifiers[C], S = I.fn, x = I.options, O = x === void 0 ? {} : x, k = I.name;
            typeof S == "function" && (l = S({ state: l, options: O, name: k, instance: v }) || l);
          }
        }
      }
    }, update: O0(function() {
      return new Promise(function(p) {
        v.forceUpdate(), p(l);
      });
    }), destroy: function() {
      f(), c = !0;
    } };
    if (!Ia(s, i)) return v;
    v.setOptions(u).then(function(p) {
      !c && u.onFirstUpdate && u.onFirstUpdate(p);
    });
    function g() {
      l.orderedModifiers.forEach(function(p) {
        var m = p.name, y = p.options, C = y === void 0 ? {} : y, I = p.effect;
        if (typeof I == "function") {
          var S = I({ state: l, name: m, instance: v, options: C }), x = function() {
          };
          d.push(S || x);
        }
      });
    }
    function f() {
      d.forEach(function(p) {
        return p();
      }), d = [];
    }
    return v;
  };
}
Or();
var E0 = [zs, Vs, Bs, Ps];
Or({ defaultModifiers: E0 });
var k0 = [zs, Vs, Bs, Ps, v0, u0, y0, qp, d0], _0 = Or({ defaultModifiers: k0 });
const $0 = (e, t, n = {}) => {
  const o = {
    name: "updateState",
    enabled: !0,
    phase: "write",
    fn: ({ state: u }) => {
      const l = I0(u);
      Object.assign(s.value, l);
    },
    requires: ["computeStyles"]
  }, r = w(() => {
    const { onFirstUpdate: u, placement: l, strategy: d, modifiers: c } = h(n);
    return {
      onFirstUpdate: u,
      placement: l || "bottom",
      strategy: d || "absolute",
      modifiers: [
        ...c || [],
        o,
        { name: "applyStyles", enabled: !1 }
      ]
    };
  }), a = ns(), s = E({
    styles: {
      popper: {
        position: h(r).strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), i = () => {
    a.value && (a.value.destroy(), a.value = void 0);
  };
  return V(r, (u) => {
    const l = h(a);
    l && l.setOptions(u);
  }, {
    deep: !0
  }), V([e, t], ([u, l]) => {
    i(), !(!u || !l) && (a.value = _0(u, l, h(r)));
  }), ke(() => {
    i();
  }), {
    state: w(() => {
      var u;
      return { ...((u = h(a)) == null ? void 0 : u.state) || {} };
    }),
    styles: w(() => h(s).styles),
    attributes: w(() => h(s).attributes),
    update: () => {
      var u;
      return (u = h(a)) == null ? void 0 : u.update();
    },
    forceUpdate: () => {
      var u;
      return (u = h(a)) == null ? void 0 : u.forceUpdate();
    },
    instanceRef: w(() => h(a))
  };
};
function I0(e) {
  const t = Object.keys(e.elements), n = Zo(t.map((r) => [r, e.styles[r] || {}])), o = Zo(t.map((r) => [r, e.attributes[r]]));
  return {
    styles: n,
    attributes: o
  };
}
function Aa() {
  let e;
  const t = (o, r) => {
    n(), e = window.setTimeout(o, r);
  }, n = () => window.clearTimeout(e);
  return ro(() => n()), {
    registerTimeout: t,
    cancelTimeout: n
  };
}
const Xo = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, A0 = Symbol("elIdInjection"), Tr = () => me() ? W(A0, Xo) : Xo, mo = (e) => {
  const t = Tr();
  !se && t === Xo && Ve("IdInjection", `Looks like you are using server rendering, you must provide a id provider to ensure the hydration process to be succeed
usage: app.provide(ID_INJECTION_KEY, {
  prefix: number,
  current: number,
})`);
  const n = mr();
  return w(() => h(e) || `${n.value}-id-${t.prefix}-${t.current++}`);
};
let Gt = [];
const Pa = (e) => {
  const t = e;
  t.key === Tn.esc && Gt.forEach((n) => n(t));
}, P0 = (e) => {
  ie(() => {
    Gt.length === 0 && document.addEventListener("keydown", Pa), se && Gt.push(e);
  }), ke(() => {
    Gt = Gt.filter((t) => t !== e), Gt.length === 0 && se && document.removeEventListener("keydown", Pa);
  });
};
let La;
const js = () => {
  const e = mr(), t = Tr(), n = w(() => `${e.value}-popper-container-${t.prefix}`), o = w(() => `#${n.value}`);
  return {
    id: n,
    selector: o
  };
}, L0 = (e) => {
  const t = document.createElement("div");
  return t.id = e, document.body.appendChild(t), t;
}, M0 = () => {
  const { id: e, selector: t } = js();
  return gl(() => {
    se && (Lt.env.NODE_ENV === "test" || !La || !document.body.querySelector(t.value)) && (La = L0(e.value));
  }), {
    id: e,
    selector: t
  };
}, R0 = ee({
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  autoClose: {
    type: Number,
    default: 0
  }
}), N0 = ({
  showAfter: e,
  hideAfter: t,
  autoClose: n,
  open: o,
  close: r
}) => {
  const { registerTimeout: a } = Aa(), {
    registerTimeout: s,
    cancelTimeout: i
  } = Aa();
  return {
    onOpen: (d) => {
      a(() => {
        o(d);
        const c = h(n);
        xe(c) && c > 0 && s(() => {
          r(d);
        }, c);
      }, h(e));
    },
    onClose: (d) => {
      i(), a(() => {
        r(d);
      }, h(t));
    }
  };
}, Us = Symbol("elForwardRef"), B0 = (e) => {
  ye(Us, {
    setForwardRef: (n) => {
      e.value = n;
    }
  });
}, z0 = (e) => ({
  mounted(t) {
    e(t);
  },
  updated(t) {
    e(t);
  },
  unmounted() {
    e(null);
  }
}), Ma = {
  current: 0
}, Ra = E(0), D0 = 2e3, Na = Symbol("elZIndexContextKey"), H0 = Symbol("zIndexContextKey"), V0 = (e) => {
  const t = me() ? W(Na, Ma) : Ma, n = me() ? W(H0, void 0) : void 0, o = w(() => {
    const s = h(n);
    return xe(s) ? s : D0;
  }), r = w(() => o.value + Ra.value), a = () => (t.current++, Ra.value = t.current, r.value);
  return !se && !W(Na) && Ve("ZIndexInjection", `Looks like you are using server rendering, you must provide a z-index provider to ensure the hydration process to be succeed
usage: app.provide(ZINDEX_INJECTION_KEY, { current: 0 })`), {
    initialZIndex: o,
    currentZIndex: r,
    nextZIndex: a
  };
}, Ks = fo({
  type: String,
  values: $s,
  required: !1
}), j0 = Symbol("size"), U0 = () => {
  const e = W(j0, {});
  return w(() => h(e.size) || "");
};
function K0(e, {
  beforeFocus: t,
  afterFocus: n,
  beforeBlur: o,
  afterBlur: r
} = {}) {
  const a = me(), { emit: s } = a, i = ns(), u = E(!1), l = (v) => {
    ue(t) && t(v) || u.value || (u.value = !0, s("focus", v), n == null || n());
  }, d = (v) => {
    var g;
    ue(o) && o(v) || v.relatedTarget && ((g = i.value) != null && g.contains(v.relatedTarget)) || (u.value = !1, s("blur", v), r == null || r());
  }, c = () => {
    var v, g;
    (v = i.value) != null && v.contains(document.activeElement) && i.value !== document.activeElement || (g = e.value) == null || g.focus();
  };
  return V(i, (v) => {
    v && v.setAttribute("tabindex", "-1");
  }), Te(i, "focus", l, !0), Te(i, "blur", d, !0), Te(i, "click", c, !0), Lt.env.NODE_ENV === "test" && ie(() => {
    const v = kt(e.value) ? e.value : document.querySelector("input,textarea");
    v && (Te(v, "focus", l, !0), Te(v, "blur", d, !0));
  }), {
    isFocused: u,
    wrapperRef: i,
    handleFocus: l,
    handleBlur: d
  };
}
function G0({
  afterComposition: e,
  emit: t
}) {
  const n = E(!1), o = (i) => {
    t == null || t("compositionstart", i), n.value = !0;
  }, r = (i) => {
    var u;
    t == null || t("compositionupdate", i);
    const l = (u = i.target) == null ? void 0 : u.value, d = l[l.length - 1] || "";
    n.value = !vp(d);
  }, a = (i) => {
    t == null || t("compositionend", i), n.value && (n.value = !1, we(() => e(i)));
  };
  return {
    isComposing: n,
    handleComposition: (i) => {
      i.type === "compositionend" ? a(i) : r(i);
    },
    handleCompositionStart: o,
    handleCompositionUpdate: r,
    handleCompositionEnd: a
  };
}
const W0 = Symbol("emptyValuesContextKey"), q0 = "use-empty-values", Z0 = ["", void 0, null], Y0 = void 0, J0 = ee({
  emptyValues: Array,
  valueOnClear: {
    type: [String, Number, Boolean, Function],
    default: void 0,
    validator: (e) => ue(e) ? !e() : !e
  }
}), X0 = (e, t) => {
  const n = me() ? W(W0, E({})) : E({}), o = w(() => e.emptyValues || n.value.emptyValues || Z0), r = w(() => ue(e.valueOnClear) ? e.valueOnClear() : e.valueOnClear !== void 0 ? e.valueOnClear : ue(n.value.valueOnClear) ? n.value.valueOnClear() : n.value.valueOnClear !== void 0 ? n.value.valueOnClear : Y0), a = (s) => o.value.includes(s);
  return o.value.includes(r.value) || Ve(q0, "value-on-clear should be a value of empty-values"), {
    emptyValues: o,
    valueOnClear: r,
    isEmptyValue: a
  };
}, Q0 = ee({
  ariaLabel: String,
  ariaOrientation: {
    type: String,
    values: ["horizontal", "vertical", "undefined"]
  },
  ariaControls: String
}), yo = (e) => Yf(Q0, e), ev = Symbol(), Ba = E();
function tv(e, t = void 0) {
  const n = me() ? W(ev, Ba) : Ba;
  return w(() => {
    var o, r;
    return (r = (o = n.value) == null ? void 0 : o[e]) != null ? r : t;
  });
}
var J = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
};
const nv = ee({
  size: {
    type: z([Number, String])
  },
  color: {
    type: String
  }
}), ov = M({
  name: "ElIcon",
  inheritAttrs: !1
}), rv = /* @__PURE__ */ M({
  ...ov,
  props: nv,
  setup(e) {
    const t = e, n = te("icon"), o = w(() => {
      const { size: r, color: a } = t;
      return !r && !a ? {} : {
        fontSize: wn(r) ? void 0 : eo(r),
        "--color": a
      };
    });
    return (r, a) => (F(), P("i", Pt({
      class: h(n).b(),
      style: h(o)
    }, r.$attrs), [
      N(r.$slots, "default")
    ], 16));
  }
});
var av = /* @__PURE__ */ J(rv, [["__file", "icon.vue"]]);
const on = _e(av), Er = Symbol("formContextKey"), no = Symbol("formItemContextKey"), kr = (e, t = {}) => {
  const n = E(void 0), o = t.prop ? n : Is("size"), r = t.global ? n : U0(), a = t.form ? { size: void 0 } : W(Er, void 0), s = t.formItem ? { size: void 0 } : W(no, void 0);
  return w(() => o.value || h(e) || (s == null ? void 0 : s.size) || (a == null ? void 0 : a.size) || r.value || "");
}, Gs = (e) => {
  const t = Is("disabled"), n = W(Er, void 0);
  return w(() => t.value || h(e) || (n == null ? void 0 : n.disabled) || !1);
}, Ws = () => {
  const e = W(Er, void 0), t = W(no, void 0);
  return {
    form: e,
    formItem: t
  };
}, sv = (e, {
  formItemContext: t,
  disableIdGeneration: n,
  disableIdManagement: o
}) => {
  n || (n = E(!1)), o || (o = E(!1));
  const r = E();
  let a;
  const s = w(() => {
    var i;
    return !!(!(e.label || e.ariaLabel) && t && t.inputIds && ((i = t.inputIds) == null ? void 0 : i.length) <= 1);
  });
  return ie(() => {
    a = V([Re(e, "id"), n], ([i, u]) => {
      const l = i ?? (u ? void 0 : mo().value);
      l !== r.value && (t != null && t.removeInputId && (r.value && t.removeInputId(r.value), !(o != null && o.value) && !u && l && t.addInputId(l)), r.value = l);
    }, { immediate: !0 });
  }), ml(() => {
    a && a(), t != null && t.removeInputId && r.value && t.removeInputId(r.value);
  }), {
    isLabeledByFormItem: s,
    inputId: r
  };
}, jt = 4, iv = {
  vertical: {
    offset: "offsetHeight",
    scroll: "scrollTop",
    scrollSize: "scrollHeight",
    size: "height",
    key: "vertical",
    axis: "Y",
    client: "clientY",
    direction: "top"
  },
  horizontal: {
    offset: "offsetWidth",
    scroll: "scrollLeft",
    scrollSize: "scrollWidth",
    size: "width",
    key: "horizontal",
    axis: "X",
    client: "clientX",
    direction: "left"
  }
}, lv = ({
  move: e,
  size: t,
  bar: n
}) => ({
  [n.size]: t,
  transform: `translate${n.axis}(${e}%)`
}), _r = Symbol("scrollbarContextKey"), uv = ee({
  vertical: Boolean,
  size: String,
  move: Number,
  ratio: {
    type: Number,
    required: !0
  },
  always: Boolean
}), cv = "Thumb", dv = /* @__PURE__ */ M({
  __name: "thumb",
  props: uv,
  setup(e) {
    const t = e, n = W(_r), o = te("scrollbar");
    n || Qf(cv, "can not inject scrollbar context");
    const r = E(), a = E(), s = E({}), i = E(!1);
    let u = !1, l = !1, d = se ? document.onselectstart : null;
    const c = w(() => iv[t.vertical ? "vertical" : "horizontal"]), v = w(() => lv({
      size: t.size,
      move: t.move,
      bar: c.value
    })), g = w(() => r.value[c.value.offset] ** 2 / n.wrapElement[c.value.scrollSize] / t.ratio / a.value[c.value.offset]), f = (O) => {
      var k;
      if (O.stopPropagation(), O.ctrlKey || [1, 2].includes(O.button))
        return;
      (k = window.getSelection()) == null || k.removeAllRanges(), m(O);
      const A = O.currentTarget;
      A && (s.value[c.value.axis] = A[c.value.offset] - (O[c.value.client] - A.getBoundingClientRect()[c.value.direction]));
    }, p = (O) => {
      if (!a.value || !r.value || !n.wrapElement)
        return;
      const k = Math.abs(O.target.getBoundingClientRect()[c.value.direction] - O[c.value.client]), A = a.value[c.value.offset] / 2, L = (k - A) * 100 * g.value / r.value[c.value.offset];
      n.wrapElement[c.value.scroll] = L * n.wrapElement[c.value.scrollSize] / 100;
    }, m = (O) => {
      O.stopImmediatePropagation(), u = !0, document.addEventListener("mousemove", y), document.addEventListener("mouseup", C), d = document.onselectstart, document.onselectstart = () => !1;
    }, y = (O) => {
      if (!r.value || !a.value || u === !1)
        return;
      const k = s.value[c.value.axis];
      if (!k)
        return;
      const A = (r.value.getBoundingClientRect()[c.value.direction] - O[c.value.client]) * -1, L = a.value[c.value.offset] - k, H = (A - L) * 100 * g.value / r.value[c.value.offset];
      n.wrapElement[c.value.scroll] = H * n.wrapElement[c.value.scrollSize] / 100;
    }, C = () => {
      u = !1, s.value[c.value.axis] = 0, document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", C), x(), l && (i.value = !1);
    }, I = () => {
      l = !1, i.value = !!t.size;
    }, S = () => {
      l = !0, i.value = u;
    };
    ke(() => {
      x(), document.removeEventListener("mouseup", C);
    });
    const x = () => {
      document.onselectstart !== d && (document.onselectstart = d);
    };
    return Te(Re(n, "scrollbarElement"), "mousemove", I), Te(Re(n, "scrollbarElement"), "mouseleave", S), (O, k) => (F(), j(oo, {
      name: h(o).b("fade"),
      persisted: ""
    }, {
      default: R(() => [
        et(B("div", {
          ref_key: "instance",
          ref: r,
          class: $([h(o).e("bar"), h(o).is(h(c).key)]),
          onMousedown: p
        }, [
          B("div", {
            ref_key: "thumb",
            ref: a,
            class: $(h(o).e("thumb")),
            style: ze(h(v)),
            onMousedown: f
          }, null, 38)
        ], 34), [
          [rn, O.always || i.value]
        ])
      ]),
      _: 1
    }, 8, ["name"]));
  }
});
var za = /* @__PURE__ */ J(dv, [["__file", "thumb.vue"]]);
const fv = ee({
  always: {
    type: Boolean,
    default: !0
  },
  minSize: {
    type: Number,
    required: !0
  }
}), pv = /* @__PURE__ */ M({
  __name: "bar",
  props: fv,
  setup(e, { expose: t }) {
    const n = e, o = W(_r), r = E(0), a = E(0), s = E(""), i = E(""), u = E(1), l = E(1);
    return t({
      handleScroll: (v) => {
        if (v) {
          const g = v.offsetHeight - jt, f = v.offsetWidth - jt;
          a.value = v.scrollTop * 100 / g * u.value, r.value = v.scrollLeft * 100 / f * l.value;
        }
      },
      update: () => {
        const v = o == null ? void 0 : o.wrapElement;
        if (!v)
          return;
        const g = v.offsetHeight - jt, f = v.offsetWidth - jt, p = g ** 2 / v.scrollHeight, m = f ** 2 / v.scrollWidth, y = Math.max(p, n.minSize), C = Math.max(m, n.minSize);
        u.value = p / (g - p) / (y / (g - y)), l.value = m / (f - m) / (C / (f - C)), i.value = y + jt < g ? `${y}px` : "", s.value = C + jt < f ? `${C}px` : "";
      }
    }), (v, g) => (F(), P(ot, null, [
      U(za, {
        move: r.value,
        ratio: l.value,
        size: s.value,
        always: v.always
      }, null, 8, ["move", "ratio", "size", "always"]),
      U(za, {
        move: a.value,
        ratio: u.value,
        size: i.value,
        vertical: "",
        always: v.always
      }, null, 8, ["move", "ratio", "size", "always"])
    ], 64));
  }
});
var vv = /* @__PURE__ */ J(pv, [["__file", "bar.vue"]]);
const hv = ee({
  height: {
    type: [String, Number],
    default: ""
  },
  maxHeight: {
    type: [String, Number],
    default: ""
  },
  native: {
    type: Boolean,
    default: !1
  },
  wrapStyle: {
    type: z([String, Object, Array]),
    default: ""
  },
  wrapClass: {
    type: [String, Array],
    default: ""
  },
  viewClass: {
    type: [String, Array],
    default: ""
  },
  viewStyle: {
    type: [String, Array, Object],
    default: ""
  },
  noresize: Boolean,
  tag: {
    type: String,
    default: "div"
  },
  always: Boolean,
  minSize: {
    type: Number,
    default: 20
  },
  tabindex: {
    type: [String, Number],
    default: void 0
  },
  id: String,
  role: String,
  ...yo(["ariaLabel", "ariaOrientation"])
}), gv = {
  scroll: ({
    scrollTop: e,
    scrollLeft: t
  }) => [e, t].every(xe)
}, Qo = "ElScrollbar", mv = M({
  name: Qo
}), yv = /* @__PURE__ */ M({
  ...mv,
  props: hv,
  emits: gv,
  setup(e, { expose: t, emit: n }) {
    const o = e, r = te("scrollbar");
    let a, s, i = 0, u = 0;
    const l = E(), d = E(), c = E(), v = E(), g = w(() => {
      const x = {};
      return o.height && (x.height = eo(o.height)), o.maxHeight && (x.maxHeight = eo(o.maxHeight)), [o.wrapStyle, x];
    }), f = w(() => [
      o.wrapClass,
      r.e("wrap"),
      { [r.em("wrap", "hidden-default")]: !o.native }
    ]), p = w(() => [r.e("view"), o.viewClass]), m = () => {
      var x;
      d.value && ((x = v.value) == null || x.handleScroll(d.value), i = d.value.scrollTop, u = d.value.scrollLeft, n("scroll", {
        scrollTop: d.value.scrollTop,
        scrollLeft: d.value.scrollLeft
      }));
    };
    function y(x, O) {
      Be(x) ? d.value.scrollTo(x) : xe(x) && xe(O) && d.value.scrollTo(x, O);
    }
    const C = (x) => {
      if (!xe(x)) {
        Ve(Qo, "value must be a number");
        return;
      }
      d.value.scrollTop = x;
    }, I = (x) => {
      if (!xe(x)) {
        Ve(Qo, "value must be a number");
        return;
      }
      d.value.scrollLeft = x;
    }, S = () => {
      var x;
      (x = v.value) == null || x.update();
    };
    return V(() => o.noresize, (x) => {
      x ? (a == null || a(), s == null || s()) : ({ stop: a } = pt(c, S), s = Te("resize", S));
    }, { immediate: !0 }), V(() => [o.maxHeight, o.height], () => {
      o.native || we(() => {
        var x;
        S(), d.value && ((x = v.value) == null || x.handleScroll(d.value));
      });
    }), ye(_r, $t({
      scrollbarElement: l,
      wrapElement: d
    })), yl(() => {
      d.value && (d.value.scrollTop = i, d.value.scrollLeft = u);
    }), ie(() => {
      o.native || we(() => {
        S();
      });
    }), bl(() => S()), t({
      wrapRef: d,
      update: S,
      scrollTo: y,
      setScrollTop: C,
      setScrollLeft: I,
      handleScroll: m
    }), (x, O) => (F(), P("div", {
      ref_key: "scrollbarRef",
      ref: l,
      class: $(h(r).b())
    }, [
      B("div", {
        ref_key: "wrapRef",
        ref: d,
        class: $(h(f)),
        style: ze(h(g)),
        tabindex: x.tabindex,
        onScroll: m
      }, [
        (F(), j(tt(x.tag), {
          id: x.id,
          ref_key: "resizeRef",
          ref: c,
          class: $(h(p)),
          style: ze(x.viewStyle),
          role: x.role,
          "aria-label": x.ariaLabel,
          "aria-orientation": x.ariaOrientation
        }, {
          default: R(() => [
            N(x.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "class", "style", "role", "aria-label", "aria-orientation"]))
      ], 46, ["tabindex"]),
      x.native ? G("v-if", !0) : (F(), j(vv, {
        key: 0,
        ref_key: "barRef",
        ref: v,
        always: x.always,
        "min-size": x.minSize
      }, null, 8, ["always", "min-size"]))
    ], 2));
  }
});
var bv = /* @__PURE__ */ J(yv, [["__file", "scrollbar.vue"]]);
const wv = _e(bv), $r = Symbol("popper"), qs = Symbol("popperContent"), xv = [
  "dialog",
  "grid",
  "group",
  "listbox",
  "menu",
  "navigation",
  "tooltip",
  "tree"
], Zs = ee({
  role: {
    type: String,
    values: xv,
    default: "tooltip"
  }
}), Fv = M({
  name: "ElPopper",
  inheritAttrs: !1
}), Cv = /* @__PURE__ */ M({
  ...Fv,
  props: Zs,
  setup(e, { expose: t }) {
    const n = e, o = E(), r = E(), a = E(), s = E(), i = w(() => n.role), u = {
      triggerRef: o,
      popperInstanceRef: r,
      contentRef: a,
      referenceRef: s,
      role: i
    };
    return t(u), ye($r, u), (l, d) => N(l.$slots, "default");
  }
});
var Sv = /* @__PURE__ */ J(Cv, [["__file", "popper.vue"]]);
const Ys = ee({
  arrowOffset: {
    type: Number,
    default: 5
  }
}), Ov = M({
  name: "ElPopperArrow",
  inheritAttrs: !1
}), Tv = /* @__PURE__ */ M({
  ...Ov,
  props: Ys,
  setup(e, { expose: t }) {
    const n = e, o = te("popper"), { arrowOffset: r, arrowRef: a, arrowStyle: s } = W(qs, void 0);
    return V(() => n.arrowOffset, (i) => {
      r.value = i;
    }), ke(() => {
      a.value = void 0;
    }), t({
      arrowRef: a
    }), (i, u) => (F(), P("span", {
      ref_key: "arrowRef",
      ref: a,
      class: $(h(o).e("arrow")),
      style: ze(h(s)),
      "data-popper-arrow": ""
    }, null, 6));
  }
});
var Ev = /* @__PURE__ */ J(Tv, [["__file", "arrow.vue"]]);
const Ao = "ElOnlyChild", kv = M({
  name: Ao,
  setup(e, {
    slots: t,
    attrs: n
  }) {
    var o;
    const r = W(Us), a = z0((o = r == null ? void 0 : r.setForwardRef) != null ? o : Jn);
    return () => {
      var s;
      const i = (s = t.default) == null ? void 0 : s.call(t, n);
      if (!i)
        return null;
      if (i.length > 1)
        return Ve(Ao, "requires exact only one valid child."), null;
      const u = Js(i);
      return u ? et(wl(u, n), [[a]]) : (Ve(Ao, "no valid child node found"), null);
    };
  }
});
function Js(e) {
  if (!e)
    return null;
  const t = e;
  for (const n of t) {
    if (Be(n))
      switch (n.type) {
        case xl:
          continue;
        case os:
        case "svg":
          return Da(n);
        case ot:
          return Js(n.children);
        default:
          return n;
      }
    return Da(n);
  }
  return null;
}
function Da(e) {
  const t = te("only-child");
  return U("span", {
    class: t.e("content")
  }, [e]);
}
const Xs = ee({
  virtualRef: {
    type: z(Object)
  },
  virtualTriggering: Boolean,
  onMouseenter: {
    type: z(Function)
  },
  onMouseleave: {
    type: z(Function)
  },
  onClick: {
    type: z(Function)
  },
  onKeydown: {
    type: z(Function)
  },
  onFocus: {
    type: z(Function)
  },
  onBlur: {
    type: z(Function)
  },
  onContextmenu: {
    type: z(Function)
  },
  id: String,
  open: Boolean
}), _v = M({
  name: "ElPopperTrigger",
  inheritAttrs: !1
}), $v = /* @__PURE__ */ M({
  ..._v,
  props: Xs,
  setup(e, { expose: t }) {
    const n = e, { role: o, triggerRef: r } = W($r, void 0);
    B0(r);
    const a = w(() => i.value ? n.id : void 0), s = w(() => {
      if (o && o.value === "tooltip")
        return n.open && n.id ? n.id : void 0;
    }), i = w(() => {
      if (o && o.value !== "tooltip")
        return o.value;
    }), u = w(() => i.value ? `${n.open}` : void 0);
    let l;
    const d = [
      "onMouseenter",
      "onMouseleave",
      "onClick",
      "onKeydown",
      "onFocus",
      "onBlur",
      "onContextmenu"
    ];
    return ie(() => {
      V(() => n.virtualRef, (c) => {
        c && (r.value = Qe(c));
      }, {
        immediate: !0
      }), V(r, (c, v) => {
        l == null || l(), l = void 0, kt(c) && (d.forEach((g) => {
          var f;
          const p = n[g];
          p && (c.addEventListener(g.slice(2).toLowerCase(), p), (f = v == null ? void 0 : v.removeEventListener) == null || f.call(v, g.slice(2).toLowerCase(), p));
        }), l = V([a, s, i, u], (g) => {
          [
            "aria-controls",
            "aria-describedby",
            "aria-haspopup",
            "aria-expanded"
          ].forEach((f, p) => {
            hr(g[p]) ? c.removeAttribute(f) : c.setAttribute(f, g[p]);
          });
        }, { immediate: !0 })), kt(v) && [
          "aria-controls",
          "aria-describedby",
          "aria-haspopup",
          "aria-expanded"
        ].forEach((g) => v.removeAttribute(g));
      }, {
        immediate: !0
      });
    }), ke(() => {
      if (l == null || l(), l = void 0, r.value && kt(r.value)) {
        const c = r.value;
        d.forEach((v) => {
          const g = n[v];
          g && c.removeEventListener(v.slice(2).toLowerCase(), g);
        }), r.value = void 0;
      }
    }), t({
      triggerRef: r
    }), (c, v) => c.virtualTriggering ? G("v-if", !0) : (F(), j(h(kv), Pt({ key: 0 }, c.$attrs, {
      "aria-controls": h(a),
      "aria-describedby": h(s),
      "aria-expanded": h(u),
      "aria-haspopup": h(i)
    }), {
      default: R(() => [
        N(c.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup"]));
  }
});
var Iv = /* @__PURE__ */ J($v, [["__file", "trigger.vue"]]);
const Po = "focus-trap.focus-after-trapped", Lo = "focus-trap.focus-after-released", Av = "focus-trap.focusout-prevented", Ha = {
  cancelable: !0,
  bubbles: !1
}, Pv = {
  cancelable: !0,
  bubbles: !1
}, Va = "focusAfterTrapped", ja = "focusAfterReleased", Lv = Symbol("elFocusTrap"), Ir = E(), bo = E(0), Ar = E(0);
let Un = 0;
const Qs = (e) => {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 || o === document.activeElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}, Ua = (e, t) => {
  for (const n of e)
    if (!Mv(n, t))
      return n;
}, Mv = (e, t) => {
  if (Lt.env.NODE_ENV === "test")
    return !1;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}, Rv = (e) => {
  const t = Qs(e), n = Ua(t, e), o = Ua(t.reverse(), e);
  return [n, o];
}, Nv = (e) => e instanceof HTMLInputElement && "select" in e, dt = (e, t) => {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), Ar.value = window.performance.now(), e !== n && Nv(e) && t && e.select();
  }
};
function Ka(e, t) {
  const n = [...e], o = e.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
const Bv = () => {
  let e = [];
  return {
    push: (o) => {
      const r = e[0];
      r && o !== r && r.pause(), e = Ka(e, o), e.unshift(o);
    },
    remove: (o) => {
      var r, a;
      e = Ka(e, o), (a = (r = e[0]) == null ? void 0 : r.resume) == null || a.call(r);
    }
  };
}, zv = (e, t = !1) => {
  const n = document.activeElement;
  for (const o of e)
    if (dt(o, t), document.activeElement !== n)
      return;
}, Ga = Bv(), Dv = () => bo.value > Ar.value, Kn = () => {
  Ir.value = "pointer", bo.value = window.performance.now();
}, Wa = () => {
  Ir.value = "keyboard", bo.value = window.performance.now();
}, Hv = () => (ie(() => {
  Un === 0 && (document.addEventListener("mousedown", Kn), document.addEventListener("touchstart", Kn), document.addEventListener("keydown", Wa)), Un++;
}), ke(() => {
  Un--, Un <= 0 && (document.removeEventListener("mousedown", Kn), document.removeEventListener("touchstart", Kn), document.removeEventListener("keydown", Wa));
}), {
  focusReason: Ir,
  lastUserFocusTimestamp: bo,
  lastAutomatedFocusTimestamp: Ar
}), Gn = (e) => new CustomEvent(Av, {
  ...Pv,
  detail: e
}), Vv = M({
  name: "ElFocusTrap",
  inheritAttrs: !1,
  props: {
    loop: Boolean,
    trapped: Boolean,
    focusTrapEl: Object,
    focusStartEl: {
      type: [Object, String],
      default: "first"
    }
  },
  emits: [
    Va,
    ja,
    "focusin",
    "focusout",
    "focusout-prevented",
    "release-requested"
  ],
  setup(e, { emit: t }) {
    const n = E();
    let o, r;
    const { focusReason: a } = Hv();
    P0((f) => {
      e.trapped && !s.paused && t("release-requested", f);
    });
    const s = {
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }, i = (f) => {
      if (!e.loop && !e.trapped || s.paused)
        return;
      const { key: p, altKey: m, ctrlKey: y, metaKey: C, currentTarget: I, shiftKey: S } = f, { loop: x } = e, O = p === Tn.tab && !m && !y && !C, k = document.activeElement;
      if (O && k) {
        const A = I, [L, H] = Rv(A);
        if (L && H) {
          if (!S && k === H) {
            const K = Gn({
              focusReason: a.value
            });
            t("focusout-prevented", K), K.defaultPrevented || (f.preventDefault(), x && dt(L, !0));
          } else if (S && [L, A].includes(k)) {
            const K = Gn({
              focusReason: a.value
            });
            t("focusout-prevented", K), K.defaultPrevented || (f.preventDefault(), x && dt(H, !0));
          }
        } else if (k === A) {
          const K = Gn({
            focusReason: a.value
          });
          t("focusout-prevented", K), K.defaultPrevented || f.preventDefault();
        }
      }
    };
    ye(Lv, {
      focusTrapRef: n,
      onKeydown: i
    }), V(() => e.focusTrapEl, (f) => {
      f && (n.value = f);
    }, { immediate: !0 }), V([n], ([f], [p]) => {
      f && (f.addEventListener("keydown", i), f.addEventListener("focusin", d), f.addEventListener("focusout", c)), p && (p.removeEventListener("keydown", i), p.removeEventListener("focusin", d), p.removeEventListener("focusout", c));
    });
    const u = (f) => {
      t(Va, f);
    }, l = (f) => t(ja, f), d = (f) => {
      const p = h(n);
      if (!p)
        return;
      const m = f.target, y = f.relatedTarget, C = m && p.contains(m);
      e.trapped || y && p.contains(y) || (o = y), C && t("focusin", f), !s.paused && e.trapped && (C ? r = m : dt(r, !0));
    }, c = (f) => {
      const p = h(n);
      if (!(s.paused || !p))
        if (e.trapped) {
          const m = f.relatedTarget;
          !hr(m) && !p.contains(m) && setTimeout(() => {
            if (!s.paused && e.trapped) {
              const y = Gn({
                focusReason: a.value
              });
              t("focusout-prevented", y), y.defaultPrevented || dt(r, !0);
            }
          }, 0);
        } else {
          const m = f.target;
          m && p.contains(m) || t("focusout", f);
        }
    };
    async function v() {
      await we();
      const f = h(n);
      if (f) {
        Ga.push(s);
        const p = f.contains(document.activeElement) ? o : document.activeElement;
        if (o = p, !f.contains(p)) {
          const y = new Event(Po, Ha);
          f.addEventListener(Po, u), f.dispatchEvent(y), y.defaultPrevented || we(() => {
            let C = e.focusStartEl;
            an(C) || (dt(C), document.activeElement !== C && (C = "first")), C === "first" && zv(Qs(f), !0), (document.activeElement === p || C === "container") && dt(f);
          });
        }
      }
    }
    function g() {
      const f = h(n);
      if (f) {
        f.removeEventListener(Po, u);
        const p = new CustomEvent(Lo, {
          ...Ha,
          detail: {
            focusReason: a.value
          }
        });
        f.addEventListener(Lo, l), f.dispatchEvent(p), !p.defaultPrevented && (a.value == "keyboard" || !Dv() || f.contains(document.activeElement)) && dt(o ?? document.body), f.removeEventListener(Lo, l), Ga.remove(s);
      }
    }
    return ie(() => {
      e.trapped && v(), V(() => e.trapped, (f) => {
        f ? v() : g();
      });
    }), ke(() => {
      e.trapped && g(), n.value && (n.value.removeEventListener("keydown", i), n.value.removeEventListener("focusin", d), n.value.removeEventListener("focusout", c), n.value = void 0);
    }), {
      onKeydown: i
    };
  }
});
function jv(e, t, n, o, r, a) {
  return N(e.$slots, "default", { handleKeydown: e.onKeydown });
}
var Uv = /* @__PURE__ */ J(Vv, [["render", jv], ["__file", "focus-trap.vue"]]);
const Kv = ["fixed", "absolute"], Gv = ee({
  boundariesPadding: {
    type: Number,
    default: 0
  },
  fallbackPlacements: {
    type: z(Array),
    default: void 0
  },
  gpuAcceleration: {
    type: Boolean,
    default: !0
  },
  offset: {
    type: Number,
    default: 12
  },
  placement: {
    type: String,
    values: ho,
    default: "bottom"
  },
  popperOptions: {
    type: z(Object),
    default: () => ({})
  },
  strategy: {
    type: String,
    values: Kv,
    default: "absolute"
  }
}), ei = ee({
  ...Gv,
  id: String,
  style: {
    type: z([String, Array, Object])
  },
  className: {
    type: z([String, Array, Object])
  },
  effect: {
    type: z(String),
    default: "dark"
  },
  visible: Boolean,
  enterable: {
    type: Boolean,
    default: !0
  },
  pure: Boolean,
  focusOnShow: {
    type: Boolean,
    default: !1
  },
  trapping: {
    type: Boolean,
    default: !1
  },
  popperClass: {
    type: z([String, Array, Object])
  },
  popperStyle: {
    type: z([String, Array, Object])
  },
  referenceEl: {
    type: z(Object)
  },
  triggerTargetEl: {
    type: z(Object)
  },
  stopPopperMouseEvent: {
    type: Boolean,
    default: !0
  },
  virtualTriggering: Boolean,
  zIndex: Number,
  ...yo(["ariaLabel"])
}), Wv = {
  mouseenter: (e) => e instanceof MouseEvent,
  mouseleave: (e) => e instanceof MouseEvent,
  focus: () => !0,
  blur: () => !0,
  close: () => !0
}, qv = (e, t = []) => {
  const { placement: n, strategy: o, popperOptions: r } = e, a = {
    placement: n,
    strategy: o,
    ...r,
    modifiers: [...Yv(e), ...t]
  };
  return Jv(a, r == null ? void 0 : r.modifiers), a;
}, Zv = (e) => {
  if (se)
    return Qe(e);
};
function Yv(e) {
  const { offset: t, gpuAcceleration: n, fallbackPlacements: o } = e;
  return [
    {
      name: "offset",
      options: {
        offset: [0, t ?? 12]
      }
    },
    {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    },
    {
      name: "flip",
      options: {
        padding: 5,
        fallbackPlacements: o
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: n
      }
    }
  ];
}
function Jv(e, t) {
  t && (e.modifiers = [...e.modifiers, ...t ?? []]);
}
const Xv = 0, Qv = (e) => {
  const { popperInstanceRef: t, contentRef: n, triggerRef: o, role: r } = W($r, void 0), a = E(), s = E(), i = w(() => ({
    name: "eventListeners",
    enabled: !!e.visible
  })), u = w(() => {
    var y;
    const C = h(a), I = (y = h(s)) != null ? y : Xv;
    return {
      name: "arrow",
      enabled: !Gf(C),
      options: {
        element: C,
        padding: I
      }
    };
  }), l = w(() => ({
    onFirstUpdate: () => {
      f();
    },
    ...qv(e, [
      h(u),
      h(i)
    ])
  })), d = w(() => Zv(e.referenceEl) || h(o)), { attributes: c, state: v, styles: g, update: f, forceUpdate: p, instanceRef: m } = $0(d, n, l);
  return V(m, (y) => t.value = y), ie(() => {
    V(() => {
      var y;
      return (y = h(d)) == null ? void 0 : y.getBoundingClientRect();
    }, () => {
      f();
    });
  }), {
    attributes: c,
    arrowRef: a,
    contentRef: n,
    instanceRef: m,
    state: v,
    styles: g,
    role: r,
    forceUpdate: p,
    update: f
  };
}, eh = (e, {
  attributes: t,
  styles: n,
  role: o
}) => {
  const { nextZIndex: r } = V0(), a = te("popper"), s = w(() => h(t).popper), i = E(xe(e.zIndex) ? e.zIndex : r()), u = w(() => [
    a.b(),
    a.is("pure", e.pure),
    a.is(e.effect),
    e.popperClass
  ]), l = w(() => [
    { zIndex: h(i) },
    h(n).popper,
    e.popperStyle || {}
  ]), d = w(() => o.value === "dialog" ? "false" : void 0), c = w(() => h(n).arrow || {});
  return {
    ariaModal: d,
    arrowStyle: c,
    contentAttrs: s,
    contentClass: u,
    contentStyle: l,
    contentZIndex: i,
    updateZIndex: () => {
      i.value = xe(e.zIndex) ? e.zIndex : r();
    }
  };
}, th = (e, t) => {
  const n = E(!1), o = E();
  return {
    focusStartRef: o,
    trapped: n,
    onFocusAfterReleased: (l) => {
      var d;
      ((d = l.detail) == null ? void 0 : d.focusReason) !== "pointer" && (o.value = "first", t("blur"));
    },
    onFocusAfterTrapped: () => {
      t("focus");
    },
    onFocusInTrap: (l) => {
      e.visible && !n.value && (l.target && (o.value = l.target), n.value = !0);
    },
    onFocusoutPrevented: (l) => {
      e.trapping || (l.detail.focusReason === "pointer" && l.preventDefault(), n.value = !1);
    },
    onReleaseRequested: () => {
      n.value = !1, t("close");
    }
  };
}, nh = M({
  name: "ElPopperContent"
}), oh = /* @__PURE__ */ M({
  ...nh,
  props: ei,
  emits: Wv,
  setup(e, { expose: t, emit: n }) {
    const o = e, {
      focusStartRef: r,
      trapped: a,
      onFocusAfterReleased: s,
      onFocusAfterTrapped: i,
      onFocusInTrap: u,
      onFocusoutPrevented: l,
      onReleaseRequested: d
    } = th(o, n), { attributes: c, arrowRef: v, contentRef: g, styles: f, instanceRef: p, role: m, update: y } = Qv(o), {
      ariaModal: C,
      arrowStyle: I,
      contentAttrs: S,
      contentClass: x,
      contentStyle: O,
      updateZIndex: k
    } = eh(o, {
      styles: f,
      attributes: c,
      role: m
    }), A = W(no, void 0), L = E();
    ye(qs, {
      arrowStyle: I,
      arrowRef: v,
      arrowOffset: L
    }), A && ye(no, {
      ...A,
      addInputId: Jn,
      removeInputId: Jn
    });
    let H;
    const Z = (X = !0) => {
      y(), X && k();
    }, K = () => {
      Z(!1), o.visible && o.focusOnShow ? a.value = !0 : o.visible === !1 && (a.value = !1);
    };
    return ie(() => {
      V(() => o.triggerTargetEl, (X, be) => {
        H == null || H(), H = void 0;
        const re = h(X || g.value), _ = h(be || g.value);
        kt(re) && (H = V([m, () => o.ariaLabel, C, () => o.id], (q) => {
          ["role", "aria-label", "aria-modal", "id"].forEach((Ke, fe) => {
            hr(q[fe]) ? re.removeAttribute(Ke) : re.setAttribute(Ke, q[fe]);
          });
        }, { immediate: !0 })), _ !== re && kt(_) && ["role", "aria-label", "aria-modal", "id"].forEach((q) => {
          _.removeAttribute(q);
        });
      }, { immediate: !0 }), V(() => o.visible, K, { immediate: !0 });
    }), ke(() => {
      H == null || H(), H = void 0;
    }), t({
      popperContentRef: g,
      popperInstanceRef: p,
      updatePopper: Z,
      contentStyle: O
    }), (X, be) => (F(), P("div", Pt({
      ref_key: "contentRef",
      ref: g
    }, h(S), {
      style: h(O),
      class: h(x),
      tabindex: "-1",
      onMouseenter: (re) => X.$emit("mouseenter", re),
      onMouseleave: (re) => X.$emit("mouseleave", re)
    }), [
      U(h(Uv), {
        trapped: h(a),
        "trap-on-focus-in": !0,
        "focus-trap-el": h(g),
        "focus-start-el": h(r),
        onFocusAfterTrapped: h(i),
        onFocusAfterReleased: h(s),
        onFocusin: h(u),
        onFocusoutPrevented: h(l),
        onReleaseRequested: h(d)
      }, {
        default: R(() => [
          N(X.$slots, "default")
        ]),
        _: 3
      }, 8, ["trapped", "focus-trap-el", "focus-start-el", "onFocusAfterTrapped", "onFocusAfterReleased", "onFocusin", "onFocusoutPrevented", "onReleaseRequested"])
    ], 16, ["onMouseenter", "onMouseleave"]));
  }
});
var rh = /* @__PURE__ */ J(oh, [["__file", "content.vue"]]);
const ah = _e(Sv), Pr = Symbol("elTooltip"), he = ee({
  ...R0,
  ...ei,
  appendTo: {
    type: z([String, Object])
  },
  content: {
    type: String,
    default: ""
  },
  rawContent: Boolean,
  persistent: Boolean,
  visible: {
    type: z(Boolean),
    default: null
  },
  transition: String,
  teleported: {
    type: Boolean,
    default: !0
  },
  disabled: Boolean,
  ...yo(["ariaLabel"])
}), _n = ee({
  ...Xs,
  disabled: Boolean,
  trigger: {
    type: z([String, Array]),
    default: "hover"
  },
  triggerKeys: {
    type: z(Array),
    default: () => [Tn.enter, Tn.space]
  }
}), {
  useModelToggleProps: sh,
  useModelToggleEmits: ih,
  useModelToggle: lh
} = Ep("visible"), uh = ee({
  ...Zs,
  ...sh,
  ...he,
  ..._n,
  ...Ys,
  showArrow: {
    type: Boolean,
    default: !0
  }
}), ch = [
  ...ih,
  "before-show",
  "before-hide",
  "show",
  "hide",
  "open",
  "close"
], dh = (e, t) => Ne(e) ? e.includes(t) : e === t, Ut = (e, t, n) => (o) => {
  dh(h(e), t) && n(o);
}, fh = M({
  name: "ElTooltipTrigger"
}), ph = /* @__PURE__ */ M({
  ...fh,
  props: _n,
  setup(e, { expose: t }) {
    const n = e, o = te("tooltip"), { controlled: r, id: a, open: s, onOpen: i, onClose: u, onToggle: l } = W(Pr, void 0), d = E(null), c = () => {
      if (h(r) || n.disabled)
        return !0;
    }, v = Re(n, "trigger"), g = Ze(c, Ut(v, "hover", i)), f = Ze(c, Ut(v, "hover", u)), p = Ze(c, Ut(v, "click", (S) => {
      S.button === 0 && l(S);
    })), m = Ze(c, Ut(v, "focus", i)), y = Ze(c, Ut(v, "focus", u)), C = Ze(c, Ut(v, "contextmenu", (S) => {
      S.preventDefault(), l(S);
    })), I = Ze(c, (S) => {
      const { code: x } = S;
      n.triggerKeys.includes(x) && (S.preventDefault(), l(S));
    });
    return t({
      triggerRef: d
    }), (S, x) => (F(), j(h(Iv), {
      id: h(a),
      "virtual-ref": S.virtualRef,
      open: h(s),
      "virtual-triggering": S.virtualTriggering,
      class: $(h(o).e("trigger")),
      onBlur: h(y),
      onClick: h(p),
      onContextmenu: h(C),
      onFocus: h(m),
      onMouseenter: h(g),
      onMouseleave: h(f),
      onKeydown: h(I)
    }, {
      default: R(() => [
        N(S.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "virtual-ref", "open", "virtual-triggering", "class", "onBlur", "onClick", "onContextmenu", "onFocus", "onMouseenter", "onMouseleave", "onKeydown"]));
  }
});
var vh = /* @__PURE__ */ J(ph, [["__file", "trigger.vue"]]);
const hh = ee({
  to: {
    type: z([String, Object]),
    required: !0
  },
  disabled: Boolean
}), gh = /* @__PURE__ */ M({
  __name: "teleport",
  props: hh,
  setup(e) {
    return (t, n) => t.disabled ? N(t.$slots, "default", { key: 0 }) : (F(), j(Fl, {
      key: 1,
      to: t.to
    }, [
      N(t.$slots, "default")
    ], 8, ["to"]));
  }
});
var mh = /* @__PURE__ */ J(gh, [["__file", "teleport.vue"]]);
const yh = _e(mh), bh = M({
  name: "ElTooltipContent",
  inheritAttrs: !1
}), wh = /* @__PURE__ */ M({
  ...bh,
  props: he,
  setup(e, { expose: t }) {
    const n = e, { selector: o } = js(), r = te("tooltip"), a = E(null);
    let s;
    const {
      controlled: i,
      id: u,
      open: l,
      trigger: d,
      onClose: c,
      onOpen: v,
      onShow: g,
      onHide: f,
      onBeforeShow: p,
      onBeforeHide: m
    } = W(Pr, void 0), y = w(() => n.transition || `${r.namespace.value}-fade-in-linear`), C = w(() => Lt.env.NODE_ENV === "test" ? !0 : n.persistent);
    ke(() => {
      s == null || s();
    });
    const I = w(() => h(C) ? !0 : h(l)), S = w(() => n.disabled ? !1 : h(l)), x = w(() => n.appendTo || o.value), O = w(() => {
      var _;
      return (_ = n.style) != null ? _ : {};
    }), k = E(!0), A = () => {
      f(), k.value = !0;
    }, L = () => {
      if (h(i))
        return !0;
    }, H = Ze(L, () => {
      n.enterable && h(d) === "hover" && v();
    }), Z = Ze(L, () => {
      h(d) === "hover" && c();
    }), K = () => {
      var _, q;
      (q = (_ = a.value) == null ? void 0 : _.updatePopper) == null || q.call(_), p == null || p();
    }, X = () => {
      m == null || m();
    }, be = () => {
      g(), s = Vl(w(() => {
        var _;
        return (_ = a.value) == null ? void 0 : _.popperContentRef;
      }), () => {
        if (h(i))
          return;
        h(d) !== "hover" && c();
      });
    }, re = () => {
      n.virtualTriggering || c();
    };
    return V(() => h(l), (_) => {
      _ ? k.value = !1 : s == null || s();
    }, {
      flush: "post"
    }), V(() => n.content, () => {
      var _, q;
      (q = (_ = a.value) == null ? void 0 : _.updatePopper) == null || q.call(_);
    }), t({
      contentRef: a
    }), (_, q) => (F(), j(h(yh), {
      disabled: !_.teleported,
      to: h(x)
    }, {
      default: R(() => [
        U(oo, {
          name: h(y),
          onAfterLeave: A,
          onBeforeEnter: K,
          onAfterEnter: be,
          onBeforeLeave: X
        }, {
          default: R(() => [
            h(I) ? et((F(), j(h(rh), Pt({
              key: 0,
              id: h(u),
              ref_key: "contentRef",
              ref: a
            }, _.$attrs, {
              "aria-label": _.ariaLabel,
              "aria-hidden": k.value,
              "boundaries-padding": _.boundariesPadding,
              "fallback-placements": _.fallbackPlacements,
              "gpu-acceleration": _.gpuAcceleration,
              offset: _.offset,
              placement: _.placement,
              "popper-options": _.popperOptions,
              strategy: _.strategy,
              effect: _.effect,
              enterable: _.enterable,
              pure: _.pure,
              "popper-class": _.popperClass,
              "popper-style": [_.popperStyle, h(O)],
              "reference-el": _.referenceEl,
              "trigger-target-el": _.triggerTargetEl,
              visible: h(S),
              "z-index": _.zIndex,
              onMouseenter: h(H),
              onMouseleave: h(Z),
              onBlur: re,
              onClose: h(c)
            }), {
              default: R(() => [
                N(_.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "aria-label", "aria-hidden", "boundaries-padding", "fallback-placements", "gpu-acceleration", "offset", "placement", "popper-options", "strategy", "effect", "enterable", "pure", "popper-class", "popper-style", "reference-el", "trigger-target-el", "visible", "z-index", "onMouseenter", "onMouseleave", "onClose"])), [
              [rn, h(S)]
            ]) : G("v-if", !0)
          ]),
          _: 3
        }, 8, ["name"])
      ]),
      _: 3
    }, 8, ["disabled", "to"]));
  }
});
var xh = /* @__PURE__ */ J(wh, [["__file", "content.vue"]]);
const Fh = M({
  name: "ElTooltip"
}), Ch = /* @__PURE__ */ M({
  ...Fh,
  props: uh,
  emits: ch,
  setup(e, { expose: t, emit: n }) {
    const o = e;
    M0();
    const r = mo(), a = E(), s = E(), i = () => {
      var y;
      const C = h(a);
      C && ((y = C.popperInstanceRef) == null || y.update());
    }, u = E(!1), l = E(), { show: d, hide: c, hasUpdateHandler: v } = lh({
      indicator: u,
      toggleReason: l
    }), { onOpen: g, onClose: f } = N0({
      showAfter: Re(o, "showAfter"),
      hideAfter: Re(o, "hideAfter"),
      autoClose: Re(o, "autoClose"),
      open: d,
      close: c
    }), p = w(() => gr(o.visible) && !v.value);
    ye(Pr, {
      controlled: p,
      id: r,
      open: Cl(u),
      trigger: Re(o, "trigger"),
      onOpen: (y) => {
        g(y);
      },
      onClose: (y) => {
        f(y);
      },
      onToggle: (y) => {
        h(u) ? f(y) : g(y);
      },
      onShow: () => {
        n("show", l.value);
      },
      onHide: () => {
        n("hide", l.value);
      },
      onBeforeShow: () => {
        n("before-show", l.value);
      },
      onBeforeHide: () => {
        n("before-hide", l.value);
      },
      updatePopper: i
    }), V(() => o.disabled, (y) => {
      y && u.value && (u.value = !1);
    });
    const m = (y) => {
      var C, I;
      const S = (I = (C = s.value) == null ? void 0 : C.contentRef) == null ? void 0 : I.popperContentRef, x = (y == null ? void 0 : y.relatedTarget) || document.activeElement;
      return S && S.contains(x);
    };
    return Sl(() => u.value && c()), t({
      popperRef: a,
      contentRef: s,
      isFocusInsideContent: m,
      updatePopper: i,
      onOpen: g,
      onClose: f,
      hide: c
    }), (y, C) => (F(), j(h(ah), {
      ref_key: "popperRef",
      ref: a,
      role: y.role
    }, {
      default: R(() => [
        U(vh, {
          disabled: y.disabled,
          trigger: y.trigger,
          "trigger-keys": y.triggerKeys,
          "virtual-ref": y.virtualRef,
          "virtual-triggering": y.virtualTriggering
        }, {
          default: R(() => [
            y.$slots.default ? N(y.$slots, "default", { key: 0 }) : G("v-if", !0)
          ]),
          _: 3
        }, 8, ["disabled", "trigger", "trigger-keys", "virtual-ref", "virtual-triggering"]),
        U(xh, {
          ref_key: "contentRef",
          ref: s,
          "aria-label": y.ariaLabel,
          "boundaries-padding": y.boundariesPadding,
          content: y.content,
          disabled: y.disabled,
          effect: y.effect,
          enterable: y.enterable,
          "fallback-placements": y.fallbackPlacements,
          "hide-after": y.hideAfter,
          "gpu-acceleration": y.gpuAcceleration,
          offset: y.offset,
          persistent: y.persistent,
          "popper-class": y.popperClass,
          "popper-style": y.popperStyle,
          placement: y.placement,
          "popper-options": y.popperOptions,
          pure: y.pure,
          "raw-content": y.rawContent,
          "reference-el": y.referenceEl,
          "trigger-target-el": y.triggerTargetEl,
          "show-after": y.showAfter,
          strategy: y.strategy,
          teleported: y.teleported,
          transition: y.transition,
          "virtual-triggering": y.virtualTriggering,
          "z-index": y.zIndex,
          "append-to": y.appendTo
        }, {
          default: R(() => [
            N(y.$slots, "content", {}, () => [
              y.rawContent ? (F(), P("span", {
                key: 0,
                innerHTML: y.content
              }, null, 8, ["innerHTML"])) : (F(), P("span", { key: 1 }, ge(y.content), 1))
            ]),
            y.showArrow ? (F(), j(h(Ev), {
              key: 0,
              "arrow-offset": y.arrowOffset
            }, null, 8, ["arrow-offset"])) : G("v-if", !0)
          ]),
          _: 3
        }, 8, ["aria-label", "boundaries-padding", "content", "disabled", "effect", "enterable", "fallback-placements", "hide-after", "gpu-acceleration", "offset", "persistent", "popper-class", "popper-style", "placement", "popper-options", "pure", "raw-content", "reference-el", "trigger-target-el", "show-after", "strategy", "teleported", "transition", "virtual-triggering", "z-index", "append-to"])
      ]),
      _: 3
    }, 8, ["role"]));
  }
});
var Sh = /* @__PURE__ */ J(Ch, [["__file", "tooltip.vue"]]);
const ti = _e(Sh), ni = Symbol("buttonGroupContextKey"), Oh = (e, t) => {
  gp({
    from: "type.text",
    replacement: "link",
    version: "3.0.0",
    scope: "props",
    ref: "https://element-plus.org/en-US/component/button.html#button-attributes"
  }, w(() => e.type === "text"));
  const n = W(ni, void 0), o = tv("button"), { form: r } = Ws(), a = kr(w(() => n == null ? void 0 : n.size)), s = Gs(), i = E(), u = Ol(), l = w(() => e.type || (n == null ? void 0 : n.type) || ""), d = w(() => {
    var f, p, m;
    return (m = (p = e.autoInsertSpace) != null ? p : (f = o.value) == null ? void 0 : f.autoInsertSpace) != null ? m : !1;
  }), c = w(() => e.tag === "button" ? {
    ariaDisabled: s.value || e.loading,
    disabled: s.value || e.loading,
    autofocus: e.autofocus,
    type: e.nativeType
  } : {}), v = w(() => {
    var f;
    const p = (f = u.default) == null ? void 0 : f.call(u);
    if (d.value && (p == null ? void 0 : p.length) === 1) {
      const m = p[0];
      if ((m == null ? void 0 : m.type) === os) {
        const y = m.children;
        return new RegExp("^\\p{Unified_Ideograph}{2}$", "u").test(y.trim());
      }
    }
    return !1;
  });
  return {
    _disabled: s,
    _size: a,
    _type: l,
    _ref: i,
    _props: c,
    shouldAddSpace: v,
    handleClick: (f) => {
      if (s.value || e.loading) {
        f.stopPropagation();
        return;
      }
      e.nativeType === "reset" && (r == null || r.resetFields()), t("click", f);
    }
  };
}, Th = [
  "default",
  "primary",
  "success",
  "warning",
  "info",
  "danger",
  "text",
  ""
], Eh = ["button", "submit", "reset"], er = ee({
  size: Ks,
  disabled: Boolean,
  type: {
    type: String,
    values: Th,
    default: ""
  },
  icon: {
    type: Jt
  },
  nativeType: {
    type: String,
    values: Eh,
    default: "button"
  },
  loading: Boolean,
  loadingIcon: {
    type: Jt,
    default: () => ks
  },
  plain: Boolean,
  text: Boolean,
  link: Boolean,
  bg: Boolean,
  autofocus: Boolean,
  round: Boolean,
  circle: Boolean,
  color: String,
  dark: Boolean,
  autoInsertSpace: {
    type: Boolean,
    default: void 0
  },
  tag: {
    type: z([String, Object]),
    default: "button"
  }
}), kh = {
  click: (e) => e instanceof MouseEvent
};
function ae(e, t) {
  _h(e) && (e = "100%");
  var n = $h(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Wn(e) {
  return Math.min(1, Math.max(0, e));
}
function _h(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function $h(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function oi(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function qn(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Tt(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Ih(e, t, n) {
  return {
    r: ae(e, 255) * 255,
    g: ae(t, 255) * 255,
    b: ae(n, 255) * 255
  };
}
function qa(e, t, n) {
  e = ae(e, 255), t = ae(t, 255), n = ae(n, 255);
  var o = Math.max(e, t, n), r = Math.min(e, t, n), a = 0, s = 0, i = (o + r) / 2;
  if (o === r)
    s = 0, a = 0;
  else {
    var u = o - r;
    switch (s = i > 0.5 ? u / (2 - o - r) : u / (o + r), o) {
      case e:
        a = (t - n) / u + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / u + 2;
        break;
      case n:
        a = (e - t) / u + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s, l: i };
}
function Mo(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Ah(e, t, n) {
  var o, r, a;
  if (e = ae(e, 360), t = ae(t, 100), n = ae(n, 100), t === 0)
    r = n, a = n, o = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, i = 2 * n - s;
    o = Mo(i, s, e + 1 / 3), r = Mo(i, s, e), a = Mo(i, s, e - 1 / 3);
  }
  return { r: o * 255, g: r * 255, b: a * 255 };
}
function Za(e, t, n) {
  e = ae(e, 255), t = ae(t, 255), n = ae(n, 255);
  var o = Math.max(e, t, n), r = Math.min(e, t, n), a = 0, s = o, i = o - r, u = o === 0 ? 0 : i / o;
  if (o === r)
    a = 0;
  else {
    switch (o) {
      case e:
        a = (t - n) / i + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / i + 2;
        break;
      case n:
        a = (e - t) / i + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: u, v: s };
}
function Ph(e, t, n) {
  e = ae(e, 360) * 6, t = ae(t, 100), n = ae(n, 100);
  var o = Math.floor(e), r = e - o, a = n * (1 - t), s = n * (1 - r * t), i = n * (1 - (1 - r) * t), u = o % 6, l = [n, s, a, a, i, n][u], d = [i, n, n, s, a, a][u], c = [a, a, i, n, n, s][u];
  return { r: l * 255, g: d * 255, b: c * 255 };
}
function Ya(e, t, n, o) {
  var r = [
    Tt(Math.round(e).toString(16)),
    Tt(Math.round(t).toString(16)),
    Tt(Math.round(n).toString(16))
  ];
  return o && r[0].startsWith(r[0].charAt(1)) && r[1].startsWith(r[1].charAt(1)) && r[2].startsWith(r[2].charAt(1)) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
}
function Lh(e, t, n, o, r) {
  var a = [
    Tt(Math.round(e).toString(16)),
    Tt(Math.round(t).toString(16)),
    Tt(Math.round(n).toString(16)),
    Tt(Mh(o))
  ];
  return r && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function Mh(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Ja(e) {
  return pe(e) / 255;
}
function pe(e) {
  return parseInt(e, 16);
}
function Rh(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var tr = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Nh(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, o = null, r = null, a = null, s = !1, i = !1;
  return typeof e == "string" && (e = Dh(e)), typeof e == "object" && (We(e.r) && We(e.g) && We(e.b) ? (t = Ih(e.r, e.g, e.b), s = !0, i = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : We(e.h) && We(e.s) && We(e.v) ? (o = qn(e.s), r = qn(e.v), t = Ph(e.h, o, r), s = !0, i = "hsv") : We(e.h) && We(e.s) && We(e.l) && (o = qn(e.s), a = qn(e.l), t = Ah(e.h, o, a), s = !0, i = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = oi(n), {
    ok: s,
    format: e.format || i,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var Bh = "[-\\+]?\\d+%?", zh = "[-\\+]?\\d*\\.\\d+%?", gt = "(?:".concat(zh, ")|(?:").concat(Bh, ")"), Ro = "[\\s|\\(]+(".concat(gt, ")[,|\\s]+(").concat(gt, ")[,|\\s]+(").concat(gt, ")\\s*\\)?"), No = "[\\s|\\(]+(".concat(gt, ")[,|\\s]+(").concat(gt, ")[,|\\s]+(").concat(gt, ")[,|\\s]+(").concat(gt, ")\\s*\\)?"), Oe = {
  CSS_UNIT: new RegExp(gt),
  rgb: new RegExp("rgb" + Ro),
  rgba: new RegExp("rgba" + No),
  hsl: new RegExp("hsl" + Ro),
  hsla: new RegExp("hsla" + No),
  hsv: new RegExp("hsv" + Ro),
  hsva: new RegExp("hsva" + No),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Dh(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (tr[e])
    e = tr[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Oe.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Oe.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Oe.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Oe.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Oe.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Oe.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Oe.hex8.exec(e), n ? {
    r: pe(n[1]),
    g: pe(n[2]),
    b: pe(n[3]),
    a: Ja(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Oe.hex6.exec(e), n ? {
    r: pe(n[1]),
    g: pe(n[2]),
    b: pe(n[3]),
    format: t ? "name" : "hex"
  } : (n = Oe.hex4.exec(e), n ? {
    r: pe(n[1] + n[1]),
    g: pe(n[2] + n[2]),
    b: pe(n[3] + n[3]),
    a: Ja(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Oe.hex3.exec(e), n ? {
    r: pe(n[1] + n[1]),
    g: pe(n[2] + n[2]),
    b: pe(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function We(e) {
  return !!Oe.CSS_UNIT.exec(String(e));
}
var Hh = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var o;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = Rh(t)), this.originalInput = t;
      var r = Nh(t);
      this.originalInput = t, this.r = r.r, this.g = r.g, this.b = r.b, this.a = r.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (o = n.format) !== null && o !== void 0 ? o : r.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = r.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, o, r, a = t.r / 255, s = t.g / 255, i = t.b / 255;
      return a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? o = s / 12.92 : o = Math.pow((s + 0.055) / 1.055, 2.4), i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * o + 0.0722 * r;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = oi(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = Za(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = Za(this.r, this.g, this.b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), r = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(o, "%, ").concat(r, "%)") : "hsva(".concat(n, ", ").concat(o, "%, ").concat(r, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = qa(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = qa(this.r, this.g, this.b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), r = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(o, "%, ").concat(r, "%)") : "hsla(".concat(n, ", ").concat(o, "%, ").concat(r, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), Ya(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), Lh(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), o = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(o, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(o, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(ae(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(ae(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + Ya(this.r, this.g, this.b, !1), n = 0, o = Object.entries(tr); n < o.length; n++) {
        var r = o[n], a = r[0], s = r[1];
        if (t === s)
          return a;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var o = !1, r = this.a < 1 && this.a >= 0, a = !n && r && (t.startsWith("hex") || t === "name");
      return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (o = this.toRgbString()), t === "prgb" && (o = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (o = this.toHexString()), t === "hex3" && (o = this.toHexString(!0)), t === "hex4" && (o = this.toHex8String(!0)), t === "hex8" && (o = this.toHex8String()), t === "name" && (o = this.toName()), t === "hsl" && (o = this.toHslString()), t === "hsv" && (o = this.toHsvString()), o || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = Wn(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = Wn(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = Wn(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = Wn(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), o = (n.h + t) % 360;
      return n.h = o < 0 ? 360 + o : o, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var o = this.toRgb(), r = new e(t).toRgb(), a = n / 100, s = {
        r: (r.r - o.r) * a + o.r,
        g: (r.g - o.g) * a + o.g,
        b: (r.b - o.b) * a + o.b,
        a: (r.a - o.a) * a + o.a
      };
      return new e(s);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var o = this.toHsl(), r = 360 / n, a = [this];
      for (o.h = (o.h - (r * t >> 1) + 720) % 360; --t; )
        o.h = (o.h + r) % 360, a.push(new e(o));
      return a;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), o = n.h, r = n.s, a = n.v, s = [], i = 1 / t; t--; )
        s.push(new e({ h: o, s: r, v: a })), a = (a + i) % 1;
      return s;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), o = new e(t).toRgb(), r = n.a + o.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + o.r * o.a * (1 - n.a)) / r,
        g: (n.g * n.a + o.g * o.a * (1 - n.a)) / r,
        b: (n.b * n.a + o.b * o.a * (1 - n.a)) / r,
        a: r
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), o = n.h, r = [this], a = 360 / t, s = 1; s < t; s++)
        r.push(new e({ h: (o + s * a) % 360, s: n.s, l: n.l }));
      return r;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function ct(e, t = 20) {
  return e.mix("#141414", t).toString();
}
function Vh(e) {
  const t = Gs(), n = te("button");
  return w(() => {
    let o = {}, r = e.color;
    if (r) {
      const a = r.match(/var\((.*?)\)/);
      a && (r = window.getComputedStyle(window.document.documentElement).getPropertyValue(a[1]));
      const s = new Hh(r), i = e.dark ? s.tint(20).toString() : ct(s, 20);
      if (e.plain)
        o = n.cssVarBlock({
          "bg-color": e.dark ? ct(s, 90) : s.tint(90).toString(),
          "text-color": r,
          "border-color": e.dark ? ct(s, 50) : s.tint(50).toString(),
          "hover-text-color": `var(${n.cssVarName("color-white")})`,
          "hover-bg-color": r,
          "hover-border-color": r,
          "active-bg-color": i,
          "active-text-color": `var(${n.cssVarName("color-white")})`,
          "active-border-color": i
        }), t.value && (o[n.cssVarBlockName("disabled-bg-color")] = e.dark ? ct(s, 90) : s.tint(90).toString(), o[n.cssVarBlockName("disabled-text-color")] = e.dark ? ct(s, 50) : s.tint(50).toString(), o[n.cssVarBlockName("disabled-border-color")] = e.dark ? ct(s, 80) : s.tint(80).toString());
      else {
        const u = e.dark ? ct(s, 30) : s.tint(30).toString(), l = s.isDark() ? `var(${n.cssVarName("color-white")})` : `var(${n.cssVarName("color-black")})`;
        if (o = n.cssVarBlock({
          "bg-color": r,
          "text-color": l,
          "border-color": r,
          "hover-bg-color": u,
          "hover-text-color": l,
          "hover-border-color": u,
          "active-bg-color": i,
          "active-border-color": i
        }), t.value) {
          const d = e.dark ? ct(s, 50) : s.tint(50).toString();
          o[n.cssVarBlockName("disabled-bg-color")] = d, o[n.cssVarBlockName("disabled-text-color")] = e.dark ? "rgba(255, 255, 255, 0.5)" : `var(${n.cssVarName("color-white")})`, o[n.cssVarBlockName("disabled-border-color")] = d;
        }
      }
    }
    return o;
  });
}
const jh = M({
  name: "ElButton"
}), Uh = /* @__PURE__ */ M({
  ...jh,
  props: er,
  emits: kh,
  setup(e, { expose: t, emit: n }) {
    const o = e, r = Vh(o), a = te("button"), { _ref: s, _size: i, _type: u, _disabled: l, _props: d, shouldAddSpace: c, handleClick: v } = Oh(o, n), g = w(() => [
      a.b(),
      a.m(u.value),
      a.m(i.value),
      a.is("disabled", l.value),
      a.is("loading", o.loading),
      a.is("plain", o.plain),
      a.is("round", o.round),
      a.is("circle", o.circle),
      a.is("text", o.text),
      a.is("link", o.link),
      a.is("has-bg", o.bg)
    ]);
    return t({
      ref: s,
      size: i,
      type: u,
      disabled: l,
      shouldAddSpace: c
    }), (f, p) => (F(), j(tt(f.tag), Pt({
      ref_key: "_ref",
      ref: s
    }, h(d), {
      class: h(g),
      style: h(r),
      onClick: h(v)
    }), {
      default: R(() => [
        f.loading ? (F(), P(ot, { key: 0 }, [
          f.$slots.loading ? N(f.$slots, "loading", { key: 0 }) : (F(), j(h(on), {
            key: 1,
            class: $(h(a).is("loading"))
          }, {
            default: R(() => [
              (F(), j(tt(f.loadingIcon)))
            ]),
            _: 1
          }, 8, ["class"]))
        ], 64)) : f.icon || f.$slots.icon ? (F(), j(h(on), { key: 1 }, {
          default: R(() => [
            f.icon ? (F(), j(tt(f.icon), { key: 0 })) : N(f.$slots, "icon", { key: 1 })
          ]),
          _: 3
        })) : G("v-if", !0),
        f.$slots.default ? (F(), P("span", {
          key: 2,
          class: $({ [h(a).em("text", "expand")]: h(c) })
        }, [
          N(f.$slots, "default")
        ], 2)) : G("v-if", !0)
      ]),
      _: 3
    }, 16, ["class", "style", "onClick"]));
  }
});
var Kh = /* @__PURE__ */ J(Uh, [["__file", "button.vue"]]);
const Gh = {
  size: er.size,
  type: er.type
}, Wh = M({
  name: "ElButtonGroup"
}), qh = /* @__PURE__ */ M({
  ...Wh,
  props: Gh,
  setup(e) {
    const t = e;
    ye(ni, $t({
      size: Re(t, "size"),
      type: Re(t, "type")
    }));
    const n = te("button");
    return (o, r) => (F(), P("div", {
      class: $(h(n).b("group"))
    }, [
      N(o.$slots, "default")
    ], 2));
  }
});
var ri = /* @__PURE__ */ J(qh, [["__file", "button-group.vue"]]);
const Pn = _e(Kh, {
  ButtonGroup: ri
});
po(ri);
const ft = /* @__PURE__ */ new Map();
if (se) {
  let e;
  document.addEventListener("mousedown", (t) => e = t), document.addEventListener("mouseup", (t) => {
    if (e) {
      for (const n of ft.values())
        for (const { documentHandler: o } of n)
          o(t, e);
      e = void 0;
    }
  });
}
function Xa(e, t) {
  let n = [];
  return Array.isArray(t.arg) ? n = t.arg : kt(t.arg) && n.push(t.arg), function(o, r) {
    const a = t.instance.popperRef, s = o.target, i = r == null ? void 0 : r.target, u = !t || !t.instance, l = !s || !i, d = e.contains(s) || e.contains(i), c = e === s, v = n.length && n.some((f) => f == null ? void 0 : f.contains(s)) || n.length && n.includes(i), g = a && (a.contains(s) || a.contains(i));
    u || l || d || c || v || g || t.value(o, r);
  };
}
const Zh = {
  beforeMount(e, t) {
    ft.has(e) || ft.set(e, []), ft.get(e).push({
      documentHandler: Xa(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    ft.has(e) || ft.set(e, []);
    const n = ft.get(e), o = n.findIndex((a) => a.bindingFn === t.oldValue), r = {
      documentHandler: Xa(e, t),
      bindingFn: t.value
    };
    o >= 0 ? n.splice(o, 1, r) : n.push(r);
  },
  unmounted(e) {
    ft.delete(e);
  }
}, nr = ee({
  type: {
    type: String,
    values: ["primary", "success", "info", "warning", "danger"],
    default: "primary"
  },
  closable: Boolean,
  disableTransitions: Boolean,
  hit: Boolean,
  color: String,
  size: {
    type: String,
    values: $s
  },
  effect: {
    type: String,
    values: ["dark", "light", "plain"],
    default: "light"
  },
  round: Boolean
}), Yh = {
  close: (e) => e instanceof MouseEvent,
  click: (e) => e instanceof MouseEvent
}, Jh = M({
  name: "ElTag"
}), Xh = /* @__PURE__ */ M({
  ...Jh,
  props: nr,
  emits: Yh,
  setup(e, { emit: t }) {
    const n = e, o = kr(), r = te("tag"), a = w(() => {
      const { type: l, hit: d, effect: c, closable: v, round: g } = n;
      return [
        r.b(),
        r.is("closable", v),
        r.m(l || "primary"),
        r.m(o.value),
        r.m(c),
        r.is("hit", d),
        r.is("round", g)
      ];
    }), s = (l) => {
      t("close", l);
    }, i = (l) => {
      t("click", l);
    }, u = (l) => {
      l.component.subTree.component.bum = null;
    };
    return (l, d) => l.disableTransitions ? (F(), P("span", {
      key: 0,
      class: $(h(a)),
      style: ze({ backgroundColor: l.color }),
      onClick: i
    }, [
      B("span", {
        class: $(h(r).e("content"))
      }, [
        N(l.$slots, "default")
      ], 2),
      l.closable ? (F(), j(h(on), {
        key: 0,
        class: $(h(r).e("close")),
        onClick: ve(s, ["stop"])
      }, {
        default: R(() => [
          U(h(Fa))
        ]),
        _: 1
      }, 8, ["class", "onClick"])) : G("v-if", !0)
    ], 6)) : (F(), j(oo, {
      key: 1,
      name: `${h(r).namespace.value}-zoom-in-center`,
      appear: "",
      onVnodeMounted: u
    }, {
      default: R(() => [
        B("span", {
          class: $(h(a)),
          style: ze({ backgroundColor: l.color }),
          onClick: i
        }, [
          B("span", {
            class: $(h(r).e("content"))
          }, [
            N(l.$slots, "default")
          ], 2),
          l.closable ? (F(), j(h(on), {
            key: 0,
            class: $(h(r).e("close")),
            onClick: ve(s, ["stop"])
          }, {
            default: R(() => [
              U(h(Fa))
            ]),
            _: 1
          }, 8, ["class", "onClick"])) : G("v-if", !0)
        ], 6)
      ]),
      _: 3
    }, 8, ["name"]));
  }
});
var Qh = /* @__PURE__ */ J(Xh, [["__file", "tag.vue"]]);
const eg = _e(Qh), Qa = (e) => xe(e) || an(e) || Ne(e), tg = ee({
  accordion: Boolean,
  modelValue: {
    type: z([Array, String, Number]),
    default: () => hp([])
  }
}), ng = {
  [ht]: Qa,
  [vo]: Qa
}, ai = Symbol("collapseContextKey"), og = (e, t) => {
  const n = E(Me(e.modelValue)), o = (a) => {
    n.value = a;
    const s = e.accordion ? n.value[0] : n.value;
    t(ht, s), t(vo, s);
  }, r = (a) => {
    if (e.accordion)
      o([n.value[0] === a ? "" : a]);
    else {
      const s = [...n.value], i = s.indexOf(a);
      i > -1 ? s.splice(i, 1) : s.push(a), o(s);
    }
  };
  return V(() => e.modelValue, () => n.value = Me(e.modelValue), { deep: !0 }), ye(ai, {
    activeNames: n,
    handleItemClick: r
  }), {
    activeNames: n,
    setActiveNames: o
  };
}, rg = () => {
  const e = te("collapse");
  return {
    rootKls: w(() => e.b())
  };
}, ag = M({
  name: "ElCollapse"
}), sg = /* @__PURE__ */ M({
  ...ag,
  props: tg,
  emits: ng,
  setup(e, { expose: t, emit: n }) {
    const o = e, { activeNames: r, setActiveNames: a } = og(o, n), { rootKls: s } = rg();
    return t({
      activeNames: r,
      setActiveNames: a
    }), (i, u) => (F(), P("div", {
      class: $(h(s))
    }, [
      N(i.$slots, "default")
    ], 2));
  }
});
var ig = /* @__PURE__ */ J(sg, [["__file", "collapse.vue"]]);
const lg = M({
  name: "ElCollapseTransition"
}), ug = /* @__PURE__ */ M({
  ...lg,
  setup(e) {
    const t = te("collapse-transition"), n = (r) => {
      r.style.maxHeight = "", r.style.overflow = r.dataset.oldOverflow, r.style.paddingTop = r.dataset.oldPaddingTop, r.style.paddingBottom = r.dataset.oldPaddingBottom;
    }, o = {
      beforeEnter(r) {
        r.dataset || (r.dataset = {}), r.dataset.oldPaddingTop = r.style.paddingTop, r.dataset.oldPaddingBottom = r.style.paddingBottom, r.style.height && (r.dataset.elExistsHeight = r.style.height), r.style.maxHeight = 0, r.style.paddingTop = 0, r.style.paddingBottom = 0;
      },
      enter(r) {
        requestAnimationFrame(() => {
          r.dataset.oldOverflow = r.style.overflow, r.dataset.elExistsHeight ? r.style.maxHeight = r.dataset.elExistsHeight : r.scrollHeight !== 0 ? r.style.maxHeight = `${r.scrollHeight}px` : r.style.maxHeight = 0, r.style.paddingTop = r.dataset.oldPaddingTop, r.style.paddingBottom = r.dataset.oldPaddingBottom, r.style.overflow = "hidden";
        });
      },
      afterEnter(r) {
        r.style.maxHeight = "", r.style.overflow = r.dataset.oldOverflow;
      },
      enterCancelled(r) {
        n(r);
      },
      beforeLeave(r) {
        r.dataset || (r.dataset = {}), r.dataset.oldPaddingTop = r.style.paddingTop, r.dataset.oldPaddingBottom = r.style.paddingBottom, r.dataset.oldOverflow = r.style.overflow, r.style.maxHeight = `${r.scrollHeight}px`, r.style.overflow = "hidden";
      },
      leave(r) {
        r.scrollHeight !== 0 && (r.style.maxHeight = 0, r.style.paddingTop = 0, r.style.paddingBottom = 0);
      },
      afterLeave(r) {
        n(r);
      },
      leaveCancelled(r) {
        n(r);
      }
    };
    return (r, a) => (F(), j(oo, Pt({
      name: h(t).b()
    }, Tl(o)), {
      default: R(() => [
        N(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["name"]));
  }
});
var cg = /* @__PURE__ */ J(ug, [["__file", "collapse-transition.vue"]]);
const dg = _e(cg), fg = ee({
  title: {
    type: String,
    default: ""
  },
  name: {
    type: z([String, Number]),
    default: void 0
  },
  icon: {
    type: Jt,
    default: ap
  },
  disabled: Boolean
}), pg = (e) => {
  const t = W(ai), { namespace: n } = te("collapse"), o = E(!1), r = E(!1), a = Tr(), s = w(() => a.current++), i = w(() => {
    var v;
    return (v = e.name) != null ? v : `${n.value}-id-${a.prefix}-${h(s)}`;
  }), u = w(() => t == null ? void 0 : t.activeNames.value.includes(h(i)));
  return {
    focusing: o,
    id: s,
    isActive: u,
    handleFocus: () => {
      setTimeout(() => {
        r.value ? r.value = !1 : o.value = !0;
      }, 50);
    },
    handleHeaderClick: () => {
      e.disabled || (t == null || t.handleItemClick(h(i)), o.value = !1, r.value = !0);
    },
    handleEnterClick: () => {
      t == null || t.handleItemClick(h(i));
    }
  };
}, vg = (e, { focusing: t, isActive: n, id: o }) => {
  const r = te("collapse"), a = w(() => [
    r.b("item"),
    r.is("active", h(n)),
    r.is("disabled", e.disabled)
  ]), s = w(() => [
    r.be("item", "header"),
    r.is("active", h(n)),
    { focusing: h(t) && !e.disabled }
  ]), i = w(() => [
    r.be("item", "arrow"),
    r.is("active", h(n))
  ]), u = w(() => r.be("item", "wrap")), l = w(() => r.be("item", "content")), d = w(() => r.b(`content-${h(o)}`)), c = w(() => r.b(`head-${h(o)}`));
  return {
    arrowKls: i,
    headKls: s,
    rootKls: a,
    itemWrapperKls: u,
    itemContentKls: l,
    scopedContentId: d,
    scopedHeadId: c
  };
}, hg = M({
  name: "ElCollapseItem"
}), gg = /* @__PURE__ */ M({
  ...hg,
  props: fg,
  setup(e, { expose: t }) {
    const n = e, {
      focusing: o,
      id: r,
      isActive: a,
      handleFocus: s,
      handleHeaderClick: i,
      handleEnterClick: u
    } = pg(n), {
      arrowKls: l,
      headKls: d,
      rootKls: c,
      itemWrapperKls: v,
      itemContentKls: g,
      scopedContentId: f,
      scopedHeadId: p
    } = vg(n, { focusing: o, isActive: a, id: r });
    return t({
      isActive: a
    }), (m, y) => (F(), P("div", {
      class: $(h(c))
    }, [
      B("button", {
        id: h(p),
        class: $(h(d)),
        "aria-expanded": h(a),
        "aria-controls": h(f),
        "aria-describedby": h(f),
        tabindex: m.disabled ? -1 : 0,
        type: "button",
        onClick: h(i),
        onKeydown: Kt(ve(h(u), ["stop", "prevent"]), ["space", "enter"]),
        onFocus: h(s),
        onBlur: (C) => o.value = !1
      }, [
        N(m.$slots, "title", {}, () => [
          It(ge(m.title), 1)
        ]),
        N(m.$slots, "icon", { isActive: h(a) }, () => [
          U(h(on), {
            class: $(h(l))
          }, {
            default: R(() => [
              (F(), j(tt(m.icon)))
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ], 42, ["id", "aria-expanded", "aria-controls", "aria-describedby", "tabindex", "onClick", "onKeydown", "onFocus", "onBlur"]),
      U(h(dg), null, {
        default: R(() => [
          et(B("div", {
            id: h(f),
            role: "region",
            class: $(h(v)),
            "aria-hidden": !h(a),
            "aria-labelledby": h(p)
          }, [
            B("div", {
              class: $(h(g))
            }, [
              N(m.$slots, "default")
            ], 2)
          ], 10, ["id", "aria-hidden", "aria-labelledby"]), [
            [rn, h(a)]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
});
var si = /* @__PURE__ */ J(gg, [["__file", "collapse-item.vue"]]);
const ii = _e(ig, {
  CollapseItem: si
}), li = po(si), mg = /* @__PURE__ */ M({
  inheritAttrs: !1
});
function yg(e, t, n, o, r, a) {
  return N(e.$slots, "default");
}
var bg = /* @__PURE__ */ J(mg, [["render", yg], ["__file", "collection.vue"]]);
const wg = /* @__PURE__ */ M({
  name: "ElCollectionItem",
  inheritAttrs: !1
});
function xg(e, t, n, o, r, a) {
  return N(e.$slots, "default");
}
var Fg = /* @__PURE__ */ J(wg, [["render", xg], ["__file", "collection-item.vue"]]);
const Cg = "data-el-collection-item", Sg = (e) => {
  const t = `El${e}Collection`, n = `${t}Item`, o = Symbol(t), r = Symbol(n), a = {
    ...bg,
    name: t,
    setup() {
      const i = E(null), u = /* @__PURE__ */ new Map();
      ye(o, {
        itemMap: u,
        getItems: () => {
          const d = h(i);
          if (!d)
            return [];
          const c = Array.from(d.querySelectorAll(`[${Cg}]`));
          return [...u.values()].sort((g, f) => c.indexOf(g.ref) - c.indexOf(f.ref));
        },
        collectionRef: i
      });
    }
  }, s = {
    ...Fg,
    name: n,
    setup(i, { attrs: u }) {
      const l = E(null), d = W(o, void 0);
      ye(r, {
        collectionItemRef: l
      }), ie(() => {
        const c = h(l);
        c && d.itemMap.set(c, {
          ref: c,
          ...u
        });
      }), ke(() => {
        const c = h(l);
        d.itemMap.delete(c);
      });
    }
  };
  return {
    COLLECTION_INJECTION_KEY: o,
    COLLECTION_ITEM_INJECTION_KEY: r,
    ElCollection: a,
    ElCollectionItem: s
  };
}, Bo = ee({
  trigger: _n.trigger,
  effect: {
    ...he.effect,
    default: "light"
  },
  type: {
    type: z(String)
  },
  placement: {
    type: z(String),
    default: "bottom"
  },
  popperOptions: {
    type: z(Object),
    default: () => ({})
  },
  id: String,
  size: {
    type: String,
    default: ""
  },
  splitButton: Boolean,
  hideOnClick: {
    type: Boolean,
    default: !0
  },
  loop: {
    type: Boolean,
    default: !0
  },
  showTimeout: {
    type: Number,
    default: 150
  },
  hideTimeout: {
    type: Number,
    default: 150
  },
  tabindex: {
    type: z([Number, String]),
    default: 0
  },
  maxHeight: {
    type: z([Number, String]),
    default: ""
  },
  popperClass: {
    type: String,
    default: ""
  },
  disabled: Boolean,
  role: {
    type: String,
    default: "menu"
  },
  buttonProps: {
    type: z(Object)
  },
  teleported: he.teleported
});
ee({
  command: {
    type: [Object, String, Number],
    default: () => ({})
  },
  disabled: Boolean,
  divided: Boolean,
  textValue: String,
  icon: {
    type: Jt
  }
});
ee({
  onKeydown: { type: z(Function) }
});
Sg("Dropdown");
const ui = Symbol("ElSelectGroup"), wo = Symbol("ElSelect");
function Og(e, t) {
  const n = W(wo), o = W(ui, { disabled: !1 }), r = w(() => d(Me(n.props.modelValue), e.value)), a = w(() => {
    var g;
    if (n.props.multiple) {
      const f = Me((g = n.props.modelValue) != null ? g : []);
      return !r.value && f.length >= n.props.multipleLimit && n.props.multipleLimit > 0;
    } else
      return !1;
  }), s = w(() => e.label || (Be(e.value) ? "" : e.value)), i = w(() => e.value || e.label || ""), u = w(() => e.disabled || t.groupDisabled || a.value), l = me(), d = (g = [], f) => {
    if (Be(e.value)) {
      const p = n.props.valueKey;
      return g && g.some((m) => sr(Je(m, p)) === Je(f, p));
    } else
      return g && g.includes(f);
  }, c = () => {
    !e.disabled && !o.disabled && (n.states.hoveringIndex = n.optionsArray.indexOf(l.proxy));
  }, v = (g) => {
    const f = new RegExp(Xf(g), "i");
    t.visible = f.test(s.value) || e.created;
  };
  return V(() => s.value, () => {
    !e.created && !n.props.remote && n.setSelected();
  }), V(() => e.value, (g, f) => {
    const { remote: p, valueKey: m } = n.props;
    if (g !== f && (n.onOptionDestroy(f, l.proxy), n.onOptionCreate(l.proxy)), !e.created && !p) {
      if (m && Be(g) && Be(f) && g[m] === f[m])
        return;
      n.setSelected();
    }
  }), V(() => o.disabled, () => {
    t.groupDisabled = o.disabled;
  }, { immediate: !0 }), {
    select: n,
    currentLabel: s,
    currentValue: i,
    itemSelected: r,
    isDisabled: u,
    hoverItem: c,
    updateOption: v
  };
}
const Tg = M({
  name: "ElOption",
  componentName: "ElOption",
  props: {
    value: {
      required: !0,
      type: [String, Number, Boolean, Object]
    },
    label: [String, Number],
    created: Boolean,
    disabled: Boolean
  },
  setup(e) {
    const t = te("select"), n = mo(), o = w(() => [
      t.be("dropdown", "item"),
      t.is("disabled", h(i)),
      t.is("selected", h(s)),
      t.is("hovering", h(v))
    ]), r = $t({
      index: -1,
      groupDisabled: !1,
      visible: !0,
      hover: !1
    }), {
      currentLabel: a,
      itemSelected: s,
      isDisabled: i,
      select: u,
      hoverItem: l,
      updateOption: d
    } = Og(e, r), { visible: c, hover: v } = ir(r), g = me().proxy;
    u.onOptionCreate(g), ke(() => {
      const p = g.value, { selected: m } = u.states, C = (u.props.multiple ? m : [m]).some((I) => I.value === g.value);
      we(() => {
        u.states.cachedOptions.get(p) === g && !C && u.states.cachedOptions.delete(p);
      }), u.onOptionDestroy(p, g);
    });
    function f() {
      i.value || u.handleOptionSelect(g);
    }
    return {
      ns: t,
      id: n,
      containerKls: o,
      currentLabel: a,
      itemSelected: s,
      isDisabled: i,
      select: u,
      hoverItem: l,
      updateOption: d,
      visible: c,
      hover: v,
      selectOptionClick: f,
      states: r
    };
  }
});
function Eg(e, t, n, o, r, a) {
  return et((F(), P("li", {
    id: e.id,
    class: $(e.containerKls),
    role: "option",
    "aria-disabled": e.isDisabled || void 0,
    "aria-selected": e.itemSelected,
    onMouseenter: e.hoverItem,
    onClick: ve(e.selectOptionClick, ["stop"])
  }, [
    N(e.$slots, "default", {}, () => [
      B("span", null, ge(e.currentLabel), 1)
    ])
  ], 42, ["id", "aria-disabled", "aria-selected", "onMouseenter", "onClick"])), [
    [rn, e.visible]
  ]);
}
var Lr = /* @__PURE__ */ J(Tg, [["render", Eg], ["__file", "option.vue"]]);
const kg = M({
  name: "ElSelectDropdown",
  componentName: "ElSelectDropdown",
  setup() {
    const e = W(wo), t = te("select"), n = w(() => e.props.popperClass), o = w(() => e.props.multiple), r = w(() => e.props.fitInputWidth), a = E("");
    function s() {
      var i;
      a.value = `${(i = e.selectRef) == null ? void 0 : i.offsetWidth}px`;
    }
    return ie(() => {
      s(), pt(e.selectRef, s);
    }), {
      ns: t,
      minWidth: a,
      popperClass: n,
      isMultiple: o,
      isFitInputWidth: r
    };
  }
});
function _g(e, t, n, o, r, a) {
  return F(), P("div", {
    class: $([e.ns.b("dropdown"), e.ns.is("multiple", e.isMultiple), e.popperClass]),
    style: ze({ [e.isFitInputWidth ? "width" : "minWidth"]: e.minWidth })
  }, [
    e.$slots.header ? (F(), P("div", {
      key: 0,
      class: $(e.ns.be("dropdown", "header"))
    }, [
      N(e.$slots, "header")
    ], 2)) : G("v-if", !0),
    N(e.$slots, "default"),
    e.$slots.footer ? (F(), P("div", {
      key: 1,
      class: $(e.ns.be("dropdown", "footer"))
    }, [
      N(e.$slots, "footer")
    ], 2)) : G("v-if", !0)
  ], 6);
}
var $g = /* @__PURE__ */ J(kg, [["render", _g], ["__file", "select-dropdown.vue"]]);
const Ig = 11, Ag = (e, t) => {
  const { t: n } = Fp(), o = mo(), r = te("select"), a = te("input"), s = $t({
    inputValue: "",
    options: /* @__PURE__ */ new Map(),
    cachedOptions: /* @__PURE__ */ new Map(),
    disabledOptions: /* @__PURE__ */ new Map(),
    optionValues: [],
    selected: [],
    selectionWidth: 0,
    calculatorWidth: 0,
    collapseItemWidth: 0,
    selectedLabel: "",
    hoveringIndex: -1,
    previousQuery: null,
    inputHovering: !1,
    menuVisibleOnFocus: !1,
    isBeforeHide: !1
  }), i = E(null), u = E(null), l = E(null), d = E(null), c = E(null), v = E(null), g = E(null), f = E(null), p = E(null), m = E(null), y = E(null), C = E(null), {
    isComposing: I,
    handleCompositionStart: S,
    handleCompositionUpdate: x,
    handleCompositionEnd: O
  } = G0({
    afterComposition: (b) => hn(b)
  }), { wrapperRef: k, isFocused: A } = K0(c, {
    beforeFocus() {
      return _.value;
    },
    afterFocus() {
      e.automaticDropdown && !L.value && (L.value = !0, s.menuVisibleOnFocus = !0);
    },
    beforeBlur(b) {
      var T, D;
      return ((T = l.value) == null ? void 0 : T.isFocusInsideContent(b)) || ((D = d.value) == null ? void 0 : D.isFocusInsideContent(b));
    },
    afterBlur() {
      L.value = !1, s.menuVisibleOnFocus = !1;
    }
  }), L = E(!1), H = E(), { form: Z, formItem: K } = Ws(), { inputId: X } = sv(e, {
    formItemContext: K
  }), { valueOnClear: be, isEmptyValue: re } = X0(e), _ = w(() => e.disabled || (Z == null ? void 0 : Z.disabled)), q = w(() => Ne(e.modelValue) ? e.modelValue.length > 0 : !re(e.modelValue)), Ke = w(() => e.clearable && !_.value && s.inputHovering && q.value), fe = w(() => e.remote && e.filterable && !e.remoteShowSuffix ? "" : e.suffixIcon), Nt = w(() => r.is("reverse", fe.value && L.value)), Bt = w(() => (K == null ? void 0 : K.validateState) || ""), bt = w(() => fp[Bt.value]), zt = w(() => e.remote ? 300 : 0), Ie = w(() => e.loading ? e.loadingText || n("el.select.loading") : e.remote && !s.inputValue && s.options.size === 0 ? !1 : e.filterable && s.inputValue && s.options.size > 0 && le.value === 0 ? e.noMatchText || n("el.select.noMatch") : s.options.size === 0 ? e.noDataText || n("el.select.noData") : null), le = w(() => oe.value.filter((b) => b.visible).length), oe = w(() => {
    const b = Array.from(s.options.values()), T = [];
    return s.optionValues.forEach((D) => {
      const Y = b.findIndex((ut) => ut.value === D);
      Y > -1 && T.push(b[Y]);
    }), T.length >= b.length ? T : b;
  }), wt = w(() => Array.from(s.cachedOptions.values())), lt = w(() => {
    const b = oe.value.filter((T) => !T.created).some((T) => T.currentLabel === s.inputValue);
    return e.filterable && e.allowCreate && s.inputValue !== "" && !b;
  }), Ln = () => {
    e.filterable && ue(e.filterMethod) || e.filterable && e.remote && ue(e.remoteMethod) || oe.value.forEach((b) => {
      var T;
      (T = b.updateOption) == null || T.call(b, s.inputValue);
    });
  }, Mn = kr(), cn = w(() => ["small"].includes(Mn.value) ? "small" : "default"), Fo = w({
    get() {
      return L.value && Ie.value !== !1;
    },
    set(b) {
      L.value = b;
    }
  }), Rn = w(() => {
    if (e.multiple && !wn(e.modelValue))
      return Me(e.modelValue).length === 0 && !s.inputValue;
    const b = Ne(e.modelValue) ? e.modelValue[0] : e.modelValue;
    return e.filterable || wn(b) ? !s.inputValue : !0;
  }), Co = w(() => {
    var b;
    const T = (b = e.placeholder) != null ? b : n("el.select.placeholder");
    return e.multiple || !q.value ? T : s.selectedLabel;
  }), So = w(() => Ho ? null : "mouseenter");
  V(() => e.modelValue, (b, T) => {
    e.multiple && e.filterable && !e.reserveKeyword && (s.inputValue = "", xt("")), Dt(), !Yo(b, T) && e.validateEvent && (K == null || K.validate("change").catch((D) => Ve(D)));
  }, {
    flush: "post",
    deep: !0
  }), V(() => L.value, (b) => {
    b ? xt(s.inputValue) : (s.inputValue = "", s.previousQuery = null, s.isBeforeHide = !0), t("visible-change", b);
  }), V(() => s.options.entries(), () => {
    var b;
    if (!se)
      return;
    const T = ((b = i.value) == null ? void 0 : b.querySelectorAll("input")) || [];
    (!e.filterable && !e.defaultFirstOption && !wn(e.modelValue) || !Array.from(T).includes(document.activeElement)) && Dt(), e.defaultFirstOption && (e.filterable || e.remote) && le.value && dn();
  }, {
    flush: "post"
  }), V(() => s.hoveringIndex, (b) => {
    xe(b) && b > -1 ? H.value = oe.value[b] || {} : H.value = {}, oe.value.forEach((T) => {
      T.hover = H.value === T;
    });
  }), El(() => {
    s.isBeforeHide || Ln();
  });
  const xt = (b) => {
    s.previousQuery === b || I.value || (s.previousQuery = b, e.filterable && ue(e.filterMethod) ? e.filterMethod(b) : e.filterable && e.remote && ue(e.remoteMethod) && e.remoteMethod(b), e.defaultFirstOption && (e.filterable || e.remote) && le.value ? we(dn) : we(Ge));
  }, dn = () => {
    const b = oe.value.filter((Y) => Y.visible && !Y.disabled && !Y.states.groupDisabled), T = b.find((Y) => Y.created), D = b[0];
    s.hoveringIndex = Br(oe.value, T || D);
  }, Dt = () => {
    if (e.multiple)
      s.selectedLabel = "";
    else {
      const T = Ne(e.modelValue) ? e.modelValue[0] : e.modelValue, D = Nn(T);
      s.selectedLabel = D.currentLabel, s.selected = [D];
      return;
    }
    const b = [];
    wn(e.modelValue) || Me(e.modelValue).forEach((T) => {
      b.push(Nn(T));
    }), s.selected = b;
  }, Nn = (b) => {
    let T;
    const D = To(b).toLowerCase() === "object", Y = To(b).toLowerCase() === "null", ut = To(b).toLowerCase() === "undefined";
    for (let Ct = s.cachedOptions.size - 1; Ct >= 0; Ct--) {
      const Ae = wt.value[Ct];
      if (D ? Je(Ae.value, e.valueKey) === Je(b, e.valueKey) : Ae.value === b) {
        T = {
          value: b,
          currentLabel: Ae.currentLabel,
          get isDisabled() {
            return Ae.isDisabled;
          }
        };
        break;
      }
    }
    if (T)
      return T;
    const Vt = D ? b.label : !Y && !ut ? b : "";
    return {
      value: b,
      currentLabel: Vt
    };
  }, Ge = () => {
    s.hoveringIndex = oe.value.findIndex((b) => s.selected.some((T) => Oo(T) === Oo(b)));
  }, Ht = () => {
    s.selectionWidth = u.value.getBoundingClientRect().width;
  }, fn = () => {
    s.calculatorWidth = v.value.getBoundingClientRect().width;
  }, Bn = () => {
    s.collapseItemWidth = y.value.getBoundingClientRect().width;
  }, Ft = () => {
    var b, T;
    (T = (b = l.value) == null ? void 0 : b.updatePopper) == null || T.call(b);
  }, pn = () => {
    var b, T;
    (T = (b = d.value) == null ? void 0 : b.updatePopper) == null || T.call(b);
  }, vn = () => {
    s.inputValue.length > 0 && !L.value && (L.value = !0), xt(s.inputValue);
  }, hn = (b) => {
    if (s.inputValue = b.target.value, e.remote)
      gn();
    else
      return vn();
  }, gn = Uf(() => {
    vn();
  }, zt.value), mn = (b) => {
    Yo(e.modelValue, b) || t(vo, b);
  }, qi = (b) => Kf(b, (T) => !s.disabledOptions.has(T)), Zi = (b) => {
    if (e.multiple && b.code !== Tn.delete && b.target.value.length <= 0) {
      const T = Me(e.modelValue).slice(), D = qi(T);
      if (D < 0)
        return;
      const Y = T[D];
      T.splice(D, 1), t(ht, T), mn(T), t("remove-tag", Y);
    }
  }, Yi = (b, T) => {
    const D = s.selected.indexOf(T);
    if (D > -1 && !_.value) {
      const Y = Me(e.modelValue).slice();
      Y.splice(D, 1), t(ht, Y), mn(Y), t("remove-tag", T.value);
    }
    b.stopPropagation(), Dn();
  }, Rr = (b) => {
    b.stopPropagation();
    const T = e.multiple ? [] : be.value;
    if (e.multiple)
      for (const D of s.selected)
        D.isDisabled && T.push(D.value);
    t(ht, T), mn(T), s.hoveringIndex = -1, L.value = !1, t("clear"), Dn();
  }, Nr = (b) => {
    var T;
    if (e.multiple) {
      const D = Me((T = e.modelValue) != null ? T : []).slice(), Y = Br(D, b.value);
      Y > -1 ? D.splice(Y, 1) : (e.multipleLimit <= 0 || D.length < e.multipleLimit) && D.push(b.value), t(ht, D), mn(D), b.created && xt(""), e.filterable && !e.reserveKeyword && (s.inputValue = "");
    } else
      t(ht, b.value), mn(b.value), L.value = !1;
    Dn(), !L.value && we(() => {
      zn(b);
    });
  }, Br = (b = [], T) => {
    if (!Be(T))
      return b.indexOf(T);
    const D = e.valueKey;
    let Y = -1;
    return b.some((ut, Vt) => sr(Je(ut, D)) === Je(T, D) ? (Y = Vt, !0) : !1), Y;
  }, zn = (b) => {
    var T, D, Y, ut, Vt;
    const Hn = Ne(b) ? b[0] : b;
    let Ct = null;
    if (Hn != null && Hn.value) {
      const Ae = oe.value.filter((Vr) => Vr.value === Hn.value);
      Ae.length > 0 && (Ct = Ae[0].$el);
    }
    if (l.value && Ct) {
      const Ae = (ut = (Y = (D = (T = l.value) == null ? void 0 : T.popperRef) == null ? void 0 : D.contentRef) == null ? void 0 : Y.querySelector) == null ? void 0 : ut.call(Y, `.${r.be("dropdown", "wrap")}`);
      Ae && tp(Ae, Ct);
    }
    (Vt = C.value) == null || Vt.handleScroll();
  }, Ji = (b) => {
    s.options.set(b.value, b), s.cachedOptions.set(b.value, b), b.disabled && s.disabledOptions.set(b.value, b);
  }, Xi = (b, T) => {
    s.options.get(b) === T && s.options.delete(b);
  }, Qi = w(() => {
    var b, T;
    return (T = (b = l.value) == null ? void 0 : b.popperRef) == null ? void 0 : T.contentRef;
  }), el = () => {
    s.isBeforeHide = !1, we(() => zn(s.selected));
  }, Dn = () => {
    var b;
    (b = c.value) == null || b.focus();
  }, zr = () => {
    var b;
    (b = c.value) == null || b.blur();
  }, tl = (b) => {
    Rr(b);
  }, nl = () => {
    L.value = !1, A.value && zr();
  }, ol = () => {
    s.inputValue.length > 0 ? s.inputValue = "" : L.value = !1;
  }, Dr = () => {
    _.value || (Ho && (s.inputHovering = !0), s.menuVisibleOnFocus ? s.menuVisibleOnFocus = !1 : L.value = !L.value);
  }, rl = () => {
    L.value ? oe.value[s.hoveringIndex] && Nr(oe.value[s.hoveringIndex]) : Dr();
  }, Oo = (b) => Be(b.value) ? Je(b.value, e.valueKey) : b.value, al = w(() => oe.value.filter((b) => b.visible).every((b) => b.disabled)), sl = w(() => e.multiple ? e.collapseTags ? s.selected.slice(0, e.maxCollapseTags) : s.selected : []), il = w(() => e.multiple ? e.collapseTags ? s.selected.slice(e.maxCollapseTags) : [] : []), Hr = (b) => {
    if (!L.value) {
      L.value = !0;
      return;
    }
    if (!(s.options.size === 0 || s.filteredOptionsCount === 0 || I.value) && !al.value) {
      b === "next" ? (s.hoveringIndex++, s.hoveringIndex === s.options.size && (s.hoveringIndex = 0)) : b === "prev" && (s.hoveringIndex--, s.hoveringIndex < 0 && (s.hoveringIndex = s.options.size - 1));
      const T = oe.value[s.hoveringIndex];
      (T.disabled === !0 || T.states.groupDisabled === !0 || !T.visible) && Hr(b), we(() => zn(H.value));
    }
  }, ll = () => {
    if (!u.value)
      return 0;
    const b = window.getComputedStyle(u.value);
    return Number.parseFloat(b.gap || "6px");
  }, ul = w(() => {
    const b = ll();
    return { maxWidth: `${y.value && e.maxCollapseTags === 1 ? s.selectionWidth - s.collapseItemWidth - b : s.selectionWidth}px` };
  }), cl = w(() => ({ maxWidth: `${s.selectionWidth}px` })), dl = w(() => ({
    width: `${Math.max(s.calculatorWidth, Ig)}px`
  }));
  return pt(u, Ht), pt(v, fn), pt(p, Ft), pt(k, Ft), pt(m, pn), pt(y, Bn), ie(() => {
    Dt();
  }), {
    inputId: X,
    contentId: o,
    nsSelect: r,
    nsInput: a,
    states: s,
    isFocused: A,
    expanded: L,
    optionsArray: oe,
    hoverOption: H,
    selectSize: Mn,
    filteredOptionsCount: le,
    resetCalculatorWidth: fn,
    updateTooltip: Ft,
    updateTagTooltip: pn,
    debouncedOnInputChange: gn,
    onInput: hn,
    deletePrevTag: Zi,
    deleteTag: Yi,
    deleteSelected: Rr,
    handleOptionSelect: Nr,
    scrollToOption: zn,
    hasModelValue: q,
    shouldShowPlaceholder: Rn,
    currentPlaceholder: Co,
    mouseEnterEventName: So,
    showClose: Ke,
    iconComponent: fe,
    iconReverse: Nt,
    validateState: Bt,
    validateIcon: bt,
    showNewOption: lt,
    updateOptions: Ln,
    collapseTagSize: cn,
    setSelected: Dt,
    selectDisabled: _,
    emptyText: Ie,
    handleCompositionStart: S,
    handleCompositionUpdate: x,
    handleCompositionEnd: O,
    onOptionCreate: Ji,
    onOptionDestroy: Xi,
    handleMenuEnter: el,
    focus: Dn,
    blur: zr,
    handleClearClick: tl,
    handleClickOutside: nl,
    handleEsc: ol,
    toggleMenu: Dr,
    selectOption: rl,
    getValueKey: Oo,
    navigateOptions: Hr,
    dropdownMenuVisible: Fo,
    showTagList: sl,
    collapseTagList: il,
    tagStyle: ul,
    collapseTagStyle: cl,
    inputStyle: dl,
    popperRef: Qi,
    inputRef: c,
    tooltipRef: l,
    tagTooltipRef: d,
    calculatorRef: v,
    prefixRef: g,
    suffixRef: f,
    selectRef: i,
    wrapperRef: k,
    selectionRef: u,
    scrollbarRef: C,
    menuRef: p,
    tagMenuRef: m,
    collapseItemRef: y
  };
};
var Pg = M({
  name: "ElOptions",
  setup(e, { slots: t }) {
    const n = W(wo);
    let o = [];
    return () => {
      var r, a;
      const s = (r = t.default) == null ? void 0 : r.call(t), i = [];
      function u(l) {
        Ne(l) && l.forEach((d) => {
          var c, v, g, f;
          const p = (c = (d == null ? void 0 : d.type) || {}) == null ? void 0 : c.name;
          p === "ElOptionGroup" ? u(!an(d.children) && !Ne(d.children) && ue((v = d.children) == null ? void 0 : v.default) ? (g = d.children) == null ? void 0 : g.default() : d.children) : p === "ElOption" ? i.push((f = d.props) == null ? void 0 : f.value) : Ne(d.children) && u(d.children);
        });
      }
      return s.length && u((a = s[0]) == null ? void 0 : a.children), Yo(i, o) || (o = i, n && (n.states.optionValues = i)), s;
    };
  }
});
const Lg = ee({
  name: String,
  id: String,
  modelValue: {
    type: [Array, String, Number, Boolean, Object],
    default: void 0
  },
  autocomplete: {
    type: String,
    default: "off"
  },
  automaticDropdown: Boolean,
  size: Ks,
  effect: {
    type: z(String),
    default: "light"
  },
  disabled: Boolean,
  clearable: Boolean,
  filterable: Boolean,
  allowCreate: Boolean,
  loading: Boolean,
  popperClass: {
    type: String,
    default: ""
  },
  popperOptions: {
    type: z(Object),
    default: () => ({})
  },
  remote: Boolean,
  loadingText: String,
  noMatchText: String,
  noDataText: String,
  remoteMethod: Function,
  filterMethod: Function,
  multiple: Boolean,
  multipleLimit: {
    type: Number,
    default: 0
  },
  placeholder: {
    type: String
  },
  defaultFirstOption: Boolean,
  reserveKeyword: {
    type: Boolean,
    default: !0
  },
  valueKey: {
    type: String,
    default: "value"
  },
  collapseTags: Boolean,
  collapseTagsTooltip: Boolean,
  maxCollapseTags: {
    type: Number,
    default: 1
  },
  teleported: he.teleported,
  persistent: {
    type: Boolean,
    default: !0
  },
  clearIcon: {
    type: Jt,
    default: Es
  },
  fitInputWidth: Boolean,
  suffixIcon: {
    type: Jt,
    default: op
  },
  tagType: { ...nr.type, default: "info" },
  tagEffect: { ...nr.effect, default: "light" },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  remoteShowSuffix: Boolean,
  placement: {
    type: z(String),
    values: ho,
    default: "bottom-start"
  },
  fallbackPlacements: {
    type: z(Array),
    default: ["bottom-start", "top-start", "right", "left"]
  },
  appendTo: String,
  ...J0,
  ...yo(["ariaLabel"])
}), es = "ElSelect", Mg = M({
  name: es,
  componentName: es,
  components: {
    ElSelectMenu: $g,
    ElOption: Lr,
    ElOptions: Pg,
    ElTag: eg,
    ElScrollbar: wv,
    ElTooltip: ti,
    ElIcon: on
  },
  directives: { ClickOutside: Zh },
  props: Lg,
  emits: [
    ht,
    vo,
    "remove-tag",
    "clear",
    "visible-change",
    "focus",
    "blur"
  ],
  setup(e, { emit: t }) {
    const n = w(() => {
      const { modelValue: a, multiple: s } = e, i = s ? [] : void 0;
      return Ne(a) ? s ? a : i : s ? i : a;
    }), o = $t({
      ...ir(e),
      modelValue: n
    }), r = Ag(o, t);
    return ye(wo, $t({
      props: o,
      states: r.states,
      optionsArray: r.optionsArray,
      handleOptionSelect: r.handleOptionSelect,
      onOptionCreate: r.onOptionCreate,
      onOptionDestroy: r.onOptionDestroy,
      selectRef: r.selectRef,
      setSelected: r.setSelected
    })), {
      ...r,
      modelValue: n
    };
  }
});
function Rg(e, t, n, o, r, a) {
  const s = qe("el-tag"), i = qe("el-tooltip"), u = qe("el-icon"), l = qe("el-option"), d = qe("el-options"), c = qe("el-scrollbar"), v = qe("el-select-menu"), g = kl("click-outside");
  return et((F(), P("div", {
    ref: "selectRef",
    class: $([e.nsSelect.b(), e.nsSelect.m(e.selectSize)]),
    [_l(e.mouseEnterEventName)]: (f) => e.states.inputHovering = !0,
    onMouseleave: (f) => e.states.inputHovering = !1
  }, [
    U(i, {
      ref: "tooltipRef",
      visible: e.dropdownMenuVisible,
      placement: e.placement,
      teleported: e.teleported,
      "popper-class": [e.nsSelect.e("popper"), e.popperClass],
      "popper-options": e.popperOptions,
      "fallback-placements": e.fallbackPlacements,
      effect: e.effect,
      pure: "",
      trigger: "click",
      transition: `${e.nsSelect.namespace.value}-zoom-in-top`,
      "stop-popper-mouse-event": !1,
      "gpu-acceleration": !1,
      persistent: e.persistent,
      "append-to": e.appendTo,
      onBeforeShow: e.handleMenuEnter,
      onHide: (f) => e.states.isBeforeHide = !1
    }, {
      default: R(() => {
        var f;
        return [
          B("div", {
            ref: "wrapperRef",
            class: $([
              e.nsSelect.e("wrapper"),
              e.nsSelect.is("focused", e.isFocused),
              e.nsSelect.is("hovering", e.states.inputHovering),
              e.nsSelect.is("filterable", e.filterable),
              e.nsSelect.is("disabled", e.selectDisabled)
            ]),
            onClick: ve(e.toggleMenu, ["prevent"])
          }, [
            e.$slots.prefix ? (F(), P("div", {
              key: 0,
              ref: "prefixRef",
              class: $(e.nsSelect.e("prefix"))
            }, [
              N(e.$slots, "prefix")
            ], 2)) : G("v-if", !0),
            B("div", {
              ref: "selectionRef",
              class: $([
                e.nsSelect.e("selection"),
                e.nsSelect.is("near", e.multiple && !e.$slots.prefix && !!e.states.selected.length)
              ])
            }, [
              e.multiple ? N(e.$slots, "tag", { key: 0 }, () => [
                (F(!0), P(ot, null, Zt(e.showTagList, (p) => (F(), P("div", {
                  key: e.getValueKey(p),
                  class: $(e.nsSelect.e("selected-item"))
                }, [
                  U(s, {
                    closable: !e.selectDisabled && !p.isDisabled,
                    size: e.collapseTagSize,
                    type: e.tagType,
                    effect: e.tagEffect,
                    "disable-transitions": "",
                    style: ze(e.tagStyle),
                    onClose: (m) => e.deleteTag(m, p)
                  }, {
                    default: R(() => [
                      B("span", {
                        class: $(e.nsSelect.e("tags-text"))
                      }, [
                        N(e.$slots, "label", {
                          label: p.currentLabel,
                          value: p.value
                        }, () => [
                          It(ge(p.currentLabel), 1)
                        ])
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["closable", "size", "type", "effect", "style", "onClose"])
                ], 2))), 128)),
                e.collapseTags && e.states.selected.length > e.maxCollapseTags ? (F(), j(i, {
                  key: 0,
                  ref: "tagTooltipRef",
                  disabled: e.dropdownMenuVisible || !e.collapseTagsTooltip,
                  "fallback-placements": ["bottom", "top", "right", "left"],
                  effect: e.effect,
                  placement: "bottom",
                  teleported: e.teleported
                }, {
                  default: R(() => [
                    B("div", {
                      ref: "collapseItemRef",
                      class: $(e.nsSelect.e("selected-item"))
                    }, [
                      U(s, {
                        closable: !1,
                        size: e.collapseTagSize,
                        type: e.tagType,
                        effect: e.tagEffect,
                        "disable-transitions": "",
                        style: ze(e.collapseTagStyle)
                      }, {
                        default: R(() => [
                          B("span", {
                            class: $(e.nsSelect.e("tags-text"))
                          }, " + " + ge(e.states.selected.length - e.maxCollapseTags), 3)
                        ]),
                        _: 1
                      }, 8, ["size", "type", "effect", "style"])
                    ], 2)
                  ]),
                  content: R(() => [
                    B("div", {
                      ref: "tagMenuRef",
                      class: $(e.nsSelect.e("selection"))
                    }, [
                      (F(!0), P(ot, null, Zt(e.collapseTagList, (p) => (F(), P("div", {
                        key: e.getValueKey(p),
                        class: $(e.nsSelect.e("selected-item"))
                      }, [
                        U(s, {
                          class: "in-tooltip",
                          closable: !e.selectDisabled && !p.isDisabled,
                          size: e.collapseTagSize,
                          type: e.tagType,
                          effect: e.tagEffect,
                          "disable-transitions": "",
                          onClose: (m) => e.deleteTag(m, p)
                        }, {
                          default: R(() => [
                            B("span", {
                              class: $(e.nsSelect.e("tags-text"))
                            }, [
                              N(e.$slots, "label", {
                                label: p.currentLabel,
                                value: p.value
                              }, () => [
                                It(ge(p.currentLabel), 1)
                              ])
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["closable", "size", "type", "effect", "onClose"])
                      ], 2))), 128))
                    ], 2)
                  ]),
                  _: 3
                }, 8, ["disabled", "effect", "teleported"])) : G("v-if", !0)
              ]) : G("v-if", !0),
              e.selectDisabled ? G("v-if", !0) : (F(), P("div", {
                key: 1,
                class: $([
                  e.nsSelect.e("selected-item"),
                  e.nsSelect.e("input-wrapper"),
                  e.nsSelect.is("hidden", !e.filterable)
                ])
              }, [
                et(B("input", {
                  id: e.inputId,
                  ref: "inputRef",
                  "onUpdate:modelValue": (p) => e.states.inputValue = p,
                  type: "text",
                  name: e.name,
                  class: $([e.nsSelect.e("input"), e.nsSelect.is(e.selectSize)]),
                  disabled: e.selectDisabled,
                  autocomplete: e.autocomplete,
                  style: ze(e.inputStyle),
                  role: "combobox",
                  readonly: !e.filterable,
                  spellcheck: "false",
                  "aria-activedescendant": ((f = e.hoverOption) == null ? void 0 : f.id) || "",
                  "aria-controls": e.contentId,
                  "aria-expanded": e.dropdownMenuVisible,
                  "aria-label": e.ariaLabel,
                  "aria-autocomplete": "none",
                  "aria-haspopup": "listbox",
                  onKeydown: [
                    Kt(ve((p) => e.navigateOptions("next"), ["stop", "prevent"]), ["down"]),
                    Kt(ve((p) => e.navigateOptions("prev"), ["stop", "prevent"]), ["up"]),
                    Kt(ve(e.handleEsc, ["stop", "prevent"]), ["esc"]),
                    Kt(ve(e.selectOption, ["stop", "prevent"]), ["enter"]),
                    Kt(ve(e.deletePrevTag, ["stop"]), ["delete"])
                  ],
                  onCompositionstart: e.handleCompositionStart,
                  onCompositionupdate: e.handleCompositionUpdate,
                  onCompositionend: e.handleCompositionEnd,
                  onInput: e.onInput,
                  onClick: ve(e.toggleMenu, ["stop"])
                }, null, 46, ["id", "onUpdate:modelValue", "name", "disabled", "autocomplete", "readonly", "aria-activedescendant", "aria-controls", "aria-expanded", "aria-label", "onKeydown", "onCompositionstart", "onCompositionupdate", "onCompositionend", "onInput", "onClick"]), [
                  [$l, e.states.inputValue]
                ]),
                e.filterable ? (F(), P("span", {
                  key: 0,
                  ref: "calculatorRef",
                  "aria-hidden": "true",
                  class: $(e.nsSelect.e("input-calculator")),
                  textContent: ge(e.states.inputValue)
                }, null, 10, ["textContent"])) : G("v-if", !0)
              ], 2)),
              e.shouldShowPlaceholder ? (F(), P("div", {
                key: 2,
                class: $([
                  e.nsSelect.e("selected-item"),
                  e.nsSelect.e("placeholder"),
                  e.nsSelect.is("transparent", !e.hasModelValue || e.expanded && !e.states.inputValue)
                ])
              }, [
                e.hasModelValue ? N(e.$slots, "label", {
                  key: 0,
                  label: e.currentPlaceholder,
                  value: e.modelValue
                }, () => [
                  B("span", null, ge(e.currentPlaceholder), 1)
                ]) : (F(), P("span", { key: 1 }, ge(e.currentPlaceholder), 1))
              ], 2)) : G("v-if", !0)
            ], 2),
            B("div", {
              ref: "suffixRef",
              class: $(e.nsSelect.e("suffix"))
            }, [
              e.iconComponent && !e.showClose ? (F(), j(u, {
                key: 0,
                class: $([e.nsSelect.e("caret"), e.nsSelect.e("icon"), e.iconReverse])
              }, {
                default: R(() => [
                  (F(), j(tt(e.iconComponent)))
                ]),
                _: 1
              }, 8, ["class"])) : G("v-if", !0),
              e.showClose && e.clearIcon ? (F(), j(u, {
                key: 1,
                class: $([
                  e.nsSelect.e("caret"),
                  e.nsSelect.e("icon"),
                  e.nsSelect.e("clear")
                ]),
                onClick: e.handleClearClick
              }, {
                default: R(() => [
                  (F(), j(tt(e.clearIcon)))
                ]),
                _: 1
              }, 8, ["class", "onClick"])) : G("v-if", !0),
              e.validateState && e.validateIcon ? (F(), j(u, {
                key: 2,
                class: $([e.nsInput.e("icon"), e.nsInput.e("validateIcon")])
              }, {
                default: R(() => [
                  (F(), j(tt(e.validateIcon)))
                ]),
                _: 1
              }, 8, ["class"])) : G("v-if", !0)
            ], 2)
          ], 10, ["onClick"])
        ];
      }),
      content: R(() => [
        U(v, { ref: "menuRef" }, {
          default: R(() => [
            e.$slots.header ? (F(), P("div", {
              key: 0,
              class: $(e.nsSelect.be("dropdown", "header")),
              onClick: ve(() => {
              }, ["stop"])
            }, [
              N(e.$slots, "header")
            ], 10, ["onClick"])) : G("v-if", !0),
            et(U(c, {
              id: e.contentId,
              ref: "scrollbarRef",
              tag: "ul",
              "wrap-class": e.nsSelect.be("dropdown", "wrap"),
              "view-class": e.nsSelect.be("dropdown", "list"),
              class: $([e.nsSelect.is("empty", e.filteredOptionsCount === 0)]),
              role: "listbox",
              "aria-label": e.ariaLabel,
              "aria-orientation": "vertical"
            }, {
              default: R(() => [
                e.showNewOption ? (F(), j(l, {
                  key: 0,
                  value: e.states.inputValue,
                  created: !0
                }, null, 8, ["value"])) : G("v-if", !0),
                U(d, null, {
                  default: R(() => [
                    N(e.$slots, "default")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["id", "wrap-class", "view-class", "class", "aria-label"]), [
              [rn, e.states.options.size > 0 && !e.loading]
            ]),
            e.$slots.loading && e.loading ? (F(), P("div", {
              key: 1,
              class: $(e.nsSelect.be("dropdown", "loading"))
            }, [
              N(e.$slots, "loading")
            ], 2)) : e.loading || e.filteredOptionsCount === 0 ? (F(), P("div", {
              key: 2,
              class: $(e.nsSelect.be("dropdown", "empty"))
            }, [
              N(e.$slots, "empty", {}, () => [
                B("span", null, ge(e.emptyText), 1)
              ])
            ], 2)) : G("v-if", !0),
            e.$slots.footer ? (F(), P("div", {
              key: 3,
              class: $(e.nsSelect.be("dropdown", "footer")),
              onClick: ve(() => {
              }, ["stop"])
            }, [
              N(e.$slots, "footer")
            ], 10, ["onClick"])) : G("v-if", !0)
          ]),
          _: 3
        }, 512)
      ]),
      _: 3
    }, 8, ["visible", "placement", "teleported", "popper-class", "popper-options", "fallback-placements", "effect", "transition", "persistent", "append-to", "onBeforeShow", "onHide"])
  ], 16, ["onMouseleave"])), [
    [g, e.handleClickOutside, e.popperRef]
  ]);
}
var Ng = /* @__PURE__ */ J(Mg, [["render", Rg], ["__file", "select.vue"]]);
const Bg = M({
  name: "ElOptionGroup",
  componentName: "ElOptionGroup",
  props: {
    label: String,
    disabled: Boolean
  },
  setup(e) {
    const t = te("select"), n = E(null), o = me(), r = E([]);
    ye(ui, $t({
      ...ir(e)
    }));
    const a = w(() => r.value.some((l) => l.visible === !0)), s = (l) => {
      var d, c;
      return ((d = l.type) == null ? void 0 : d.name) === "ElOption" && !!((c = l.component) != null && c.proxy);
    }, i = (l) => {
      const d = Me(l), c = [];
      return d.forEach((v) => {
        var g, f;
        s(v) ? c.push(v.component.proxy) : (g = v.children) != null && g.length ? c.push(...i(v.children)) : (f = v.component) != null && f.subTree && c.push(...i(v.component.subTree));
      }), c;
    }, u = () => {
      r.value = i(o.subTree);
    };
    return ie(() => {
      u();
    }), Zl(n, u, {
      attributes: !0,
      subtree: !0,
      childList: !0
    }), {
      groupRef: n,
      visible: a,
      ns: t
    };
  }
});
function zg(e, t, n, o, r, a) {
  return et((F(), P("ul", {
    ref: "groupRef",
    class: $(e.ns.be("group", "wrap"))
  }, [
    B("li", {
      class: $(e.ns.be("group", "title"))
    }, ge(e.label), 3),
    B("li", null, [
      B("ul", {
        class: $(e.ns.b("group"))
      }, [
        N(e.$slots, "default")
      ], 2)
    ])
  ], 2)), [
    [rn, e.visible]
  ]);
}
var ci = /* @__PURE__ */ J(Bg, [["render", zg], ["__file", "option-group.vue"]]);
const ln = _e(Ng, {
  Option: Lr,
  OptionGroup: ci
}), un = po(Lr);
po(ci);
const Dg = ee({
  trigger: _n.trigger,
  placement: Bo.placement,
  disabled: _n.disabled,
  visible: he.visible,
  transition: he.transition,
  popperOptions: Bo.popperOptions,
  tabindex: Bo.tabindex,
  content: he.content,
  popperStyle: he.popperStyle,
  popperClass: he.popperClass,
  enterable: {
    ...he.enterable,
    default: !0
  },
  effect: {
    ...he.effect,
    default: "light"
  },
  teleported: he.teleported,
  title: String,
  width: {
    type: [String, Number],
    default: 150
  },
  offset: {
    type: Number,
    default: void 0
  },
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  autoClose: {
    type: Number,
    default: 0
  },
  showArrow: {
    type: Boolean,
    default: !0
  },
  persistent: {
    type: Boolean,
    default: !0
  },
  "onUpdate:visible": {
    type: Function
  }
}), Hg = {
  "update:visible": (e) => gr(e),
  "before-enter": () => !0,
  "before-leave": () => !0,
  "after-enter": () => !0,
  "after-leave": () => !0
}, Vg = "onUpdate:visible", jg = M({
  name: "ElPopover"
}), Ug = /* @__PURE__ */ M({
  ...jg,
  props: Dg,
  emits: Hg,
  setup(e, { expose: t, emit: n }) {
    const o = e, r = w(() => o[Vg]), a = te("popover"), s = E(), i = w(() => {
      var m;
      return (m = h(s)) == null ? void 0 : m.popperRef;
    }), u = w(() => [
      {
        width: eo(o.width)
      },
      o.popperStyle
    ]), l = w(() => [a.b(), o.popperClass, { [a.m("plain")]: !!o.content }]), d = w(() => o.transition === `${a.namespace.value}-fade-in-linear`), c = () => {
      var m;
      (m = s.value) == null || m.hide();
    }, v = () => {
      n("before-enter");
    }, g = () => {
      n("before-leave");
    }, f = () => {
      n("after-enter");
    }, p = () => {
      n("update:visible", !1), n("after-leave");
    };
    return t({
      popperRef: i,
      hide: c
    }), (m, y) => (F(), j(h(ti), Pt({
      ref_key: "tooltipRef",
      ref: s
    }, m.$attrs, {
      trigger: m.trigger,
      placement: m.placement,
      disabled: m.disabled,
      visible: m.visible,
      transition: m.transition,
      "popper-options": m.popperOptions,
      tabindex: m.tabindex,
      content: m.content,
      offset: m.offset,
      "show-after": m.showAfter,
      "hide-after": m.hideAfter,
      "auto-close": m.autoClose,
      "show-arrow": m.showArrow,
      "aria-label": m.title,
      effect: m.effect,
      enterable: m.enterable,
      "popper-class": h(l),
      "popper-style": h(u),
      teleported: m.teleported,
      persistent: m.persistent,
      "gpu-acceleration": h(d),
      "onUpdate:visible": h(r),
      onBeforeShow: v,
      onBeforeHide: g,
      onShow: f,
      onHide: p
    }), {
      content: R(() => [
        m.title ? (F(), P("div", {
          key: 0,
          class: $(h(a).e("title")),
          role: "title"
        }, ge(m.title), 3)) : G("v-if", !0),
        N(m.$slots, "default", {}, () => [
          It(ge(m.content), 1)
        ])
      ]),
      default: R(() => [
        m.$slots.reference ? N(m.$slots, "reference", { key: 0 }) : G("v-if", !0)
      ]),
      _: 3
    }, 16, ["trigger", "placement", "disabled", "visible", "transition", "popper-options", "tabindex", "content", "offset", "show-after", "hide-after", "auto-close", "show-arrow", "aria-label", "effect", "enterable", "popper-class", "popper-style", "teleported", "persistent", "gpu-acceleration", "onUpdate:visible"]));
  }
});
var Kg = /* @__PURE__ */ J(Ug, [["__file", "popover.vue"]]);
const ts = (e, t) => {
  const n = t.arg || t.value, o = n == null ? void 0 : n.popperRef;
  o && (o.triggerRef = e);
};
var Gg = {
  mounted(e, t) {
    ts(e, t);
  },
  updated(e, t) {
    ts(e, t);
  }
};
const Wg = "popover", qg = pp(Gg, Wg), Mr = _e(Kg, {
  directive: qg
});
Et.register([Il, Al, Pl]);
const Zg = (e, t) => Ll.parse(e, { download: !0, complete: t }), or = {
  loadFile: Zg
}, di = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, Yg = ["xlink:href"], Jg = {
  __name: "SvgIcon",
  props: {
    /**
     * The svg icon to show.
     */
    icon: {
      type: String,
      required: !0
    },
    /**
     * The option to spin the icon.
     */
    spin: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (F(), P("svg", {
      class: $(["map-icon", { "map-icon-spin": e.spin }])
    }, [
      B("use", {
        "xlink:href": `#${e.icon}`
      }, null, 8, Yg)
    ], 2));
  }
}, Xg = /* @__PURE__ */ di(Jg, [["__scopeId", "data-v-e172d5ff"]]), fi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>2horpanel</title>
    <g id="2horpanel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-4">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="18.5" y1="12" x2="5.5" y2="12" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, pi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>2vertpanel</title>
    <g id="2vertpanel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-3">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="12" y1="7.5" x2="12" y2="16.5" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, vi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>3panel</title>
    <g id="3panel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="11.5" y1="7.5" x2="11.5" y2="16.5" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
            <line x1="18.5" y1="11.5" x2="11.5" y2="11.5" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, hi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>4panel</title>
    <g id="4panel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-2">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="12" y1="7.5" x2="12" y2="16.5" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
            <line x1="18.5" y1="12" x2="5.5" y2="12" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, gi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>2horpanel</title>
    <g id="2horpanel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-4">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="18.5" y1="12" x2="5.5" y2="12" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
          <line x1="12" y1="12.5" x2="12" y2="16.5" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
          <line x1="14.5" y1="12" x2="14.5" y2="7" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
          <line x1="9.5" y1="12" x2="9.5" y2="7" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, mi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>2horpanel</title>
    <g id="2horpanel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-4">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="18.5" y1="12" x2="5.5" y2="12" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
          <line x1="14.5" y1="16" x2="14.5" y2="7" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
          <line x1="9.5" y1="16" x2="9.5" y2="7" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, yi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>4panel</title>
    <g id="4panel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-2">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
            <line x1="12" y1="7.5" x2="12" y2="16.5" id="Line-6" stroke="#FFFFFF" stroke-linecap="square"></line>
            <line x1="18.5" y1="10.5" x2="5.5" y2="10.5" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
            <line x1="18.5" y1="13.8" x2="5.5" y2="13.8" id="Line-10" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, bi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>changeBckgd</title>
    <g id="changeBckgd" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-5">
            <circle id="Oval-Copy" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <rect id="Rectangle" stroke="#FFFFFF" x="7" y="6" width="10" height="7"></rect>
            <line x1="12" y1="13.5" x2="12" y2="16.5" id="Line-4" stroke="#FFFFFF" stroke-width="2"></line>
            <line x1="7" y1="16.5" x2="17" y2="16.5" id="Line" stroke="#FFFFFF" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, wi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>close no bk</title>
    <g id="close-no-bk" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="Group-13" transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) translate(5.000000, 5.000000)" stroke="#FFFFFF" stroke-width="2">
            <line x1="0" y1="7" x2="14" y2="7" id="Line-9"></line>
            <line x1="7" y1="0" x2="7" y2="14" id="Line-9"></line>
        </g>
    </g>
</svg>`, xi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>close</title>
    <g id="close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-9">
            <g id="Group-8" fill="currentColor">
                <circle id="Oval" cx="12" cy="12" r="12"></circle>
            </g>
            <g id="Group-13" transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) translate(5.000000, 5.000000)" stroke="#FFFFFF" stroke-linecap="square" stroke-width="2">
                <line x1="0" y1="7" x2="14" y2="7" id="Line-9"></line>
                <line x1="7" y1="0" x2="7" y2="14" id="Line-9"></line>
            </g>
        </g>
    </g>
</svg>`, Fi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>closeFullScreen</title>
    <g id="closeFullScreen" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group">
            <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <polyline id="Line-5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="square" transform="translate(6.750000, 7.750000) rotate(-180.000000) translate(-6.750000, -7.750000) " points="5 9.5 5 6 8.5 6"></polyline>
            <polyline id="Line-5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="square" transform="translate(17.250000, 15.750000) rotate(-360.000000) translate(-17.250000, -15.750000) " points="15.5 17.5 15.5 14 19 14"></polyline>
            <polyline id="Line-5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="square" transform="translate(6.750000, 15.750000) scale(1, -1) rotate(-180.000000) translate(-6.750000, -15.750000) " points="5 17.5 5 14 8.5 14"></polyline>
            <polyline id="Line-5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="square" transform="translate(17.250000, 7.750000) scale(1, -1) rotate(-360.000000) translate(-17.250000, -7.750000) " points="15.5 9.5 15.5 6 19 6"></polyline>
        </g>
    </g>
</svg>`, Ci = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Comment</title>
    <g id="Comment" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="512" cy="512" r="512"></circle>
        <path fill="#FFFFFF" transform="scale(0.75, 0.75) translate(165, 215)"
            d="M736 504a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112M128 128v640h192v160l224-160h352V128z" />
    </g>
</svg>`, Si = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Connection</title>
    <g id="Connection" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="512" cy="512" r="512"></circle>
        <path fill="#FFFFFF" transform="scale(0.75, 0.75) translate(175, 175)"
            d="M640 384v64H448a128 128 0 0 0-128 128v128a128 128 0 0 0 128 128h320a128 128 0 0 0 128-128V576a128 128 0 0 0-64-110.848V394.88c74.56 26.368 128 97.472 128 181.056v128a192 192 0 0 1-192 192H448a192 192 0 0 1-192-192V576a192 192 0 0 1 192-192z" />
        <path fill="#FFFFFF" transform="scale(0.75, 0.75) translate(175, 175)"
            d="M384 640v-64h192a128 128 0 0 0 128-128V320a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v128a128 128 0 0 0 64 110.848v70.272A192.064 192.064 0 0 1 64 448V320a192 192 0 0 1 192-192h320a192 192 0 0 1 192 192v128a192 192 0 0 1-192 192z" />
    </g>
</svg>`, Oi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>dock</title>
    <g id="dock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-8-Copy-2">
            <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <g id="Group-5" transform="translate(2.972940, 3.512563)" stroke="#FFFFFF" stroke-linecap="square" stroke-width="2">
                <line x1="10.7289628" y1="7.03553391" x2="14.9716035" y2="2.79289322" id="Line"></line>
                <g id="Group" transform="translate(14.264497, 3.500000) rotate(-315.000000) translate(-14.264497, -3.500000) translate(11.264497, 2.000000)">
                    <line x1="2.27373675e-13" y1="2.82842712" x2="2.82842712" y2="0" id="Line"></line>
                    <line x1="3" y1="0" x2="5.82842712" y2="2.82842712" id="Line"></line>
                </g>
                <line x1="7.53553391" y1="10.1584369" x2="3.29289322" y2="14.4010776" id="Line"></line>
                <g id="Group" transform="translate(4.000000, 13.693971) rotate(-135.000000) translate(-4.000000, -13.693971) translate(1.000000, 12.193971)">
                    <line x1="2.27373675e-13" y1="2.82842712" x2="2.82842712" y2="0" id="Line"></line>
                    <line x1="3" y1="0" x2="5.82842712" y2="2.82842712" id="Line"></line>
                </g>
            </g>
        </g>
    </g>
</svg>`, Ti = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>drawLine</title>
    <g id="drawLine" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
        <path fill="#FFFFFF" transform="translate(2 2.0625)" d="m13.5 3.5c-1.4 0-2.5 1.1-2.5 2.5 0 .3 0 .6.2.9l-3.8 3.8c-.3-.1-.6-.2-.9-.2-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5c0-.3 0-.6-.2-.9l3.8-3.8c.3.1.6.2.9.2 1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5z" />
    </g>
</svg>`, Ei = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>drawPoint</title>
    <g id="drawPoint" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
        <path fill="#FFFFFF" transform="translate(1.875 2.5)" d="m10 2c-3.3 0-6 2.7-6 6s6 9 6 9 6-5.7 6-9-2.7-6-6-6zm0 2c2.1 0 3.8 1.7 3.8 3.8 0 1.5-1.8 3.9-2.9 5.2h-1.7c-1.1-1.4-2.9-3.8-2.9-5.2-.1-2.1 1.6-3.8 3.7-3.8z" />
    </g>
</svg>`, ki = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>drawPolygon</title>
    <g id="drawPolygon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
        <path fill="#FFFFFF" transform="translate(1.875 1.625)" d="m15 12.3v-4.6c.6-.3 1-1 1-1.7 0-1.1-.9-2-2-2-.7 0-1.4.4-1.7 1h-4.6c-.3-.6-1-1-1.7-1-1.1 0-2 .9-2 2 0 .7.4 1.4 1 1.7v4.6c-.6.3-1 1-1 1.7 0 1.1.9 2 2 2 .7 0 1.4-.4 1.7-1h4.6c.3.6 1 1 1.7 1 1.1 0 2-.9 2-2 0-.7-.4-1.4-1-1.7zm-8-.3v-4l1-1h4l1 1v4l-1 1h-4z" />
    </g>
</svg>`, _i = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>drawTrash</title>
    <g id="drawTrash" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
        <path fill="#FFFFFF" transform="translate(2 1.5)" d="M10,3.4 c-0.8,0-1.5,0.5-1.8,1.2H5l-1,1v1h12v-1l-1-1h-3.2C11.5,3.9,10.8,3.4,10,3.4z M5,8v7c0,1,1,2,2,2h6c1,0,2-1,2-2V8h-2v5.5h-1.5V8h-3 v5.5H7V8H5z" />
    </g>
</svg>`, $i = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>fitWindow</title>
    <g id="fitWindow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-3">
            <g id="Group-8-Copy">
                <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
                <g id="Group" transform="translate(5.000000, 6.000000)" stroke="#FFFFFF" stroke-linecap="square" stroke-width="1.5">
                    <polyline id="Line-5" points="0 3.5 0 0 4.80123862 0"></polyline>
                    <polyline id="Line-5" transform="translate(2.400619, 9.750000) scale(1, -1) translate(-2.400619, -9.750000) " points="0 11.5 0 8 4.80123862 8"></polyline>
                    <polyline id="Line-5" transform="translate(11.600619, 1.750000) scale(1, -1) rotate(-180.000000) translate(-11.600619, -1.750000) " points="9.2 3.5 9.2 0 14.0012386 0"></polyline>
                </g>
            </g>
            <g id="Group-12" transform="translate(9.000000, 8.500000)" stroke="#FFFFFF" stroke-width="2">
                <circle id="Oval" cx="3.5" cy="3.5" r="3.5"></circle>
                <line x1="8.75" y1="8.75" x2="6.25" y2="6.25" id="Line-8" stroke-linecap="square"></line>
            </g>
        </g>
    </g>
</svg>`, Ii = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>fullScreen</title>
    <g id="fullScreen" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-8-Copy">
            <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <g id="Group" transform="translate(5.000000, 6.000000)" stroke="#FFFFFF" stroke-linecap="square" stroke-width="1.5">
                <polyline id="Line-5" points="7.68274333e-14 3.5 7.68274333e-14 0 4.80123862 0"></polyline>
                <polyline id="Line-5" transform="translate(11.600619, 9.750000) rotate(-180.000000) translate(-11.600619, -9.750000) " points="9.2 11.5 9.2 8 14.0012386 8"></polyline>
                <polyline id="Line-5" transform="translate(2.400619, 9.750000) scale(1, -1) translate(-2.400619, -9.750000) " points="7.68274333e-14 11.5 7.68274333e-14 8 4.80123862 8"></polyline>
                <polyline id="Line-5" transform="translate(11.600619, 1.750000) scale(1, -1) rotate(-180.000000) translate(-11.600619, -1.750000) " points="9.2 3.5 9.2 0 14.0012386 0"></polyline>
            </g>
        </g>
    </g>
</svg>`, Ai = '<svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>DataPortal-Icons</title><circle cx="12" cy="15.824" r="0.753"/><path d="M12,14.256a.75.75,0,0,1-.75-.75v-1c0-.529.419-.818.862-1.124.623-.43,1.138-.83,1.138-1.376A1.209,1.209,0,0,0,12,8.756a1.252,1.252,0,0,0-1.25,1.25.75.75,0,0,1-1.5,0A2.753,2.753,0,0,1,12,7.256a2.721,2.721,0,0,1,2.75,2.75,3.3,3.3,0,0,1-1.786,2.61c-.079.055-.152.1-.214.147v.743A.75.75,0,0,1,12,14.256Z"/><path d="M12,5a7,7,0,1,1-7,7,7.008,7.008,0,0,1,7-7m0-2a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z"/></svg>', Pi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>magnifyingGlass</title>
    <g id="magnifyingGlass" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-19-Copy">
            <g id="Group-13-Copy">
                <circle id="Oval-Copy-2" fill="currentColor" cx="12" cy="12" r="12"></circle>
                <g id="Group-12" transform="translate(5.000000, 4.000000)" stroke="#FFFFFF" stroke-width="2">
                    <circle id="Oval" cx="5.5" cy="5.5" r="5.5"></circle>
                    <line x1="13.5833333" y1="13.5833333" x2="9.41666667" y2="9.41666667" id="Line-8" stroke-linecap="square"></line>
                </g>
            </g>
        </g>
    </g>
</svg>`, Li = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" x="0px" y="0px" viewBox="0 0 960 1200" enable-background="new 0 0 960 960" xml:space="preserve"><g><path fill="#000000" d="M670,499.992c0,5.5-4.5,10-10,10H300c-5.516,0-10-4.5-10-10v-40c0-5.5,4.484-10,10-10h360   c5.5,0,10,4.5,10,10V499.992z"/><path fill="#000000" d="M530,649.992c0,5.5-4.5,10-10,10h-80c-5.516,0-10-4.5-10-10v-40c0-5.5,4.484-10,10-10h80   c5.5,0,10,4.5,10,10V649.992z"/><path fill="#000000" d="M780,350.008c0,5.5-4.5,10-10,10H190c-5.516,0-10-4.5-10-10v-40c0-5.516,4.484-10,10-10h580   c5.5,0,10,4.484,10,10V350.008z"/></g><text x="0" y="975" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif">Created by Wahyu Prihantoro</text><text x="0" y="980" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif">from the Noun Project</text></svg>`, Mi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>openMap</title>
    <g id="openMap" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-5-Copy" fill="currentColor">
            <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
        </g>
        <rect id="Rectangle" stroke="#FFFFFF" x="5" y="10" width="10" height="7"></rect>
        <rect id="Rectangle-Copy" stroke="#FFFFFF" x="9" y="6" width="10" height="7"></rect>
    </g>
</svg>`, Ri = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Artboard Copy 6</title>
    <g id="Artboard-Copy-6" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-5-Copy" fill="currentColor">
            <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
        </g>
        <line x1="9" y1="8" x2="9" y2="16" id="Line-6-Copy-2" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square"></line>
        <line x1="15" y1="8" x2="15" y2="16" id="Line-6-Copy-3" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square"></line>
    </g>
</svg>`, Ni = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>permalink</title>
    <g id="permalink" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
        <line x1="12.5" y1="9" x2="12.5" y2="15" id="Line-6-Copy-2" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square" transform="translate(12.500000, 12.000000) rotate(45.000000) translate(-12.500000, -12.000000) "></line>
        <path d="M17,13 L17,16.5 C17,18.9852814 14.9852814,21 12.5,21 C10.0147186,21 8,18.9852814 8,16.5 L8,13 L10,13 L10,16.5 C10,17.8807119 11.1192881,19 12.5,19 C13.8254834,19 14.9100387,17.9684641 14.9946823,16.6643757 L15,16.5 L15,13 L17,13 Z M12.5,3 C14.9852814,3 17,5.01471863 17,7.5 L17,11 L15,11 L15,7.5 C15,6.11928813 13.8807119,5 12.5,5 C11.1745166,5 10.0899613,6.03153594 10.0053177,7.33562431 L10,7.5 L10,11 L8,11 L8,7.5 C8,5.01471863 10.0147186,3 12.5,3 Z" id="Combined-Shape" fill="#FFFFFF" transform="translate(12.500000, 12.000000) rotate(45.000000) translate(-12.500000, -12.000000) "></path>
    </g>
</svg>`, Bi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>play</title>
    <g id="play" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-9">
            <g id="Group-5-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
            </g>
            <polygon id="Triangle" fill="#FFFFFF" class="st0" transform="translate(13.000000, 11.500000) rotate(-270.000000) translate(-13.000000, -11.500000) " points="13 8 19 15 7 15"></polygon>
        </g>
    </g>
</svg>`, zi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>resetZoom</title>
    <g id="resetZoom" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-13-Copy-2">
            <circle id="Oval-Copy-2" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <g id="Group-12" transform="translate(5.000000, 4.000000)" stroke="#FFFFFF" stroke-width="2">
                <circle id="Oval" cx="5.5" cy="5.5" r="5.5"></circle>
                <line x1="13.5833333" y1="13.5833333" x2="9.41666667" y2="9.41666667" id="Line-8" stroke-linecap="square"></line>
            </g>
            <g id="Group-4" transform="translate(7.500000, 7.000000)">
                <path d="M3,5 C3.83613696,5 4.57640148,4.58952131 5.03027306,3.95908443 C5.19488093,3.73044075 5.32181864,3.47286529 5.40199763,3.19544657 C5.46580562,2.97467142 5.5,2.74132897 5.5,2.5 C5.5,2.26693547 5.46810753,2.04131982 5.40844867,1.82727914 C5.31560782,1.49418996 5.15552386,1.18913241 4.9437468,0.927656488 C4.48541251,0.361762414 3.78495332,0 3,0 C1.61928813,0 0.5,1.11928813 0.5,2.5 C0.5,3.88071187 1.61928813,5 3,5 Z" id="Oval" stroke="#FFFFFF"></path>
                <rect id="Rectangle" fill="currentColor" x="2.5" y="2" width="4" height="1"></rect>
                <line x1="5.5" y1="1.5" x2="5.5" y2="0.5" id="Line-7" stroke="#FFFFFF" stroke-linecap="square"></line>
                <line x1="4.5" y1="1.5" x2="5.5" y2="1.5" id="Line-7" stroke="#FFFFFF" stroke-linecap="square"></line>
            </g>
        </g>
    </g>
</svg>`, Di = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>singlepanel</title>
    <g id="singlepanel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-10-Copy-5">
            <g id="Group-15-Copy" fill="currentColor">
                <circle id="Oval-Copy" cx="12" cy="12" r="12"></circle>
                <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold">
                    <tspan x="8.5" y="18">?</tspan>
                </text>
            </g>
            <rect id="Rectangle" stroke="#FFFFFF" x="5" y="7" width="14" height="10"></rect>
        </g>
    </g>
</svg>`, Hi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>tooltips</title>
    <g id="tooltips" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-15">
            <circle id="Oval-Copy" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <path d="M6,5 L18,5 C19.1045695,5 20,5.8954305 20,7 L20,15.5714286 C20,16.6759981 19.1045695,17.5714286 18,17.5714286 L15.4003471,17.5714286 L15.4003471,17.5714286 L12.8157442,20.271248 C12.4338253,20.6701921 11.8008107,20.6839938 11.4018666,20.3020749 C11.3997428,20.3000417 11.3976279,20.2979991 11.3955221,20.2959473 L8.59934577,17.5714286 L8.59934577,17.5714286 L6,17.5714286 C4.8954305,17.5714286 4,16.6759981 4,15.5714286 L4,7 C4,5.8954305 4.8954305,5 6,5 Z" id="Rectangle" fill="#FFFFFF"></path>
            <text id="?" font-family="Asap-Bold, Asap" font-size="16" font-weight="bold" fill="currentColor">
                <tspan x="8.5" y="18">?</tspan>
            </text>
        </g>
    </g>
</svg>`, Vi = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>undock</title>
    <g id="undock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-9">
            <circle id="Oval" fill="currentColor" cx="12" cy="12" r="12"></circle>
            <g id="Group-5" transform="translate(5.500000, 6.000000)" stroke="#FFFFFF" stroke-linecap="square" stroke-width="2">
                <line x1="0.728962778" y1="12.0355339" x2="4.97160346" y2="7.79289322" id="Line"></line>
                <g id="Group" transform="translate(4.264497, 8.500000) rotate(-315.000000) translate(-4.264497, -8.500000) translate(1.264497, 7.000000)">
                    <line x1="2.27373675e-13" y1="2.82842712" x2="2.82842712" y2="0" id="Line"></line>
                    <line x1="3" y1="0" x2="5.82842712" y2="2.82842712" id="Line"></line>
                </g>
                <line x1="12.5355339" y1="0.158436893" x2="8.29289322" y2="4.40107758" id="Line"></line>
                <g id="Group" transform="translate(9.000000, 3.693971) rotate(-135.000000) translate(-9.000000, -3.693971) translate(6.000000, 2.193971)">
                    <line x1="2.27373675e-13" y1="2.82842712" x2="2.82842712" y2="0" id="Line"></line>
                    <line x1="3" y1="0" x2="5.82842712" y2="2.82842712" id="Line"></line>
                </g>
            </g>
        </g>
    </g>
</svg>`, ji = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>zoomIn</title>
    <g id="zoomIn" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-19-Copy">
            <g id="Group-13-Copy">
                <circle id="Oval-Copy-2" fill="currentColor" cx="12" cy="12" r="12"></circle>
                <g id="Group-12" transform="translate(5.000000, 4.000000)" stroke="#FFFFFF" stroke-width="2">
                    <circle id="Oval" cx="5.5" cy="5.5" r="5.5"></circle>
                    <line x1="13.5833333" y1="13.5833333" x2="9.41666667" y2="9.41666667" id="Line-8" stroke-linecap="square"></line>
                </g>
            </g>
            <line x1="9" y1="9.5" x2="12" y2="9.5" id="Line-6-Copy-2" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square"></line>
            <line x1="9" y1="9.5" x2="12" y2="9.5" id="Line-6-Copy-2" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square" transform="translate(10.500000, 9.500000) rotate(90.000000) translate(-10.500000, -9.500000) "></line>
        </g>
    </g>
</svg>`, Ui = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>zoomOut</title>
    <g id="zoomOut" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-19-Copy-3">
            <g id="Group-13-Copy">
                <circle id="Oval-Copy-2" fill="currentColor" cx="12" cy="12" r="12"></circle>
                <g id="Group-12" transform="translate(5.000000, 4.000000)" stroke="#FFFFFF" stroke-width="2">
                    <circle id="Oval" cx="5.5" cy="5.5" r="5.5"></circle>
                    <line x1="13.5833333" y1="13.5833333" x2="9.41666667" y2="9.41666667" id="Line-8" stroke-linecap="square"></line>
                </g>
            </g>
            <line x1="9" y1="9.5" x2="12" y2="9.5" id="Line-6-Copy-2" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square"></line>
        </g>
    </g>
</svg>`, Ki = (e, t, n, o) => {
  const r = ["title", "desc", "defs", "style"], a = ["width", "height"], s = o || [];
  let i = document.createElement("div");
  i.innerHTML = e, r.map((l) => {
    const d = i.querySelector(l);
    d && d.remove();
  }), a.map((l) => {
    i.querySelector("svg").removeAttribute(l);
  }), o && s.map((l) => {
    Object.values(i.querySelectorAll(`[${l}]`)).map((d) => {
      d.removeAttribute(l);
    });
  });
  const u = i.innerHTML;
  return i = null, u;
}, Gi = (e) => [
  // Remove XML stuffs and comments
  [/<\?xml[\s\S]*?>/gi, ""],
  [/<!doctype[\s\S]*?>/gi, ""],
  [/<!--.*-->/gi, ""],
  // SVG XML -> HTML5
  [/\<([A-Za-z]+)([^\>]*)\/\>/g, "<$1$2></$1>"],
  // convert self-closing XML SVG nodes to explicitly closed HTML5 SVG nodes
  [/\s+/g, " "],
  // replace whitespace sequences with a single space
  [/\> \</g, "><"]
  // remove whitespace between tags
].reduce((t, n) => "".replace.apply(t, n), e).trim(), Qg = !0, e1 = !0, t1 = ["fill"], rr = /* @__PURE__ */ Object.assign({
  "/assets/icons/2horpanel.svg": fi,
  "/assets/icons/2vertpanel.svg": pi,
  "/assets/icons/3panel.svg": vi,
  "/assets/icons/4panel.svg": hi,
  "/assets/icons/5panel.svg": gi,
  "/assets/icons/6panel.svg": mi,
  "/assets/icons/6panelVertical.svg": yi,
  "/assets/icons/changeBckgd.svg": bi,
  "/assets/icons/close-no-bk.svg": wi,
  "/assets/icons/close.svg": xi,
  "/assets/icons/closeFullScreen.svg": Fi,
  "/assets/icons/comment.svg": Ci,
  "/assets/icons/connection.svg": Si,
  "/assets/icons/dock.svg": Oi,
  "/assets/icons/drawLine.svg": Ti,
  "/assets/icons/drawPoint.svg": Ei,
  "/assets/icons/drawPolygon.svg": ki,
  "/assets/icons/drawTrash.svg": _i,
  "/assets/icons/fitWindow.svg": $i,
  "/assets/icons/fullScreen.svg": Ii,
  "/assets/icons/help.svg": Ai,
  "/assets/icons/magnifyingGlass.svg": Pi,
  "/assets/icons/noun-filter.svg": Li,
  "/assets/icons/openMap.svg": Mi,
  "/assets/icons/pause.svg": Ri,
  "/assets/icons/permalink.svg": Ni,
  "/assets/icons/play.svg": Bi,
  "/assets/icons/resetZoom.svg": zi,
  "/assets/icons/singlepanel.svg": Di,
  "/assets/icons/tooltips.svg": Hi,
  "/assets/icons/undock.svg": Vi,
  "/assets/icons/zoomIn.svg": ji,
  "/assets/icons/zoomOut.svg": Ui
}), n1 = Object.keys(rr).map((e) => {
  const t = Ki(rr[e], Qg, e1, t1), n = e.replace(/^.+\/(\w+).svg$/, "$1");
  return Gi(t).replace("<svg", `<symbol id="${n}"`).replace("svg>", "symbol>");
});
n1.join(`
`);
const ar = /* @__PURE__ */ Object.assign({
  "/assets/icons/2horpanel.svg": fi,
  "/assets/icons/2vertpanel.svg": pi,
  "/assets/icons/3panel.svg": vi,
  "/assets/icons/4panel.svg": hi,
  "/assets/icons/5panel.svg": gi,
  "/assets/icons/6panel.svg": mi,
  "/assets/icons/6panelVertical.svg": yi,
  "/assets/icons/changeBckgd.svg": bi,
  "/assets/icons/close-no-bk.svg": wi,
  "/assets/icons/close.svg": xi,
  "/assets/icons/closeFullScreen.svg": Fi,
  "/assets/icons/comment.svg": Ci,
  "/assets/icons/connection.svg": Si,
  "/assets/icons/dock.svg": Oi,
  "/assets/icons/drawLine.svg": Ti,
  "/assets/icons/drawPoint.svg": Ei,
  "/assets/icons/drawPolygon.svg": ki,
  "/assets/icons/drawTrash.svg": _i,
  "/assets/icons/fitWindow.svg": $i,
  "/assets/icons/fullScreen.svg": Ii,
  "/assets/icons/help.svg": Ai,
  "/assets/icons/magnifyingGlass.svg": Pi,
  "/assets/icons/noun-filter.svg": Li,
  "/assets/icons/openMap.svg": Mi,
  "/assets/icons/pause.svg": Ri,
  "/assets/icons/permalink.svg": Ni,
  "/assets/icons/play.svg": Bi,
  "/assets/icons/resetZoom.svg": zi,
  "/assets/icons/singlepanel.svg": Di,
  "/assets/icons/tooltips.svg": Hi,
  "/assets/icons/undock.svg": Vi,
  "/assets/icons/zoomIn.svg": ji,
  "/assets/icons/zoomOut.svg": Ui
}), o1 = Object.keys(ar).map((e) => {
  const t = Ki(ar[e]), n = e.replace(/^.+\/(\w+).svg$/, "$1");
  return Gi(t).replace("<svg", `<symbol id="${n}"`).replace("svg>", "symbol>");
}), r1 = {
  name: "MapSvgSpriteColor",
  svgContext: ar,
  svgSprite: o1.join(`
`)
  // concatenate all symbols into $options.svgSprite
}, a1 = ["innerHTML"];
function s1(e, t, n, o, r, a) {
  return F(), P("svg", {
    width: "0",
    height: "0",
    style: { display: "none" },
    innerHTML: e.$options.svgSprite
  }, null, 8, a1);
}
const i1 = /* @__PURE__ */ di(r1, [["render", s1]]), xo = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, l1 = {
  name: "PlotControls",
  components: {
    MapSvgSpriteColor: i1,
    MapSvgIcon: Xg,
    ElSelect: ln,
    ElOption: un,
    ElCollapse: ii,
    ElCollapseItem: li,
    ElButton: Pn,
    ElPopover: Mr
  },
  props: {
    parentElement: {
      type: Object,
      required: !0
    },
    controlsEnabled: {
      type: Boolean,
      required: !0
    }
  },
  data: function() {
    return {
      hoverVisibilities: [{ value: !1 }, { value: !1 }, { value: !1 }, { value: !1 }, { value: !1 }],
      zoomSelect: [
        {
          value: "1",
          label: "100%"
        }
      ],
      selectZoom: "100%",
      zoom: 100,
      maxZoom: 800,
      zoomInDisabled: !1,
      zoomOutDisabled: !0
    };
  },
  methods: {
    // zoomIn: Find and click the plotly modebar 'zoom in'
    zoomIn: function() {
      this.zoom += 100, this.parentElement.element.querySelector('a[data-attr="zoom"][data-val="in"]').click(), this.setDisabledButtons(this.zoom), this.updateZoomSelect(this.zoom);
    },
    // zoomOut: Find and click the plotly modebar 'zoom out'
    zoomOut: function() {
      this.zoom -= 100, this.parentElement.element.querySelector('a[data-attr="zoom"][data-val="out"]').click(), this.setDisabledButtons(this.zoom), this.updateZoomSelect(this.zoom);
    },
    // setDisabledButtons(zoomLevel): Disable buttons once they hit max zoom
    setDisabledButtons(e) {
      e >= this.maxZoom ? this.zoomInDisabled = !0 : this.zoomInDisabled = !1, e <= 0 ? this.zoomOutDisabled = !0 : this.zoomOutDisabled = !1;
    },
    resetView: function() {
      this.zoom = 100, this.parentElement.element.querySelector('a[data-attr="zoom"][data-val="reset"]').click(), this.setDisabledButtons(this.zoom), this.updateZoomSelect(this.zoom);
    },
    percentToNum(e) {
      return Number(e.slice(0, -1));
    },
    selectZoomChange: function(e) {
      if (e === "100%") {
        this.resetView();
        return;
      }
      let t = this.percentToNum(e), n = Math.round((t - this.zoom) / 100);
      for (let o = 0; o < Math.abs(n); o++)
        n > 0 ? this.zoomIn() : this.zoomOut();
      this.updateZoomSelect(t);
    },
    updateZoomSelect(e) {
      this.selectZoom = String(e) + "%";
    },
    createZoomPercentages: function() {
      this.zoomSelect = [];
      for (let e = 0; e <= this.maxZoom / 100; e++)
        this.zoomSelect.push({
          value: e,
          label: (e + 1) * 100 + "%"
        });
    },
    setHelpMode: function(e) {
      e ? (this.inHelp = !0, this.hoverVisibilities.forEach((t) => {
        t.value = !0;
      })) : (this.inHelp = !1, this.hoverVisibilities.forEach((t) => {
        t.value = !1;
      }));
    },
    showToolitip: function(e) {
      this.inHelp || (this.hoverVisibilities[e].value = !0, this.tooltipWait = setTimeout(() => {
        this.hoverVisibilities[e].value = !0;
      }, 1e3));
    },
    hideToolitip: function(e) {
      this.inHelp || (this.hoverVisibilities[e].value = !1, clearInterval(this.tooltipWait));
    },
    handleWheel: function(e) {
      let t = Math.round(e.deltaY / 7);
      this.zoom = this.zoom - t, this.updateZoomSelect(this.zoom);
    }
  },
  mounted: function() {
    this.createZoomPercentages(), setTimeout(() => {
      var e;
      (e = this.parentElement) != null && e.element && this.parentElement.element.addEventListener("wheel", this.handleWheel);
    }, 1e3);
  },
  beforeUnmount: function() {
    var e;
    (e = this.parentElement) != null && e.element && this.parentElement.element.removeEventListener("wheel", this.handleWheel);
  }
}, u1 = { class: "controls-container" };
function c1(e, t, n, o, r, a) {
  const s = qe("map-svg-sprite-color"), i = qe("map-svg-icon"), u = Mr, l = un, d = ln;
  return F(), P("div", u1, [
    U(s),
    B("div", {
      ref: "zoomControls",
      class: $([{ inactive: !n.controlsEnabled }, "bottom-right-control"])
    }, [
      U(u, {
        modelValue: e.hoverVisibilities[0].value,
        "onUpdate:modelValue": t[3] || (t[3] = (c) => e.hoverVisibilities[0].value = c),
        content: "Zoom in",
        placement: "left",
        teleported: !1,
        trigger: "manual",
        "popper-class": "plot-popper"
      }, {
        reference: R(() => [
          U(i, {
            icon: "zoomIn",
            class: "icon-button zoomIn",
            onClick: t[0] || (t[0] = (c) => a.zoomIn()),
            onMouseover: t[1] || (t[1] = (c) => a.showToolitip(0)),
            onMouseout: t[2] || (t[2] = (c) => a.hideToolitip(0))
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      U(u, {
        modelValue: e.hoverVisibilities[1].value,
        "onUpdate:modelValue": t[7] || (t[7] = (c) => e.hoverVisibilities[1].value = c),
        content: "Zoom out",
        placement: "top-end",
        teleported: !1,
        trigger: "manual",
        "popper-class": "plot-popper popper-zoomout"
      }, {
        reference: R(() => [
          U(i, {
            icon: "zoomOut",
            class: "icon-button zoomOut",
            onClick: t[4] || (t[4] = (c) => a.zoomOut()),
            onMouseover: t[5] || (t[5] = (c) => a.showToolitip(1)),
            onMouseout: t[6] || (t[6] = (c) => a.hideToolitip(1))
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      U(d, {
        size: "small",
        modelValue: e.selectZoom,
        "onUpdate:modelValue": t[8] || (t[8] = (c) => e.selectZoom = c),
        placeholder: "100%",
        class: "zoomSelect",
        onChange: a.selectZoomChange
      }, {
        default: R(() => [
          (F(!0), P(ot, null, Zt(e.zoomSelect, (c) => (F(), j(l, {
            key: c.value,
            label: c.label,
            value: c.label
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      U(u, {
        modelValue: e.hoverVisibilities[2].value,
        "onUpdate:modelValue": t[12] || (t[12] = (c) => e.hoverVisibilities[2].value = c),
        content: "Reset",
        placement: "top",
        teleported: !1,
        trigger: "manual",
        "popper-class": "plot-popper"
      }, {
        reference: R(() => [
          U(i, {
            icon: "resetZoom",
            class: "icon-button resetView",
            onClick: t[9] || (t[9] = (c) => a.resetView()),
            onMouseover: t[10] || (t[10] = (c) => a.showToolitip(2)),
            onMouseout: t[11] || (t[11] = (c) => a.hideToolitip(2))
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2)
  ]);
}
const d1 = /* @__PURE__ */ xo(l1, [["render", c1], ["__scopeId", "data-v-e57dc44b"]]), Wi = {
  components: { PlotControls: d1 },
  props: {
    metadata: {
      type: Object,
      required: !0
    },
    sourceData: {
      type: Object,
      required: !0
    },
    plotLayout: {
      type: Object,
      required: !0
    },
    supplementalData: {
      type: Array,
      required: !0
    },
    version: {
      type: String,
      required: !0
    },
    selectorUi: {
      type: Boolean,
      default: !0
    }
  },
  data: function() {
    return {
      layout: {
        paper_bgcolor: "rgba(0,0,0,0)",
        plot_bgcolor: "rgba(0,0,0,0)",
        autosize: !0,
        margin: {
          t: 25,
          l: 55,
          r: 55,
          b: 90,
          pad: 4
        }
      },
      loading: !1,
      options: {
        responsive: !0,
        scrollZoom: !0
      }
    };
  },
  computed: {
    title() {
      return this.sourceData.url.split("\\").pop().split("/").pop().split(".")[0];
    }
  }
}, f1 = {
  name: "TimeseriesPlot",
  components: { ElSelect: ln, ElButton: Pn, ElOption: un },
  mixins: [Wi],
  data: function() {
    return {
      dataValues: Ye([]),
      filterX: [],
      parsedData: null,
      time: Ye([]),
      traceData: null,
      traceNames: [],
      xAxisLabel: "time",
      resizeObserver: null
    };
  },
  computed: {
    fullMetadata() {
      let e = JSON.parse(JSON.stringify(this.metadata));
      return e["y-axes-columns"] || (e["y-axes-columns"] = []), e["x-axis-column"] || (e["x-axis-column"] = 0), e["no-header"] || (e["no-header"] = !1), e["row-major"] || (e["row-major"] = !1), e;
    }
  },
  watch: {
    sourceData: function() {
      this.loadData(this.sourceData);
    }
  },
  mounted: function() {
    this.loadData(this.sourceData), this.resizeObserver = new ResizeObserver(() => {
      this.$refs.plotlyplot && Et.Plots.resize(this.$refs.plotlyplot);
    }), this.resizeObserver.observe(this.$refs.plotContainer);
  },
  beforeUnmount: function() {
    this.resizeObserver && this.resizeObserver.disconnect();
  },
  methods: {
    loadData(e) {
      if (e.url)
        this.loading = !0, or.loadFile(e.url, this.dataReady);
      else {
        const t = this.plotLayout ? this.plotLayout : this.layout;
        Et.react(this.$refs.plotlyplot, this.sourceData.data, t, this.options);
      }
    },
    dataReady(e) {
      const t = Date.now();
      this.fullMetadata["no-header"] && or.loadFile(this.supplementalData[0].url, this.headerDataReady), this.loading = !1, this.parsedData = Ye(e), this.findYaxesCols(), this.populateTime(), this.populateDataValues(), this.fullMetadata["no-header"] || (this.populateXaxisLabel(), this.populateTraceNames()), this.createPlot(this.time, this.xAxisLabel, this.dataValues, this.traceNames), console.log(Date.now() - t);
    },
    headerDataReady(e) {
      this.traceData = Ye(e), this.populateXaxisLabel(), this.populateTraceNames(), this.loading || this.createPlot(this.time, this.xAxisLabel, this.dataValues, this.traceNames);
    },
    filterPlot() {
      let e = this.filterX;
      if (e.length === 0) {
        this.createPlot(this.time, this.xAxisLabel, this.dataValues, this.traceNames);
        return;
      }
      let t = [];
      for (let r of e)
        t.push(this.fullMetadata["y-axes-columns"][this.traceNames.indexOf(r)]);
      let n = this.parsedData.data;
      this.fullMetadata["no-header"] || (n = n.slice(1));
      let o = [];
      for (let r of t) {
        const a = n.map((s) => s[r]);
        o.push(a);
      }
      this.createPlot(this.time, this.xAxisLabel, o, e);
    },
    createPlot(e, t, n, o) {
      let r = [];
      for (let u = 0; u < n.length; u++)
        r.push({
          type: "scatter",
          mode: "lines",
          name: o[u],
          x: e,
          y: n[u]
        });
      let a = this.plotLayout ? this.plotLayout : this.layout, s = { title: { text: this.title }, xaxis: { title: { text: t } } }, i = { ...sr(a), ...s };
      Et.react(this.$refs.plotlyplot, r, i, this.options);
    },
    findYaxesCols() {
      if (this.fullMetadata["y-axes-columns"].length === 0) {
        let e = Array(this.parsedData.data[0].length).keys();
        e.shift(), e.shift(), this.fullMetadata["y-axes-columns"] = e;
      }
    },
    populateXaxisLabel() {
      this.fullMetadata["no-header"] ? this.xAxisLabel = this.traceData.data[0][this.fullMetadata["x-axis-column"]] : this.xAxisLabel = this.parsedData.data[0][this.fullMetadata["x-axis-column"]];
    },
    populateTraceNames() {
      if (this.fullMetadata["no-header"]) {
        this.traceNames.splice(0, this.traceNames.length);
        for (let e of this.fullMetadata["y-axes-columns"])
          this.traceNames.push(this.traceData.data[0][e]);
        this.$set(this.traceNames, 0, this.traceNames[0]);
      } else {
        this.traceNames = [];
        for (let e of this.fullMetadata["y-axes-columns"])
          this.traceNames.push(this.parsedData.data[0][e]);
      }
    },
    populateTime() {
      const e = this;
      let t = this.parsedData.data;
      this.fullMetadata["no-header"] || (t = t.slice(1)), this.time = Ye(t.map(function(n) {
        return n[e.fullMetadata["x-axis-column"]];
      }));
    },
    populateDataValues() {
      let e = this.parsedData.data;
      this.fullMetadata["no-header"] || (e = e.slice(1));
      let t = [];
      for (let n of this.fullMetadata["y-axes-columns"]) {
        const o = e.map((r) => r[n]);
        t.push(o);
      }
      this.dataValues = Ye(t);
    }
  }
}, p1 = {
  ref: "plotContainer",
  class: "container"
}, v1 = {
  ref: "plotlyplot",
  class: "vue-plotly"
};
function h1(e, t, n, o, r, a) {
  const s = un, i = ln, u = Pn;
  return F(), P("div", p1, [
    B("div", v1, null, 512),
    e.selectorUi ? (F(), P("div", {
      key: 0,
      class: $(["chooser-container", { inactive: e.loading }])
    }, [
      B("span", null, [
        U(i, {
          ref: "selectBox",
          modelValue: e.filterX,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.filterX = l),
          class: "channel-select",
          size: "large",
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          "default-first-option": "",
          teleported: !1,
          placeholder: "select"
        }, {
          default: R(() => [
            (F(!0), P(ot, null, Zt(e.traceNames, (l) => (F(), j(s, {
              key: l,
              label: l,
              value: l
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      B("span", null, [
        U(u, {
          class: "view-heatmap-button",
          onClick: a.filterPlot
        }, {
          default: R(() => [...t[1] || (t[1] = [
            It("Filter plot", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ])
    ], 2)) : G("", !0)
  ], 512);
}
const g1 = /* @__PURE__ */ xo(f1, [["render", h1], ["__scopeId", "data-v-a4420d4d"]]), m1 = {
  name: "HeatmapPlot",
  components: {
    ElSelect: ln,
    ElOption: un,
    ElCollapse: ii,
    ElCollapseItem: li,
    ElButton: Pn,
    ElPopover: Mr
  },
  mixins: [Wi],
  data: function() {
    return {
      columnHeaders: [],
      rowHeaders: [],
      dataValues: Ye([]),
      filterX: [],
      filterY: [],
      loading: !1,
      logScale: !1,
      logDataValues: Ye([]),
      resizeObserver: null
    };
  },
  computed: {
    fullMetadata() {
      let e = JSON.parse(JSON.stringify(this.metadata));
      return e.columnHeaderSize || (e.columnHeaderSize = 1), e.columnHeaderIndex || (e.columnHeaderIndex = 0), e.rowHeaderSize || (e.rowHeaderSize = 1), e.rowHeaderIndex || (e.rowHeaderIndex = 0), e;
    },
    logScaleEnabled() {
      return !!JSON.parse(JSON.stringify(this.metadata)).logScale;
    },
    plotTitle() {
      return this.logScale ? this.title + " (Log scale)" : this.title;
    }
  },
  watch: {
    sourceData: function() {
      this.loadData(this.sourceData);
    }
  },
  mounted: function() {
    this.loadData(this.sourceData), this.resizeObserver = new ResizeObserver(() => {
      this.$refs.plotlyplot && Et.Plots.resize(this.$refs.plotlyplot);
    }), this.resizeObserver.observe(this.$refs.plotContainer);
  },
  beforeUnmount: function() {
    this.resizeObserver && this.resizeObserver.disconnect();
  },
  methods: {
    loadData(e) {
      if (e.url)
        this.loading = !0, or.loadFile(e.url, this.dataReady);
      else {
        const t = this.sourceData.layout ? this.sourceData.layout : this.layout;
        Et.react(this.$refs.plotlyplot, this.sourceData.data, t, this.options);
      }
    },
    dataReady(e) {
      this.loading = !1;
      const t = e;
      this.populateColumnHeaders(t), this.populateRowHeaders(t), this.populateDataValues(t), this.logScaleEnabled ? (this.logValues(), this.logScale = !0, this.createPlot(this.columnHeaders, this.rowHeaders, this.logDataValues, "heatmap")) : this.createPlot(this.columnHeaders, this.rowHeaders, this.dataValues, "heatmap");
    },
    logValues() {
      this.dataValues.forEach((e, t) => {
        this.logDataValues.push([]), e.forEach((n) => {
          this.logDataValues[t].push(Math.log10(n));
        });
      });
    },
    logToggle() {
      this.logScale ? (this.logScale = !1, this.createPlot(this.columnHeaders, this.rowHeaders, this.dataValues, "heatmap")) : (this.logScale = !0, this.createPlot(this.columnHeaders, this.rowHeaders, this.logDataValues, "heatmap"));
    },
    filterPlot() {
      let e = this.filterX, t = this.filterY;
      if (e.length === 0 && t.length === 0) {
        this.createPlot(this.columnHeaders, this.rowHeaders, this.dataValues, "heatmap");
        return;
      }
      e.length === 0 && (e = this.columnHeaders), t.length === 0 && (t = this.rowHeaders);
      let n = [];
      for (let a of e)
        n.push(this.columnHeaders.indexOf(a));
      let o = [];
      for (let a of t)
        o.push(this.rowHeaders.indexOf(a));
      let r = [];
      for (let a of n) {
        const s = this.dataValues.map((u) => u[a]);
        let i = [];
        for (let u of o)
          i.push(s[u]);
        r.push(i);
      }
      r = r[0].map((a, s) => r.map((i) => i[s])), this.createPlot(e, t, r, "heatmap");
    },
    createPlot(e, t, n, o) {
      var r = [
        {
          x: e,
          y: t,
          z: n,
          type: o
        }
      ];
      const a = { title: { text: this.plotTitle } }, s = { ...this.layout, ...a, ...this.plotLayout };
      Et.react(this.$refs.plotlyplot, r, s, this.options);
    },
    populateColumnHeaders(e) {
      let n = [...e.data[this.fullMetadata.columnHeaderIndex]];
      this.columnHeaders = n.slice(this.fullMetadata.rowHeaderSize);
    },
    populateRowHeaders(e) {
      const n = e.data.map((o) => o[this.fullMetadata.rowHeaderIndex]);
      this.rowHeaders = n.slice(this.fullMetadata.columnHeaderSize);
    },
    populateDataValues(e) {
      const n = e.data.slice(this.fullMetadata.columnHeaderSize);
      this.dataValues = Ye(n.map((o) => o.slice(this.fullMetadata.rowHeaderSize)));
    }
  }
}, y1 = {
  ref: "plotContainer",
  class: "container"
}, b1 = {
  ref: "plotlyplot",
  class: "vue-plotly"
}, w1 = { key: 0 };
function x1(e, t, n, o, r, a) {
  const s = un, i = ln, u = Pn;
  return F(), P("div", y1, [
    B("div", b1, null, 512),
    e.selectorUi ? (F(), P("div", {
      key: 0,
      class: $(["chooser-container", { inactive: e.loading }])
    }, [
      B("span", null, [
        U(i, {
          modelValue: e.filterX,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.filterX = l),
          class: "channel-select",
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          "default-first-option": "",
          placeholder: "select"
        }, {
          default: R(() => [
            (F(!0), P(ot, null, Zt(e.columnHeaders, (l) => (F(), j(s, {
              key: l,
              label: l,
              value: l
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      B("span", null, [
        U(i, {
          modelValue: e.filterY,
          "onUpdate:modelValue": t[1] || (t[1] = (l) => e.filterY = l),
          class: "channel-select",
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          "default-first-option": "",
          placeholder: "select"
        }, {
          default: R(() => [
            (F(!0), P(ot, null, Zt(e.rowHeaders, (l) => (F(), j(s, {
              key: l,
              label: l,
              value: l
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      B("span", null, [
        U(u, {
          class: "view-heatmap-button",
          onClick: a.filterPlot
        }, {
          default: R(() => [...t[2] || (t[2] = [
            It("Filter plot", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]),
      a.logScaleEnabled ? (F(), P("span", w1, [
        U(u, {
          class: "view-heatmap-button",
          onClick: a.logToggle
        }, {
          default: R(() => [...t[3] || (t[3] = [
            It("Toggle log", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ])) : G("", !0)
    ], 2)) : G("", !0)
  ], 512);
}
const F1 = /* @__PURE__ */ xo(m1, [["render", x1], ["__scopeId", "data-v-80f8a3a7"]]), C1 = ["1.2.0", "1.1.0"], S1 = {
  name: "PlotVuer",
  components: {
    TimeseriesPlot: g1,
    HeatmapPlot: F1
  },
  props: {
    /**
     * The object with `url` property
     * where the `url` is the source url to load the data.
     */
    dataSource: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    /**
     * The metadata object
     * with `version`, `type`, and `attrs` properties.
     */
    metadata: {
      type: Object,
      required: !0,
      validator: function(e) {
        return C1.includes(e.version) && e.type === "plot";
      }
    },
    /**
     * The plotLayout for UI.
     */
    plotLayout: {
      type: Object,
      /**
       * `{
       * paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)',
          autosize: true,
          margin: {
            t: 25,
            l: 55,
            r: 55,
            b: 90,
            pad: 4
          },
          loading: false,
          options: {
            responsive: true,
            scrollZoom: true
          }
       * }`
       */
      default: () => ({
        paper_bgcolor: "rgba(0,0,0,0)",
        plot_bgcolor: "rgba(0,0,0,0)",
        autosize: !0,
        margin: {
          t: 25,
          l: 55,
          r: 55,
          b: 90,
          pad: 4
        },
        loading: !1,
        options: {
          responsive: !0,
          scrollZoom: !0
        }
      })
    },
    /**
     * The supplemental data to load.
     */
    supplementalData: {
      type: Array,
      default: () => []
    },
    /**
     * The option to choose helpMode.
     */
    helpMode: {
      type: Boolean,
      default: !1
    },
    /**
     * The option to show the selector UI.
     */
    selectorUi: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    plotType: function() {
      return this.metadata.attrs.style + "-plot";
    },
    layout: function() {
      return this.metadata ? this.metadata.attrs ? this.metadata.attrs.layout ? this.metadata.attrs.layout : this.plotLayout : this.plotLayout : this.plotLayout;
    }
  }
}, O1 = { class: "plotvuer_parent" };
function T1(e, t, n, o, r, a) {
  return F(), P("div", O1, [
    a.plotType != "-plot" ? (F(), j(tt(a.plotType), {
      key: 0,
      sourceData: n.dataSource,
      plotLayout: a.layout,
      version: n.metadata.version,
      metadata: n.metadata.attrs,
      selectorUi: n.selectorUi,
      supplementalData: n.supplementalData
    }, null, 8, ["sourceData", "plotLayout", "version", "metadata", "selectorUi", "supplementalData"])) : G("", !0)
  ]);
}
const P1 = /* @__PURE__ */ xo(S1, [["render", T1], ["__scopeId", "data-v-8b1253cb"]]);
export {
  P1 as PlotVuer
};
